'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var classNames = require('classnames');
var React = require('react');
var reactFontawesome = require('@fortawesome/react-fontawesome');
var freeSolidSvgIcons = require('@fortawesome/free-solid-svg-icons');
var freeRegularSvgIcons = require('@fortawesome/free-regular-svg-icons');
var freeBrandsSvgIcons = require('@fortawesome/free-brands-svg-icons');
var PerfectScrollbar = require('react-perfect-scrollbar');
var reactDraggable = require('react-draggable');
var Lottie = require('lottie-react');
var Flickity = require('react-flickity-component');
var DOMPurify = require('dompurify');
var apStyleTitleCase = require('ap-style-title-case');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n["default"] = e;
    return Object.freeze(n);
}

var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var PerfectScrollbar__default = /*#__PURE__*/_interopDefaultLegacy(PerfectScrollbar);
var Lottie__default = /*#__PURE__*/_interopDefaultLegacy(Lottie);
var Flickity__default = /*#__PURE__*/_interopDefaultLegacy(Flickity);
var DOMPurify__default = /*#__PURE__*/_interopDefaultLegacy(DOMPurify);

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var getStringFromAlt = function (altStr) {
    if (!altStr)
        return '';
    var array = altStr.split(' ');
    if (array.length > 1) {
        return "".concat(array[0].substr(0, 1) + array[1].substr(0, 1)).toUpperCase();
    }
    return array.length ? "".concat(array[0].substr(0, 1)).toUpperCase() : '';
};
var Avatar = function (_a) {
    var size = _a.size, src = _a.src, alt = _a.alt, className = _a.className, studentId = _a.studentId, props = __rest(_a, ["size", "src", "alt", "className", "studentId"]);
    var _b = React.useState(true), usePrimaryImage = _b[0], setUsePrimaryImage = _b[1];
    var _c = React.useState(true), useBackupImage = _c[0], setUseBackupImage = _c[1];
    function onPrimaryError() {
        setUsePrimaryImage(false);
        setUseBackupImage(true);
    }
    function onBackupError() {
        setUseBackupImage(false);
    }
    function getBackUpImage(studentId) {
        var id = typeof studentId == 'number' ? studentId + '' : studentId;
        var chars = id.split('');
        var lastChar = chars[chars.length - 1];
        return ('https://storage.googleapis.com/geniebook-cdn/assets/images/profile/random_' +
            lastChar +
            '.svg');
    }
    React.useEffect(function () {
        // to retry using primary image again
        setUsePrimaryImage(true);
    }, [src]);
    return src && usePrimaryImage ? (React__default["default"].createElement("img", __assign({ src: src, onError: onPrimaryError, alt: alt, className: classNames__default["default"]('rounded-full bg-gray-300 flex justify-center items-center', className), style: { width: size, height: size } }, props))) : studentId && useBackupImage ? (React__default["default"].createElement("img", __assign({ src: getBackUpImage(studentId), onError: onBackupError, alt: alt, className: classNames__default["default"]('rounded-full bg-neutral-whiteboard flex justify-center items-center', className), style: { width: size, height: size } }, props))) : (React__default["default"].createElement("div", __assign({ className: classNames__default["default"]('rounded-full bg-gray-300 flex justify-center items-center p-4', className), style: { width: size, height: size } }, props), getStringFromAlt(alt)));
};
Avatar.defaultProps = {
    size: 24,
};

var SIZE_CLASSNAMES = {
    xs: 'text-xs',
    sm: 'text-sm',
    md: 'text-md',
    xl: 'text-xl',
    '2xl': 'text-2xl',
};
var CLASSNAMES = {
    basic: {
        base: 'flex rounded items-center justify-center bg-primary-600 text-white',
    },
    outline: {
        base: 'flex rounded items-center justify-center border border-primary-600 text-primary-600',
    },
    'no-border': {
        base: 'flex rounded items-center justify-center text-primary-600',
    },
};
var Badge = function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? 'basic' : _b, children = _a.children, className = _a.className, _c = _a.size, size = _c === void 0 ? 'md' : _c, props = __rest(_a, ["variant", "children", "className", "size"]);
    var badgeClassName = React.useMemo(function () {
        var _a;
        var _b, _c;
        var classes = (_b = CLASSNAMES[variant]) !== null && _b !== void 0 ? _b : CLASSNAMES.basic;
        var sizeClasses = (_c = SIZE_CLASSNAMES[size]) !== null && _c !== void 0 ? _c : SIZE_CLASSNAMES.md;
        return classNames__default["default"]((_a = {},
            _a[classes.base] = true,
            _a[sizeClasses] = true,
            _a[className !== null && className !== void 0 ? className : ''] = true,
            _a));
    }, [variant, size, className]);
    return (React__default["default"].createElement("div", __assign({ className: badgeClassName }, props), children));
};
Badge.defaultProps = {
    className: 'px-2 py-1',
    color: 'primary',
    variant: 'basic',
};

var icons = {
    // format: '<passed params>':'<Fontawesome icon name>'
    'arrow-down': freeSolidSvgIcons.faArrowDown,
    'arrow-left': freeSolidSvgIcons.faArrowLeft,
    'arrow-pointer': freeSolidSvgIcons.faArrowPointer,
    'arrow-right': freeSolidSvgIcons.faArrowRight,
    'arrow-right-from-bracket': freeSolidSvgIcons.faArrowRightFromBracket,
    'arrow-up': freeSolidSvgIcons.faArrowUp,
    bell: freeSolidSvgIcons.faBell,
    calendar: freeSolidSvgIcons.faCalendar,
    'caret-down': freeSolidSvgIcons.faCaretDown,
    'caret-left': freeSolidSvgIcons.faCaretLeft,
    'caret-right': freeSolidSvgIcons.faCaretRight,
    'caret-up': freeSolidSvgIcons.faCaretUp,
    certificate: freeSolidSvgIcons.faCertificate,
    'chalkboard-teacher': freeSolidSvgIcons.faChalkboardTeacher,
    check: freeSolidSvgIcons.faCheck,
    'chevron-up': freeSolidSvgIcons.faChevronUp,
    'chevron-down': freeSolidSvgIcons.faChevronDown,
    'circle-check': freeSolidSvgIcons.faCircleCheck,
    'circle-dot': freeSolidSvgIcons.faCircleDot,
    'circle-play': freeSolidSvgIcons.faCirclePlay,
    'circle-xmark': freeSolidSvgIcons.faCircleXmark,
    clock: freeSolidSvgIcons.faClock,
    code: freeSolidSvgIcons.faCode,
    envelope: freeSolidSvgIcons.faEnvelope,
    eraser: freeSolidSvgIcons.faEraser,
    'exclamation-triangle': freeSolidSvgIcons.faTriangleExclamation,
    link: freeSolidSvgIcons.faLink,
    list: freeSolidSvgIcons.faList,
    medal: freeSolidSvgIcons.faMedal,
    minus: freeSolidSvgIcons.faMinus,
    paperclip: freeSolidSvgIcons.faPaperclip,
    plus: freeSolidSvgIcons.faPlus,
    question: freeSolidSvgIcons.faQuestion,
    'regular-bell': freeRegularSvgIcons.faBell,
    'regular-calendar': freeRegularSvgIcons.faCalendar,
    repeat: freeSolidSvgIcons.faRepeat,
    'right-from-bracket': freeSolidSvgIcons.faRightFromBracket,
    rocket: freeSolidSvgIcons.faRocket,
    'rotate-right': freeSolidSvgIcons.faRotateRight,
    'screwdriver-wrench': freeSolidSvgIcons.faScrewdriverWrench,
    'sort-ascending': freeSolidSvgIcons.faArrowUpWideShort,
    'sort-descending': freeSolidSvgIcons.faArrowDownShortWide,
    'square-check': freeSolidSvgIcons.faSquareCheck,
    trash: freeSolidSvgIcons.faTrash,
    users: freeSolidSvgIcons.faUsers,
    whatsapp: freeBrandsSvgIcons.faWhatsapp,
    xmark: freeSolidSvgIcons.faXmark,
};
// export type IconTransform = 'flip-v' | 'flip-h' | 'none'

var Icon = function (_a) {
    var id = _a.id, _b = _a.name, name = _b === void 0 ? 'right-from-bracket' : _b, 
    /* style = 'solid',
    family = 'classic', */
    _c = _a.className, 
    /* style = 'solid',
    family = 'classic', */
    className = _c === void 0 ? '' : _c, _d = _a.transform, transform = _d === void 0 ? 'none' : _d, size = _a.size, // is 1em (16px)
    _e = _a.fallback, // is 1em (16px)
    fallback = _e === void 0 ? undefined : _e, onClick = _a.onClick;
    if (!name) {
        throw new Error("Can't call Icon component without name props");
    }
    return (React__default["default"].createElement(React__default["default"].Suspense, { fallback: fallback !== null && fallback !== void 0 ? fallback : (React__default["default"].createElement("div", { className: "".concat(className !== null && className !== void 0 ? className : '', " cursor-pointer"), style: { height: '16px', width: '16px', display: 'inline' } })) },
        React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, __assign({ id: id, onClick: onClick, icon: icons[name], className: "".concat(className, " cursor-pointer fill-current") }, (size ? { size: size } : {}), (transform !== 'none' ? { transform: transform } : {})))));
};

var Container = function (props) {
    var _a, _b;
    return (React__default["default"].createElement("div", { className: 'mx-auto w-full 2xl:max-w-[1200px] max-md:px-4 max-lg:md:px-16 max-xl:lg:px-[76px] max-2xl:xl:px-[139px] 2xl:px-0 ' + ((_a = props.className) !== null && _a !== void 0 ? _a : ''), style: (_b = props.style) !== null && _b !== void 0 ? _b : {} }, props.children));
};

var baseButtonClassname = "btn flex items-center justify-center";
var ButtonVariantClassNames = {
    primary: {
        base: "".concat(baseButtonClassname, " font-bold btn-primary"),
        disabled: 'btn-disabled',
        default: '',
    },
    secondary: {
        base: "".concat(baseButtonClassname, " font-black btn-secondary px-8 text-primary-apricot hover:text-primary-skyblue-shade"),
        disabled: 'btn-disabled',
        default: '',
    },
    icon: {
        base: "".concat(baseButtonClassname, " btn-icon"),
        disabled: '',
        default: '',
    },
    'primary-navyblue': {
        base: "".concat(baseButtonClassname, " font-bold btn-primary-navyblue"),
        disabled: 'btn-disabled',
        default: '',
    },
    'primary-azure': {
        base: "".concat(baseButtonClassname, " font-bold btn-primary-azure"),
        disabled: 'btn-disabled',
        default: '',
    },
    'primary-violet': {
        base: "".concat(baseButtonClassname, " font-bold btn-primary-violet"),
        disabled: 'btn-disabled',
        default: '',
    },
    'tertiary-raspberry': {
        base: "".concat(baseButtonClassname, " font-bold btn-tertiary-raspberry"),
        disabled: 'btn-disabled',
        default: '',
    },
    // success: {
    //   base: `${baseButtonClassname} bg-success-600 text-white focus:ring-2 focus:ring-offset-1 focus:ring-success-300`,
    //   disabled: 'opacity-30 cursor-not-allowed',
    //   default: 'hover:shadow hover:bg-success-700',
    // },
    // error: {
    //   base: `${baseButtonClassname} bg-error-600 text-white focus:ring-2 focus:ring-offset-1 focus:ring-error-300`,
    //   disabled: 'opacity-30 cursor-not-allowed',
    //   default: 'hover:shadow hover:bg-error-700',
    // },
    // warning: {
    //   base: `${baseButtonClassname} bg-warning-500 text-white focus:ring-2 focus:ring-offset-1 focus:ring-warning-200`,
    //   disabled: 'opacity-30 cursor-not-allowed',
    //   default: 'hover:shadow hover:bg-warning-600',
    // },
    // info: {
    //   base: `${baseButtonClassname} bg-info-600 text-white focus:ring-2 focus:ring-offset-1 focus:ring-info-300`,
    //   disabled: 'opacity-30 cursor-not-allowed',
    //   default: 'hover:shadow hover:bg-info-700',
    // },
    // transparent: {
    //   base: `${baseButtonClassname} bg-transparent`,
    //   disabled: 'opacity-30 cursor-not-allowed',
    //   default: '',
    // },
    // link: {
    //   base: `${baseButtonClassname} bg-transparent underline font-bold`,
    //   disabled: 'opacity-30 cursor-not-allowed',
    //   default: '',
    // },
    // 'inverted-primary': {
    //   base: `${baseButtonClassname} border-primary-600 border text-primary-600  focus:ring-2 focus:ring-offset-1 focus:ring-primary-300`,
    //   disabled: 'opacity-30 cursor-not-allowed',
    //   default: 'hover:shadow hover:bg-primary-600 hover:text-white',
    // },
    // 'inverted-secondary': {
    //   base: `${baseButtonClassname} bg-foreground text-white border border-foreground focus:ring-2 focus:ring-offset-1 focus:ring-foreground`,
    //   disabled: 'opacity-30 cursor-not-allowed',
    //   default: 'hover:shadow hover:bg-background hover:text-foreground',
    // },
    // 'inverted-success': {
    //   base: `${baseButtonClassname} text-success-600 border border-success-600 focus:ring-2 focus:ring-offset-1 focus:ring-success-300`,
    //   disabled: 'opacity-30 cursor-not-allowed',
    //   default: 'hover:shadow hover:bg-success-600 hover:text-white',
    // },
    // 'inverted-error': {
    //   base: `${baseButtonClassname} text-error-600 border border-error-600 focus:ring-2 focus:ring-offset-1 focus:ring-error-300`,
    //   disabled: 'opacity-30 cursor-not-allowed',
    //   default: 'hover:shadow hover:bg-error-600 hover:text-white',
    // },
    // 'inverted-warning': {
    //   base: `${baseButtonClassname} text-warning-500 border border-warning-500 focus:ring-2 focus:ring-offset-1 focus:ring-warning-200`,
    //   disabled: 'opacity-30 cursor-not-allowed',
    //   default: 'hover:shadow hover:bg-warning-500 hover:text-foreground',
    // },
    // 'inverted-info': {
    //   base: `${baseButtonClassname} text-info-600 border border-info-600 focus:ring-2 focus:ring-offset-1 focus:ring-info-300`,
    //   disabled: 'opacity-30 cursor-not-allowed',
    //   default: 'hover:shadow hover:bg-info-600 hover:text-white',
    // },
};
var ButtonSizeClassNames = {
    xs: 'text-xs',
    sm: 'text-sm',
    md: 'text-md',
    xl: 'text-xl',
    '2xl': 'text-2xl',
};

var fadeIn = function (open) {
    return open ? 'ease-out duration-300 opacity-100' : 'ease-in duration-200 opacity-0';
};
var animations$1 = {
    fadeIn: fadeIn,
};

var makeUUID = function (prefix, length) {
    if (prefix === void 0) { prefix = ''; }
    if (length === void 0) { length = 10; }
    var result = [];
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
        result.push(characters.charAt(Math.floor(Math.random() * charactersLength)));
    }
    return prefix.length > 0 ? "".concat(prefix, "-").concat(result.join('')) : result.join('');
};

var useDebounce = function (value, delay) {
    // State and setters for debounced value
    var _a = React__default["default"].useState(value), debouncedValue = _a[0], setDebouncedValue = _a[1];
    React__default["default"].useEffect(function () {
        // Update debounced value after delay
        var handler = setTimeout(function () {
            setDebouncedValue(value);
        }, delay);
        // Cancel the timeout if value changes (also on delay change or unmount)
        // This is how we prevent debounced value from updating if value is changed ...
        // .. within the delay period. Timeout gets cleared and restarted.
        return function () {
            clearTimeout(handler);
        };
    }, [value, delay] // Only re-call effect if value or delay changes
    );
    return debouncedValue;
};

var Tooltip = function (_a) {
    var render = _a.render, children = _a.children, toolptipId = _a.toolptipId, _b = _a.position, position = _b === void 0 ? 'top' : _b, _c = _a.className, className = _c === void 0 ? '' : _c, _d = _a.tooltipClassName, tooltipClassName = _d === void 0 ? '' : _d;
    var _e = React__default["default"].useState(false), isOpen = _e[0], setIsOpen = _e[1];
    var visible = useDebounce(isOpen, 200);
    var id = React__default["default"].useMemo(function () { return toolptipId !== null && toolptipId !== void 0 ? toolptipId : makeUUID(); }, [toolptipId]);
    var handlerRef = React__default["default"].useRef();
    var handleOpen = function () {
        if (handlerRef.current)
            clearTimeout(handlerRef.current);
        if (!isOpen) {
            setIsOpen(true);
        }
    };
    var handleClose = function () {
        setIsOpen(false);
    };
    var positionClassNames = React__default["default"].useMemo(function () {
        switch (position) {
            case 'right':
                return 'left-full ml-1';
            case 'left':
                return 'right-full mr-1';
            case 'bottom':
                return 'top-full mt-1';
            case 'top':
            default:
                return 'bottom-full mb-1';
        }
    }, [position]);
    return (React__default["default"].createElement("div", { "aria-describedby": id, className: 'relative flex ' + className, onMouseEnter: handleOpen, onMouseLeave: handleClose },
        React__default["default"].createElement("div", { className: "flex" }, children),
        React__default["default"].createElement("div", { className: "tooltip-container ".concat(positionClassNames, " ").concat(animations$1.fadeIn(isOpen), " ").concat(!visible && !isOpen && 'sr-only') },
            React__default["default"].createElement("div", { className: "tooltip-arrow" }),
            React__default["default"].createElement("div", { id: id, role: "tooltip", className: "tooltip ".concat(tooltipClassName !== null && tooltipClassName !== void 0 ? tooltipClassName : '', " text-sm") }, render))));
};

var isTouchDevice = function () {
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
};

var Button = function (_a) {
    var children = _a.children, tabIndex = _a.tabIndex, _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.style, style = _c === void 0 ? {} : _c, _d = _a.variant, variant = _d === void 0 ? 'primary' : _d, _e = _a.textButtonSecondary, textButtonSecondary = _e === void 0 ? false : _e, // on true will set text button label color as white (https://xd.adobe.com/view/c90cef27-e163-4e57-aac0-bb746dffbbbb-9c5f/screen/96aa900e-de36-4ad8-99bb-3148d25ec6db)
    _f = _a.size, // on true will set text button label color as white (https://xd.adobe.com/view/c90cef27-e163-4e57-aac0-bb746dffbbbb-9c5f/screen/96aa900e-de36-4ad8-99bb-3148d25ec6db)
    size = _f === void 0 ? 'md' : _f, icon = _a.icon, iconPosition = _a.iconPosition, _g = _a.iconSize, iconSize = _g === void 0 ? '1x' : _g, disabled = _a.disabled, _h = _a.title, title = _h === void 0 ? '' : _h, _j = _a.iconButtonHover, iconButtonHover = _j === void 0 ? true : _j, _k = _a.iconButtonShadow, iconButtonShadow = _k === void 0 ? true : _k, _l = _a.scaleOnHover, scaleOnHover = _l === void 0 ? true : _l, //! only for `primary` variant for now
    props = __rest(_a, ["children", "tabIndex", "className", "style", "variant", "textButtonSecondary", "size", "icon", "iconPosition", "iconSize", "disabled", "title", "iconButtonHover", "iconButtonShadow", "scaleOnHover"]);
    var _m = React.useState(false), touch = _m[0], setTouch = _m[1];
    var buttonClassNames = React.useMemo(function () {
        var _a;
        var _b, _c;
        var classes = (_b = ButtonVariantClassNames[variant]) !== null && _b !== void 0 ? _b : ButtonVariantClassNames.primary;
        var sizeClasses = (_c = ButtonSizeClassNames[size]) !== null && _c !== void 0 ? _c : ButtonSizeClassNames.md;
        return classNames__default["default"]((_a = {},
            _a[classes.base] = true,
            _a[sizeClasses] = true,
            _a[classes.default] = !disabled,
            _a[classes.disabled] = disabled,
            _a[className !== null && className !== void 0 ? className : ''] = true,
            _a));
    }, [className, variant, size, disabled]);
    React.useEffect(function () {
        setTouch(isTouchDevice());
    }, []);
    if (variant === 'icon')
        iconSize = '1x';
    return (React__default["default"].createElement(React__default["default"].Fragment, null, variant === 'icon' && title !== '' ? (React__default["default"].createElement(Tooltip, { render: title, position: "bottom" },
        React__default["default"].createElement("div", __assign({ className: "".concat(buttonClassNames, " ").concat(iconButtonHover ? 'btn-icon-hover' : '', " ").concat(iconButtonShadow ? 'btn-icon-shadow' : ''), tabIndex: tabIndex }, props),
            React__default["default"].createElement("div", { className: "button_content" }, icon ? React__default["default"].createElement(Icon, { name: icon, size: iconSize }) : children)))) : (React__default["default"].createElement("div", __assign({ className: "".concat(buttonClassNames, " ").concat(iconButtonHover ? 'btn-icon-hover' : '', " ").concat(iconButtonShadow ? 'btn-icon-shadow' : '', " group select-none ").concat(variant === 'primary' && scaleOnHover && !touch
            ? 'hover:scale-110'
            : ''), tabIndex: tabIndex }, props, { style: style }),
        React__default["default"].createElement("div", { className: "button_bg_hover" }),
        React__default["default"].createElement("div", { className: "button_content" }, icon ? (React__default["default"].createElement(React__default["default"].Fragment, null,
            iconPosition !== 'right' ? (React__default["default"].createElement(Icon, { className: variant !== 'icon' ? 'mr-1' : '', name: icon, size: iconSize })) : null,
            variant !== 'icon' &&
                variant === 'secondary' &&
                textButtonSecondary ? (React__default["default"].createElement("span", { className: "text-button-secondary text-neutral-chalk group-hover:text-primary-skyblue-shade" }, children)) : (children),
            iconPosition === 'right' ? (React__default["default"].createElement(Icon, { className: variant !== 'icon' ? 'ml-1' : '', name: icon, size: iconSize })) : null)) : (children))))));
};

var Banner = function (props) {
    var _a;
    var _b = props.ctaType, ctaType = _b === void 0 ? 'text' : _b, _c = props.dismissType, dismissType = _c === void 0 ? 'text' : _c;
    var componentCta = function () {
        var _a;
        if (props.textCta) {
            if (ctaType === 'text') {
                return (React__default["default"].createElement("span", { className: 'text-primary-apricot font-bold underline cursor-pointer mr-6 last:mr-0', onClick: props.onClickCTA }, props.textCta == '' ? 'Read more' : props.textCta));
            }
            else {
                return (React__default["default"].createElement(Button, { variant: "primary", className: "h-8 px-2", scaleOnHover: false, onClick: props.onClickCTA }, (_a = props.textCta) !== null && _a !== void 0 ? _a : 'Read more'));
            }
        }
    };
    var componentDismiss = function () {
        if (props.textDismiss) {
            if (dismissType === 'text') {
                return (React__default["default"].createElement("span", { className: 'text-primary-apricot font-bold cursor-pointer underline', onClick: props.onClickDismiss }, props.textDismiss == '' ? 'Dismiss' : props.textDismiss));
            }
        }
        if (props.dismissType === 'icon') {
            return (React__default["default"].createElement(Icon, { className: "text-primary-apricot cursor-pointer", name: "xmark", onClick: props.onClickDismiss }));
        }
    };
    return (React__default["default"].createElement("div", { className: 'bg-primary-apricot-faded w-full transition-all max-lg:hidden overflow-hidden sticky left-0 right-0 top-0 ' +
            ((_a = props.classname) !== null && _a !== void 0 ? _a : ''), style: { height: props.isVisible ? '64px' : 0 } },
        React__default["default"].createElement(Container, { className: 'py-4' },
            React__default["default"].createElement("div", { className: "flex flex-row items-center" },
                props.icon && typeof props.icon !== 'string' ? (React__default["default"].createElement(React__default["default"].Fragment, null, props.icon)) : (React__default["default"].createElement(Icon, { className: "max-h-6 max-w-6 mr-4", name: props.icon })),
                React__default["default"].createElement("div", { className: "inline-flex flex-row w-[calc(100%-40px)]" },
                    React__default["default"].createElement("div", { className: "flex items-center flex-grow pr-4 truncate" },
                        React__default["default"].createElement("span", { className: "font-bold text-primary-navyblue md:whitespace-nowrap" }, props.title),
                        React__default["default"].createElement("span", { className: "text-neutral-pencil mt-0 ml-1 whitespace-nowrap" }, props.text)),
                    React__default["default"].createElement("div", { className: "flex ".concat(dismissType === 'icon' ? 'gap-6' : 'gap-2', " items-center mt-0 whitespace-nowrap") },
                        componentCta(),
                        componentDismiss()))))));
};

var Card = function (_a) {
    var body = _a.body, _b = _a.header, header = _b === void 0 ? null : _b, _c = _a.footer, footer = _c === void 0 ? null : _c, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.cardInsetShadow, cardInsetShadow = _e === void 0 ? true : _e, _f = _a.cardShadow, cardShadow = _f === void 0 ? true : _f, _g = _a.shadowColor, shadowColor = _g === void 0 ? 'default' : _g, _h = _a.insetColor, insetColor = _h === void 0 ? 'default' : _h;
    var getInsetColor = function () {
        switch (insetColor) {
            case 'none': return '';
            case 'skyblue-dark': return ' card-inset-skyblue-dark-shadow';
            default: return ' card-inset-shadow';
        }
    };
    var getShadowColor = function () {
        switch (shadowColor) {
            case 'none': return '';
            default: return ' default-shadow';
        }
    };
    return (React__default["default"].createElement("div", { className: "card\n        ".concat(className, "\n        ").concat(cardShadow ? '' + getShadowColor() : '', "\n        ").concat(cardInsetShadow ? getInsetColor() : '', "\n      ") },
        header && React__default["default"].createElement("div", { className: "card-header" }, header),
        React__default["default"].createElement("div", { className: "card-body ".concat(header === null || header === '' ? 'pt-4' : '', " ").concat(footer === null || footer === '' ? 'pb-4' : '') }, body),
        footer && React__default["default"].createElement("div", { className: "card-footer" }, footer)));
};

//Variants Mode
var variants$2 = {
    light: {
        container: function (isChecked, isDisabled, isValidation) {
            return "cb-focus ".concat(isValidation ? (isChecked ? '' : 'validation') : '', " flex items-center justify-center appearance-none\n      cb-size relative cb-disabled cb-border ").concat(isDisabled
                ? !isChecked
                    ? 'disabled unchecked'
                    : 'disabled checked'
                : isValidation
                    ? 'cb-validation'
                    : 'enabled focused');
        },
        icon: function (isChecked, isDisabled) {
            return "".concat(isDisabled ? 'cb-icon disabled' : 'cb-icon', " ").concat(isChecked ? '' : 'hidden');
        },
        label: function (isChecked, isDisabled, isValidation) {
            return "cb-label ".concat(isDisabled
                ? 'disabled'
                : isValidation
                    ? isChecked
                        ? 'enabled'
                        : 'validation'
                    : 'enabled');
        },
    },
    dark: {
        container: function (isChecked, isDisabled, isValidation) {
            return "cb-d-focus ".concat(isValidation ? (isChecked ? '' : 'validation') : '', " flex items-center justify-center appearance-none\n      cb-d-size relative cb-d-disabled cb-d-border ").concat(isDisabled
                ? !isChecked
                    ? 'disabled unchecked'
                    : 'disabled checked'
                : isValidation
                    ? 'cb-d-validation'
                    : 'enabled focused');
        },
        icon: function (isChecked, isDisabled) {
            return "".concat(isDisabled ? 'cb-d-icon disabled' : 'cb-d-icon', " ").concat(isChecked ? '' : 'hidden');
        },
        label: function (isChecked, isDisabled, isValidation) {
            return "cb-d-label ".concat(isDisabled
                ? 'disabled'
                : isValidation
                    ? isChecked
                        ? 'enabled'
                        : 'validation'
                    : 'enabled');
        },
    },
};
var Checkbox = React.forwardRef(function (_a, ref) {
    var _b, _c, _d;
    var id = _a.id, label = _a.label, name = _a.name, ariaChecked = _a["aria-checked"], ariaLabel = _a["aria-label"], ariaLabelledBy = _a["aria-labelledby"], value = _a.value, isChecked = _a.isChecked, isValidation = _a.isValidation, defaultChecked = _a.defaultChecked, onChange = _a.onChange, _e = _a.variant, variant = _e === void 0 ? 'light' : _e, _f = _a.disabled, disabled = _f === void 0 ? false : _f;
    var inputRef = React__default["default"].useRef(null);
    React__default["default"].useImperativeHandle(ref, function () { return inputRef.current; });
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement("label", { "aria-checked": ariaChecked, className: "flex items-center" },
            React__default["default"].createElement("div", { className: "".concat((_b = variants$2[variant]) === null || _b === void 0 ? void 0 : _b.container(isChecked, disabled, isValidation)) },
                React__default["default"].createElement(Icon, { name: "square-check", className: "fill-current ".concat((_c = variants$2[variant]) === null || _c === void 0 ? void 0 : _c.icon(isChecked, disabled)) }),
                React__default["default"].createElement("input", { id: id, className: "appearance-none", ref: inputRef, type: "checkbox", name: name, checked: isChecked, defaultChecked: defaultChecked, value: value, "aria-labelledby": ariaLabelledBy, "aria-label": ariaLabel, onChange: onChange, disabled: disabled })),
            React__default["default"].createElement("span", { className: "".concat((_d = variants$2[variant]) === null || _d === void 0 ? void 0 : _d.label(isChecked, disabled, isValidation)) }, label))));
});
Checkbox.displayName = 'Checkbox';

var ContainerScroll = function (props) {
    var _a;
    var customScrollBarProps = require("lodash").merge({
        className: '',
        options: {
            minScrollbarLength: 4,
            suppressScrollX: false,
        },
    }, ((_a = props.customScrollBarProps) !== null && _a !== void 0 ? _a : {}));
    customScrollBarProps.className += ' _container_perfect_scrollbar ' + (props.mode == 'light' ?
        '_container_perfect_scrollbar_light' :
        '_container_perfect_scrollbar_dark');
    // to reposition scroll when screen size change that will affect the container size
    var ref = React__default["default"].createRef();
    window.addEventListener('resize', (function () { var _a, _b; if ((_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a._ps) === null || _b === void 0 ? void 0 : _b.update) {
        ref.current._ps.update();
    } }));
    return (React__default["default"].createElement(PerfectScrollbar__default["default"], __assign({ ref: ref }, customScrollBarProps), props.children));
};

var GridItem = function (_a) {
    var children = _a.children, colSpan = _a.colSpan, rowSpan = _a.rowSpan, colStart = _a.colStart, rowStart = _a.rowStart, colEnd = _a.colEnd, rowEnd = _a.rowEnd, className = _a.className, props = __rest(_a, ["children", "colSpan", "rowSpan", "colStart", "rowStart", "colEnd", "rowEnd", "className"]);
    var itemClassNames = '';
    if (colSpan) {
        itemClassNames += " col-span-".concat(colSpan);
    }
    if (rowSpan) {
        itemClassNames += " row-span-".concat(rowSpan);
    }
    if (colStart) {
        itemClassNames += " col-start-".concat(colStart);
    }
    if (rowStart) {
        itemClassNames += " row-start-".concat(rowStart);
    }
    if (colEnd) {
        itemClassNames += " col-end-".concat(colEnd);
    }
    if (rowEnd) {
        itemClassNames += " row-end-".concat(rowEnd);
    }
    return (React__default["default"].createElement("div", __assign({ className: "".concat(itemClassNames, " ").concat(className !== null && className !== void 0 ? className : '').trim() }, props), children));
};

var Grid = function (_a) {
    var cols = _a.cols, rows = _a.rows, gap = _a.gap, flow = _a.flow, autoCols = _a.autoCols, autoRows = _a.autoRows, children = _a.children, className = _a.className, props = __rest(_a, ["cols", "rows", "gap", "flow", "autoCols", "autoRows", "children", "className"]);
    var gridClassNames = 'grid';
    if (autoRows) {
        gridClassNames += " auto-rows-".concat(autoRows);
    }
    if (autoCols) {
        gridClassNames += " auto-cols-".concat(autoCols);
    }
    if (flow) {
        gridClassNames += " grid-flow-".concat(flow);
    }
    if (cols) {
        gridClassNames += " grid-cols-".concat(cols);
    }
    if (rows) {
        gridClassNames += " grid-rows-".concat(rows);
    }
    if (gap) {
        gridClassNames += " gap-".concat(gap);
    }
    return (React__default["default"].createElement("div", __assign({ className: "".concat(gridClassNames, " ").concat(className).trim() }, props), children));
};
Grid.Item = GridItem;

var Link = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, children = _a.children, to = _a.to, icon = _a.icon, _c = _a.iconSize, iconSize = _c === void 0 ? '1x' : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, props = __rest(_a, ["className", "children", "to", "icon", "iconSize", "disabled"]);
    return (React__default["default"].createElement("a", __assign({ href: to, role: "link", className: 'cursor-default flex justify-center items-center font-medium text-md underline ' +
            (disabled
                ? 'text-neutral-eraser pointer-events-none'
                : 'text-primary-apricot hover:text-primary-skyblue active:text-primary-skyblue-shade') +
            className }, props), icon ? (React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement(Icon, { className: "mr-1", name: icon, size: iconSize }),
        children)) : (children)));
};
Link.defaultProps = {
    className: '',
};

var Logo = function (_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (React__default["default"].createElement("div", __assign({ className: classNames__default["default"]('', className) }, props),
        React__default["default"].createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 1554 695", width: "1554", height: "695", preserveAspectRatio: "xMidYMid meet", style: {
                width: '100%',
                height: '100%',
                transform: 'unset',
                contentVisibility: 'visible',
            } },
            React__default["default"].createElement("defs", null,
                React__default["default"].createElement("clipPath", { id: "__lottie_element_21" },
                    React__default["default"].createElement("rect", { width: "1554", height: "695", x: "0", y: "0" })),
                React__default["default"].createElement("clipPath", { id: "__lottie_element_23" },
                    React__default["default"].createElement("path", { d: "M0,0 L1920,0 L1920,1080 L0,1080z" }))),
            React__default["default"].createElement("g", { clipPath: "url(#__lottie_element_21)" },
                React__default["default"].createElement("g", { clipPath: "url(#__lottie_element_23)", transform: "matrix(1,0,0,1,-283.17401123046875,-271.5929870605469)", opacity: "1", style: { display: 'block' } },
                    React__default["default"].createElement("g", { transform: "matrix(1,0,0,1,282.9229736328125,482.1839904785156)", opacity: "1", style: { display: 'block' } },
                        React__default["default"].createElement("g", { opacity: "1", transform: "matrix(1,0,0,1,78.41999816894531,82.11000061035156)" },
                            React__default["default"].createElement("path", { fill: "rgb(38,34,98)", fillOpacity: "1", d: " M26.836999893188477,8.244999885559082 C26.836999893188477,8.244999885559082 6.616000175476074,28.34600067138672 6.616000175476074,28.34600067138672 C17.121000289916992,28.070999145507812 27.628999710083008,28.74799919128418 38.012001037597656,30.368999481201172 C31.707000732421875,39.56999969482422 23.094999313354492,46.952999114990234 13.038000106811523,51.777000427246094 C3.8919999599456787,55.19900131225586 -6.2170000076293945,54.986000061035156 -15.210000038146973,51.18000030517578 C-33.303001403808594,44.275001525878906 -46.00299835205078,27.815000534057617 -48.090999603271484,8.560999870300293 C-48.63100051879883,4.938000202178955 -48.90399932861328,1.2799999713897705 -48.90800094604492,-2.381999969482422 C-48.84400177001953,-7.086999893188477 -48.24300003051758,-11.767999649047852 -47.11800003051758,-16.336999893188477 C-47.11800003051758,-16.336999893188477 -47.11800003051758,-16.430999755859375 -47.11800003051758,-16.430999755859375 C-42.24800109863281,-38.67399978637695 -22.716999053955078,-54.64500045776367 0.050999999046325684,-55.000999450683594 C19.14299964904785,-55.729000091552734 37.72700119018555,-48.763999938964844 51.63800048828125,-35.667999267578125 C51.63800048828125,-35.667999267578125 69.4219970703125,-53.349998474121094 69.4219970703125,-53.349998474121094 C56.0099983215332,-68.53900146484375 33.540000915527344,-81.86100006103516 0.3009999990463257,-81.09700012207031 C0.3009999990463257,-81.09700012207031 0.14100000262260437,-81.09700012207031 0.14100000262260437,-81.09700012207031 C-37.66899871826172,-80.92900085449219 -69.95800018310547,-53.762001037597656 -76.58999633789062,-16.538000106811523 C-76.58999633789062,-16.538000106811523 -76.58999633789062,-16.41900062561035 -76.58999633789062,-16.41900062561035 C-77.56199645996094,-11.527000427246094 -78.08899688720703,-6.558000087738037 -78.16899871826172,-1.5720000267028809 C-78.16899871826172,2.0250000953674316 -77.97100067138672,5.61899995803833 -77.5739974975586,9.192999839782715 C-73.25599670410156,52.59400177001953 -40.6609992980957,81.08000183105469 -0.5460000038146973,81.1520004272461 C11.380000114440918,81.86100006103516 35.060001373291016,76.63700103759766 55.944000244140625,49.5099983215332 C57.45800018310547,59.667999267578125 58.05699920654297,69.94400024414062 57.733001708984375,80.20999908447266 C57.733001708984375,80.20999908447266 57.733001708984375,80.59600067138672 57.733001708984375,80.59600067138672 C57.733001708984375,80.59600067138672 78.00800323486328,60.38199996948242 78.00800323486328,60.38199996948242 C78.00800323486328,60.38199996948242 78.16899871826172,8.406000137329102 78.16899871826172,8.406000137329102 C78.16899871826172,8.406000137329102 26.836999893188477,8.244999885559082 26.836999893188477,8.244999885559082z" })),
                        React__default["default"].createElement("g", { opacity: "1", transform: "matrix(1,0,0,1,238.0260009765625,104.75700378417969)" },
                            React__default["default"].createElement("path", { fill: "rgb(38,34,98)", fillOpacity: "1", d: " M25.34600067138672,-13.895000457763672 C24.952999114990234,-29.160999298095703 15.47700023651123,-37.37200164794922 3.0920000076293945,-37.40800094604492 C-10.663999557495117,-37.91699981689453 -22.475000381469727,-27.709999084472656 -23.964000701904297,-14.026000022888184 C-23.964000701904297,-14.026000022888184 25.34600067138672,-13.895000457763672 25.34600067138672,-13.895000457763672z M3.825000047683716,-59.09000015258789 C36.32500076293945,-58.983001708984375 53.7140007019043,-35.23699951171875 53.61800003051758,-5.421000003814697 C53.61800003051758,-2.1050000190734863 52.909000396728516,5.414999961853027 52.909000396728516,5.414999961853027 C52.909000396728516,5.414999961853027 -24.91200065612793,5.164000034332275 -24.91200065612793,5.164000034332275 C-23.783000946044922,22.719999313354492 -8.732000350952148,36.09400177001953 8.833999633789062,35.152000427246094 C20.71299934387207,34.637001037597656 32.11399841308594,30.332000732421875 41.369998931884766,22.868000030517578 C41.369998931884766,22.868000030517578 52.138999938964844,43.03099822998047 52.138999938964844,43.03099822998047 C39.36399841308594,53.5260009765625 23.304000854492188,59.19200134277344 6.770999908447266,59.0359992980957 C-30.589000701904297,58.91699981689453 -53.7140007019043,31.856000900268555 -53.61899948120117,-0.2150000035762787 C-53.50600051879883,-34.93899917602539 -29.766000747680664,-59.191001892089844 3.8310000896453857,-59.09000015258789" })),
                        React__default["default"].createElement("g", { opacity: "1", transform: "matrix(1,0,0,1,375.5060119628906,103.66400146484375)" },
                            React__default["default"].createElement("path", { fill: "rgb(38,34,98)", fillOpacity: "1", d: " M-52.86399841308594,-55.08700180053711 C-52.86399841308594,-55.08700180053711 -25.892000198364258,-55.00400161743164 -25.892000198364258,-55.00400161743164 C-25.892000198364258,-55.00400161743164 -25.93400001525879,-41.95600128173828 -25.93400001525879,-41.95600128173828 C-25.94700050354004,-39.3650016784668 -26.104999542236328,-36.777000427246094 -26.405000686645508,-34.20399856567383 C-26.405000686645508,-34.20399856567383 -25.95800018310547,-34.20399856567383 -25.95800018310547,-34.20399856567383 C-18.156999588012695,-49.00699996948242 -2.5910000801086426,-58.060001373291016 14.133000373840332,-57.52000045776367 C39.112998962402344,-57.44300079345703 53.22200012207031,-44.34700012207031 53.12099838256836,-14.48900032043457 C53.12099838256836,-14.48900032043457 52.89400100708008,58.060001373291016 52.89400100708008,58.060001373291016 C52.89400100708008,58.060001373291016 25.040000915527344,57.970001220703125 25.040000915527344,57.970001220703125 C25.040000915527344,57.970001220703125 25.2549991607666,-8.817999839782715 25.2549991607666,-8.817999839782715 C25.29599952697754,-22.534000396728516 21.784000396728516,-31.829999923706055 7.419000148773193,-31.878000259399414 C-6.732999801635742,-32.0369987487793 -19.208999633789062,-22.625 -22.940000534057617,-8.972999572753906 C-24.422000885009766,-4.104000091552734 -25.110000610351562,0.972000002861023 -24.979999542236328,6.059999942779541 C-24.979999542236328,6.059999942779541 -25.141000747680664,57.814998626708984 -25.141000747680664,57.814998626708984 C-25.141000747680664,57.814998626708984 -53.22200012207031,57.720001220703125 -53.22200012207031,57.720001220703125 C-53.22200012207031,57.720001220703125 -52.86399841308594,-55.08700180053711 -52.86399841308594,-55.08700180053711z" })),
                        React__default["default"].createElement("g", { opacity: "1", transform: "matrix(1,0,0,1,478.79901123046875,82.07099914550781)" },
                            React__default["default"].createElement("path", { fill: "rgb(38,34,98)", fillOpacity: "1", d: " M-14.13599967956543,-33.04100036621094 C-14.13599967956543,-33.04100036621094 13.939000129699707,-32.94599914550781 13.939000129699707,-32.94599914550781 C13.939000129699707,-32.94599914550781 13.581000328063965,79.8550033569336 13.581000328063965,79.8550033569336 C13.581000328063965,79.8550033569336 -14.494000434875488,79.76599884033203 -14.494000434875488,79.76599884033203 C-14.494000434875488,79.76599884033203 -14.13599967956543,-33.04100036621094 -14.13599967956543,-33.04100036621094z M-1.5360000133514404,-79.8290023803711 C-1.5360000133514404,-79.8290023803711 1.6299999952316284,-79.8290023803711 1.6299999952316284,-79.8290023803711 C9.248000144958496,-79.80400085449219 15.402999877929688,-73.60900115966797 15.378999710083008,-65.99099731445312 C15.354000091552734,-58.374000549316406 9.159000396728516,-52.21799850463867 1.5410000085830688,-52.24300003051758 C1.5410000085830688,-52.24300003051758 -1.63100004196167,-52.24300003051758 -1.63100004196167,-52.24300003051758 C-9.24899959564209,-52.26900100708008 -15.402999877929688,-58.465999603271484 -15.376999855041504,-66.08399963378906 C-15.350000381469727,-73.70099639892578 -9.154000282287598,-79.8550033569336 -1.5360000133514404,-79.8290023803711z" })),
                        React__default["default"].createElement("g", { opacity: "1", transform: "matrix(1,0,0,1,575.5230102539062,105.81500244140625)" },
                            React__default["default"].createElement("path", { fill: "rgb(38,34,98)", fillOpacity: "1", d: " M25.351999282836914,-13.87399959564209 C24.958999633789062,-29.139999389648438 15.47700023651123,-37.35100173950195 3.0969998836517334,-37.387001037597656 C-10.64799976348877,-37.89400100708008 -22.451000213623047,-27.701000213623047 -23.95199966430664,-14.029000282287598 C-23.95199966430664,-14.029000282287598 25.351999282836914,-13.87399959564209 25.351999282836914,-13.87399959564209z M3.8310000896453857,-59.06999969482422 C36.33100128173828,-58.96900177001953 53.720001220703125,-35.215999603271484 53.624000549316406,-5.400000095367432 C53.624000549316406,-2.0840001106262207 52.91999816894531,5.428999900817871 52.91999816894531,5.428999900817871 C52.91999816894531,5.428999900817871 -24.899999618530273,5.184000015258789 -24.899999618530273,5.184000015258789 C-23.764999389648438,22.726999282836914 -8.72599983215332,36.090999603271484 8.82800006866455,35.15599822998047 C20.707000732421875,34.63999938964844 32.108001708984375,30.334999084472656 41.36399841308594,22.871999740600586 C41.36399841308594,22.871999740600586 52.138999938964844,43.03300094604492 52.138999938964844,43.03300094604492 C39.36199951171875,53.52799987792969 23.298999786376953,59.194000244140625 6.764999866485596,59.03799819946289 C-30.594999313354492,58.91899871826172 -53.720001220703125,31.857999801635742 -53.61899948120117,-0.21299999952316284 C-53.50600051879883,-34.9370002746582 -29.766000747680664,-59.19499969482422 3.825000047683716,-59.0880012512207" })),
                        React__default["default"].createElement("g", { opacity: "1", transform: "matrix(1,0,0,1,715.8380126953125,85.53199768066406)" },
                            React__default["default"].createElement("path", { fill: "rgb(38,34,98)", fillOpacity: "1", d: " M-0.7239999771118164,56.095001220703125 C14.75100040435791,56.14799880981445 27.613000869750977,43.571998596191406 27.684999465942383,21.23900032043457 C27.756000518798828,-0.2280000001192093 16.299999237060547,-14.182000160217285 -0.2840000092983246,-14.236000061035156 C-14.87600040435791,-14.284000396728516 -28.614999771118164,-3.7109999656677246 -28.69300079345703,21.274999618530273 C-28.746000289916992,38.75400161743164 -19.520000457763672,56.04100036621094 -0.7239999771118164,56.095001220703125z M-55.58700180053711,-80.11199951171875 C-55.58700180053711,-80.11199951171875 -27.51099967956543,-80.02300262451172 -27.51099967956543,-80.02300262451172 C-27.51099967956543,-80.02300262451172 -27.66699981689453,-31.58300018310547 -27.66699981689453,-31.58300018310547 C-27.66699981689453,-26.05500030517578 -28.13800048828125,-22.07200050354004 -28.13800048828125,-22.07200050354004 C-28.13800048828125,-22.07200050354004 -27.69099998474121,-22.07200050354004 -27.69099998474121,-22.07200050354004 C-19.84000015258789,-32.82899856567383 -7.117000102996826,-38.933998107910156 6.186999797821045,-38.327999114990234 C36.69499969482422,-38.22600173950195 56.06999969482422,-14.057000160217285 55.9630012512207,20.88800048828125 C55.8489990234375,56.72100067138672 33.89899826049805,79.8759994506836 4.040999889373779,79.78099822998047 C-9.269000053405762,80.11199951171875 -21.863000869750977,73.76200103759766 -29.510000228881836,62.862998962402344 C-29.510000228881836,62.862998962402344 -29.951000213623047,62.862998962402344 -29.951000213623047,62.862998962402344 C-29.66200065612793,65.43699645996094 -29.52400016784668,68.0250015258789 -29.540000915527344,70.61499786376953 C-29.540000915527344,70.61499786376953 -29.540000915527344,77.03199768066406 -29.540000915527344,77.03199768066406 C-29.540000915527344,77.03199768066406 -56.069000244140625,76.947998046875 -56.069000244140625,76.947998046875 C-56.069000244140625,76.947998046875 -55.58700180053711,-80.11199951171875 -55.58700180053711,-80.11199951171875z" })),
                        React__default["default"].createElement("g", { opacity: "1", transform: "matrix(1,0,0,1,1002.614013671875,107.15599822998047)" },
                            React__default["default"].createElement("path", { fill: "rgb(38,34,98)", fillOpacity: "1", d: " M0,35.1619987487793 C18.518999099731445,35.1619987487793 33.53200149536133,20.14900016784668 33.53099822998047,1.6299999952316284 C33.53099822998047,1.11899995803833 33.51900100708008,0.609000027179718 33.494998931884766,0.09799999743700027 C34.44300079345703,-18.395999908447266 20.2189998626709,-34.15700149536133 1.7239999771118164,-35.104000091552734 C-16.770999908447266,-36.051998138427734 -32.53099822998047,-21.82699966430664 -33.479000091552734,-3.3320000171661377 C-33.534000396728516,-2.260999917984009 -33.53799819946289,-1.187999963760376 -33.4900016784668,-0.11599999666213989 C-34.43199920654297,18.402000427246094 -20.18400001525879,34.176998138427734 -1.6660000085830688,35.11899948120117 C-1.1109999418258667,35.14699935913086 -0.5550000071525574,35.1619987487793 0,35.1619987487793z M0.07800000160932541,-59.05699920654297 C34.56399917602539,-58.95000076293945 62.095001220703125,-34.30400085449219 62.01100158691406,0.1940000057220459 C61.89799880981445,34.917999267578125 34.19300079345703,59.16400146484375 -0.07800000160932541,59.05699920654297 C-34.56399917602539,58.95000076293945 -62.095001220703125,34.52399826049805 -62.01100158691406,-0.20000000298023224 C-61.90399932861328,-34.702999114990234 -34.19300079345703,-59.16400146484375 0.07800000160932541,-59.05699920654297z" })),
                        React__default["default"].createElement("g", { opacity: "1", transform: "matrix(1,0,0,1,856.948974609375,106.69200134277344)" },
                            React__default["default"].createElement("path", { fill: "rgb(38,34,98)", fillOpacity: "1", d: " M0,35.1609992980957 C18.518999099731445,35.1609992980957 33.53099822998047,20.14900016784668 33.53099822998047,1.6299999952316284 C33.53099822998047,1.1200000047683716 33.51900100708008,0.609000027179718 33.494998931884766,0.09799999743700027 C34.44300079345703,-18.395999908447266 20.2189998626709,-34.15700149536133 1.7239999771118164,-35.104000091552734 C-16.770999908447266,-36.051998138427734 -32.53099822998047,-21.82699966430664 -33.479000091552734,-3.3320000171661377 C-33.534000396728516,-2.260999917984009 -33.53799819946289,-1.187999963760376 -33.4900016784668,-0.11599999666213989 C-34.43199920654297,18.402000427246094 -20.18400001525879,34.17599868774414 -1.6660000085830688,35.11800003051758 C-1.1109999418258667,35.145999908447266 -0.5550000071525574,35.1609992980957 0,35.1609992980957z M0.07800000160932541,-59.05699920654297 C34.56399917602539,-58.95000076293945 62.095001220703125,-34.310001373291016 62.01100158691406,0.1940000057220459 C61.89799880981445,34.917999267578125 34.19300079345703,59.165000915527344 -0.07800000160932541,59.05699920654297 C-34.56399917602539,58.95000076293945 -62.095001220703125,34.52299880981445 -62.01100158691406,-0.20100000500679016 C-61.90399932861328,-34.70399856567383 -34.19300079345703,-59.16400146484375 0.07800000160932541,-59.05699920654297z" })),
                        React__default["default"].createElement("g", { opacity: "1", transform: "matrix(1,0,0,1,1145.9730224609375,85.49500274658203)" },
                            React__default["default"].createElement("path", { fill: "rgb(38,34,98)", fillOpacity: "1", d: " M-51.89500045776367,-78.69100189208984 C-51.89500045776367,-78.69100189208984 -23.81999969482422,-78.60199737548828 -23.81999969482422,-78.60199737548828 C-23.81999969482422,-78.60199737548828 -24.0939998626709,8.045000076293945 -24.0939998626709,8.045000076293945 C-24.0939998626709,8.045000076293945 18.304000854492188,-34.229000091552734 18.304000854492188,-34.229000091552734 C18.304000854492188,-34.229000091552734 49.08700180053711,-34.13399887084961 49.08700180053711,-34.13399887084961 C49.08700180053711,-34.13399887084961 6.551000118255615,8.206000328063965 6.551000118255615,8.206000328063965 C6.551000118255615,8.206000328063965 6.551000118255615,8.647000312805176 6.551000118255615,8.647000312805176 C6.551000118255615,8.647000312805176 52.38999938964844,78.69100189208984 52.38999938964844,78.69100189208984 C52.38999938964844,78.69100189208984 20.111000061035156,78.58999633789062 20.111000061035156,78.58999633789062 C20.111000061035156,78.58999633789062 -11.416000366210938,26.113000869750977 -11.416000366210938,26.113000869750977 C-11.416000366210938,26.113000869750977 -24.195999145507812,38.8390007019043 -24.195999145507812,38.8390007019043 C-24.195999145507812,38.8390007019043 -24.315000534057617,78.4530029296875 -24.315000534057617,78.4530029296875 C-24.315000534057617,78.4530029296875 -52.38999938964844,78.36299896240234 -52.38999938964844,78.36299896240234 C-52.38999938964844,78.36299896240234 -51.89500045776367,-78.69100189208984 -51.89500045776367,-78.69100189208984z" }))),
                    React__default["default"].createElement("g", { transform: "matrix(1,0,0,1,1481.5140380859375,431.3529968261719)", opacity: "1", style: { display: 'block' } },
                        React__default["default"].createElement("g", { opacity: "1", transform: "matrix(1,0,0,1,77.78099822998047,77.74600219726562)" },
                            React__default["default"].createElement("path", { fill: "rgb(39,170,225)", fillOpacity: "1", d: " M-42.53900146484375,-17.55900001525879 C-14.449000358581543,-7.793000221252441 7.572000026702881,14.37399959564209 17.15399932861328,42.527000427246094 C17.15399932861328,42.527000427246094 57.92399978637695,1.9119999408721924 57.92399978637695,1.9119999408721924 C57.92399978637695,1.9119999408721924 58.1150016784668,-57.900001525878906 58.1150016784668,-57.900001525878906 C58.1150016784668,-57.900001525878906 -1.75,-58.084999084472656 -1.75,-58.084999084472656 C-1.75,-58.084999084472656 -42.53900146484375,-17.55900001525879 -42.53900146484375,-17.55900001525879z M-77.53099822998047,-9.913000106811523 C-77.53099822998047,-9.913000106811523 -9.574000358581543,-77.49600219726562 -9.574000358581543,-77.49600219726562 C-9.574000358581543,-77.49600219726562 77.53099822998047,-77.2020034790039 77.53099822998047,-77.2020034790039 C77.53099822998047,-77.2020034790039 77.25700378417969,9.944000244140625 77.25700378417969,9.944000244140625 C77.25700378417969,9.944000244140625 9.312000274658203,77.49600219726562 9.312000274658203,77.49600219726562 C4.914000034332275,31.378000259399414 -31.441999435424805,-5.216000080108643 -77.53099822998047,-9.913000106811523z" }))),
                    React__default["default"].createElement("g", { transform: "matrix(1,0,0,1,1125.2716064453125,787.1226196289062)", opacity: "0.2611193394570394", style: { display: 'none' } },
                        React__default["default"].createElement("g", { opacity: "1", transform: "matrix(1,0,0,1,77.78099822998047,77.74600219726562)" },
                            React__default["default"].createElement("path", { fill: "rgb(39,170,225)", fillOpacity: "1", d: " M-42.53900146484375,-17.55900001525879 C-14.449000358581543,-7.793000221252441 7.572000026702881,14.37399959564209 17.15399932861328,42.527000427246094 C17.15399932861328,42.527000427246094 57.92399978637695,1.9119999408721924 57.92399978637695,1.9119999408721924 C57.92399978637695,1.9119999408721924 58.1150016784668,-57.900001525878906 58.1150016784668,-57.900001525878906 C58.1150016784668,-57.900001525878906 -1.75,-58.084999084472656 -1.75,-58.084999084472656 C-1.75,-58.084999084472656 -42.53900146484375,-17.55900001525879 -42.53900146484375,-17.55900001525879z M-77.53099822998047,-9.913000106811523 C-77.53099822998047,-9.913000106811523 -9.574000358581543,-77.49600219726562 -9.574000358581543,-77.49600219726562 C-9.574000358581543,-77.49600219726562 77.53099822998047,-77.2020034790039 77.53099822998047,-77.2020034790039 C77.53099822998047,-77.2020034790039 77.25700378417969,9.944000244140625 77.25700378417969,9.944000244140625 C77.25700378417969,9.944000244140625 9.312000274658203,77.49600219726562 9.312000274658203,77.49600219726562 C4.914000034332275,31.378000259399414 -31.441999435424805,-5.216000080108643 -77.53099822998047,-9.913000106811523z" }))))))));
};
Logo.defaultProps = {
    className: 'p-2',
};

var useModalTransition = function (_a) {
    var _b = _a.defaultOpen, defaultOpen = _b === void 0 ? false : _b, _c = _a.onOpenDuration, onOpenDuration = _c === void 0 ? 0 : _c, onCloseDuration = _a.onCloseDuration, callbacks = _a.callbacks;
    var _d = React__default["default"].useState('closed'), state = _d[0], setState = _d[1];
    var open = React__default["default"].useCallback(function () {
        var _a;
        setState('opening');
        (_a = callbacks.opening) === null || _a === void 0 ? void 0 : _a.call(callbacks);
        setTimeout(function () {
            var _a;
            setState('opened');
            (_a = callbacks.opened) === null || _a === void 0 ? void 0 : _a.call(callbacks);
        }, onOpenDuration);
    }, [onOpenDuration, callbacks]);
    var close = React__default["default"].useCallback(function () {
        var _a;
        setState('closing');
        (_a = callbacks.closing) === null || _a === void 0 ? void 0 : _a.call(callbacks);
        setTimeout(function () {
            var _a;
            setState('closed');
            (_a = callbacks.closed) === null || _a === void 0 ? void 0 : _a.call(callbacks);
        }, onCloseDuration !== null && onCloseDuration !== void 0 ? onCloseDuration : onOpenDuration);
    }, [onCloseDuration, onOpenDuration, callbacks]);
    React__default["default"].useEffect(function () {
        if (defaultOpen) {
            setState('opened');
        }
        else {
            setState('closed');
        }
    }, [defaultOpen]);
    return {
        state: state,
        open: open,
        close: close,
        isOpen: ['opening', 'opened'].includes(state),
        isClose: ['closing', 'closed'].includes(state),
    };
};

var sizes$1 = {
    xs: 'w-1/6',
    sm: 'w-2/6',
    md: 'w-3/6',
    lg: 'w-4/6',
    xl: 'w-5/6',
    full: 'w-full',
};
var fades = {
    fade: {
        in: 'translate-y-0 sm:scale-100',
        out: 'translate-y-4 sm:translate-y-0 sm:scale-95',
    },
    fadeTop: { in: '-translate-y-0', out: '-translate-y-20' },
    fadeRight: { in: '-translate-x-0', out: 'translate-x-20' },
    fadeBottom: { in: '-translate-y-0', out: 'translate-y-20' },
    fadeLeft: { in: '-translate-x-0', out: '-translate-x-20' },
};
var generateFadeAnimations = function () {
    return Object.entries(fades).reduce(function (acc, fadeEntry) {
        var _a;
        return (__assign(__assign({}, acc), (_a = {}, _a[fadeEntry[0]] = {
            container: {
                in: 'fixed inset-0 z-100 overflow-y-auto',
                out: 'sr-only',
            },
            background: {
                out: 'ease-in duration-300 opacity-0',
                in: 'ease-out duration-300 opacity-100',
            },
            modal: {
                out: "ease-in duration-200 opacity-0 ".concat(fadeEntry[1].out),
                in: "ease-out duration-300 opacity-100 ".concat(fadeEntry[1].in),
            },
        }, _a)));
    }, {});
};
var animations = __assign({}, generateFadeAnimations());
var getContainerClassNames = function (animation, state) {
    var _a, _b;
    switch (state) {
        case 'closed':
            return (_a = animations[animation]) === null || _a === void 0 ? void 0 : _a.container.out;
        case 'closing':
        case 'opened':
        case 'opening':
            return (_b = animations[animation]) === null || _b === void 0 ? void 0 : _b.container.in;
        default:
            return '';
    }
};
var getBackgroundClassNames = function (animation, state) {
    var _a, _b, _c;
    var base = 'fixed flex inset-0 bg-gray-500 bg-opacity-75 transition-opacity';
    switch (state) {
        case 'closed':
            return "".concat(base, " ").concat((_a = animations[animation]) === null || _a === void 0 ? void 0 : _a.background.out);
        case 'closing':
            return "".concat(base, " ").concat((_b = animations[animation]) === null || _b === void 0 ? void 0 : _b.background.out);
        case 'opened':
        case 'opening':
            return "".concat(base, " ").concat((_c = animations[animation]) === null || _c === void 0 ? void 0 : _c.background.in);
        default:
            return '';
    }
};
var getModalDialodClassNames = function (animation, state, size) {
    var _a, _b;
    var base = "".concat(sizes$1[size], " text-foreground flex align-bottom bg-white rounded-lg text-left overflow-visible shadow-xl transform transition-all sm:my-4 sm:align-middle sm:max-w-full p-2");
    switch (state) {
        case 'closed':
        case 'closing':
            return "".concat(base, " ").concat((_a = animations[animation]) === null || _a === void 0 ? void 0 : _a.modal.out);
        case 'opened':
        case 'opening':
            return "".concat(base, " ").concat((_b = animations[animation]) === null || _b === void 0 ? void 0 : _b.modal.in);
        default:
            return '';
    }
};
var getModalContainerlClassNames = function (position) {
    var base = 'flex min-h-screen pt-4 px-4 pb-20 text-center sm:p-0';
    switch (position) {
        case 'top':
            return "".concat(base, " items-start justify-center");
        case 'right':
            return "".concat(base, " items-center justify-end");
        case 'bottom':
            return "".concat(base, " items-end justify-center ");
        case 'left':
            return "".concat(base, " items-center");
        case 'center':
        default:
            return "".concat(base, " items-center justify-center");
    }
};
var getCloseButtonClassNames = function (position, size) {
    var base = 'absolute bg-background rounded-full w-6 h-6 p-1 flex items-center justify-center';
    if (size === 'full' || position === 'right') {
        return "".concat(base, " top-1 right-2");
    }
    return "".concat(base, " -right-8 top-0");
};
var getModalClassNames = function (animation, state, position, size) {
    var classNames = {};
    classNames.container = getContainerClassNames(animation, state);
    classNames.background = getBackgroundClassNames(animation, state);
    classNames.modal = getModalDialodClassNames(animation, state, size);
    classNames.modalContainer = getModalContainerlClassNames(position);
    classNames.closeButton = getCloseButtonClassNames(position, size);
    return classNames;
};

var Modal = function (_a) {
    var _b = _a.animation, animation = _b === void 0 ? 'fade' : _b, open = _a.open, onClose = _a.onClose, children = _a.children, _c = _a.size, size = _c === void 0 ? 'md' : _c, _d = _a.position, position = _d === void 0 ? 'center' : _d, _e = _a.closeOnOverlayDoubleClick, closeOnOverlayDoubleClick = _e === void 0 ? true : _e, ariaLabelledBy = _a["aria-labelledby"], ariaLabel = _a["aria-label"], _f = _a.alwaysRender, alwaysRender = _f === void 0 ? false : _f;
    var modalState = useModalTransition({
        defaultOpen: open,
        onOpenDuration: 300,
        onCloseDuration: 300,
        callbacks: {
            closed: onClose,
        },
    });
    var onClickOutside = function (event) {
        event.stopPropagation();
        if (closeOnOverlayDoubleClick)
            modalState.close();
    };
    var classes = React__default["default"].useMemo(function () { return getModalClassNames(animation, modalState.state, position, size); }, [modalState.state, position, size, animation]);
    return open || alwaysRender ? (React__default["default"].createElement("div", { className: "".concat(classes.container), "aria-labelledby": ariaLabelledBy, role: "dialog", "aria-label": ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : 'modal', "aria-modal": "true" },
        React__default["default"].createElement("div", { onDoubleClick: onClickOutside, className: "".concat(classes.background), "aria-hidden": "true" }),
        React__default["default"].createElement("div", { className: "".concat(classes.modalContainer) },
            React__default["default"].createElement("div", { onDoubleClick: function (event) { return event.stopPropagation(); }, className: "".concat(classes.modal) },
                React__default["default"].createElement(Icon, { name: "xmark", 
                    // role="button"
                    className: classes.closeButton, onClick: modalState.close }),
                children)))) : (React__default["default"].createElement(React__default["default"].Fragment, null));
};

var variants$1 = {
    light: {
        container: function (isChecked, isDisabled, isValidation) {
            return "rb-focus ".concat(isValidation ? (isChecked ? '' : 'validation') : '', " appearance-none ").concat(!isChecked ? 'rb-border' : '', "\n      rb-size m-1 relative rb-disabled ").concat(isDisabled
                ? !isChecked
                    ? 'disabled unchecked'
                    : 'disabled checked'
                : isValidation
                    ? !isChecked
                        ? 'rb-validation'
                        : 'enabled checked'
                    : 'enabled focused');
        },
        icon: function (isChecked, isDisabled) {
            return "".concat(isDisabled ? 'rb-icon disabled' : 'rb-icon', " ").concat(isChecked ? '' : 'hidden');
        },
        label: function (isChecked, isDisabled, isValidation) {
            return "rb-label ".concat(isDisabled
                ? 'disabled'
                : isValidation
                    ? isChecked
                        ? 'enabled'
                        : 'validation'
                    : 'enabled');
        },
    },
    dark: {
        container: function (isChecked, isDisabled, isValidation) {
            return "rb-d-focus ".concat(isValidation ? (isChecked ? '' : 'validation') : '', " appearance-none\n      rb-d-size m-1 relative rb-d-disabled rb-d-border ").concat(isDisabled
                ? !isChecked
                    ? 'disabled unchecked'
                    : 'disabled checked'
                : isValidation
                    ? 'rb-d-validation'
                    : isChecked
                        ? 'enabled checked'
                        : 'enabled focused');
        },
        icon: function (isChecked, isDisabled) {
            return "".concat(isDisabled ? 'rb-d-icon disabled' : 'rb-d-icon', " ").concat(isChecked ? '' : 'hidden');
        },
        label: function (isChecked, isDisabled, isValidation) {
            return "rb-d-label ".concat(isDisabled
                ? 'disabled'
                : isValidation
                    ? isChecked
                        ? 'enabled'
                        : 'validation'
                    : 'enabled');
        },
    },
    mcq: {
        container: function (isChecked, isDisabled, isValidation) {
            return "rb-focus ".concat(isValidation ? (isChecked ? '' : 'validation') : '', " appearance-none\n      rb-size m-1 relative rb-disabled rb-mcq-border ").concat(isDisabled
                ? !isChecked
                    ? 'disabled unchecked'
                    : 'disabled checked'
                : !isChecked
                    ? 'enabled focused'
                    : 'enabled checked');
        },
        icon: function (isChecked, isDisabled) {
            return "".concat(isDisabled ? 'rb-icon disabled' : 'rb-icon', " ").concat(isChecked ? '' : 'hidden');
        },
        label: function (isChecked, isDisabled, isValidation) {
            return "rb-label ".concat(isDisabled
                ? 'disabled'
                : isValidation
                    ? isChecked
                        ? 'enabled'
                        : 'validation'
                    : 'enabled');
        },
    },
};
var Radio = function (_a) {
    var _b, _c, _d;
    var name = _a.name, id = _a.id, ariaLabelledBy = _a["aria-labelledby"], ariaLabel = _a["aria-label"], value = _a.value, onChange = _a.onChange, isChecked = _a.isChecked, _e = _a.disabled, disabled = _e === void 0 ? false : _e, isValidation = _a.isValidation, defaultChecked = _a.defaultChecked, label = _a.label, _f = _a.variant, variant = _f === void 0 ? 'light' : _f, _g = _a.className, className = _g === void 0 ? '' : _g;
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement("label", { className: "rb-container ".concat(className) },
            React__default["default"].createElement("div", { className: "".concat((_b = variants$1[variant]) === null || _b === void 0 ? void 0 : _b.container(isChecked, disabled, isValidation)) },
                React__default["default"].createElement(Icon, { name: "circle-dot", className: "fill-current ".concat((_c = variants$1[variant]) === null || _c === void 0 ? void 0 : _c.icon(isChecked, disabled)) }),
                React__default["default"].createElement("input", { className: "appearance-none invisible", name: name, id: id, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, value: value, type: "radio", onChange: onChange, checked: isChecked, defaultChecked: defaultChecked, disabled: disabled })),
            React__default["default"].createElement("span", { className: "".concat((_d = variants$1[variant]) === null || _d === void 0 ? void 0 : _d.label(isChecked, disabled, isValidation)) }, label))));
};

/*
 * By default, there are 3 variants(currently only use outside):
 * - inside: text looks placed inside the input
 * - outside: text looks placed outside the input
 * - default: only text
 *
 * List of elements inside each variant(need to add even not used):
 * - container
 * - label
 * - input
 * - error
 *
 * List of state for each elements(not applicable at all codes):
 * - base: will be at any state
 * - default: when enabled & no error
 * - disabled: when input is disabled
 * - error: when there is error message
 * - *_dark: * state when in dark mode
 * - *_light: * state when in light mode
 */
var VARIANTS = {
    inside: {
        container: {
            base: "relative text-gray-500 focus-within:text-primary-700",
            disabled: "opacity-30 select-none pointer-events-none cursor-not-allowed",
        },
        label: {
            base: "absolute px-2 py-1 text-xs",
            error: "text-error-600",
        },
        input: {
            base: "border p-2 pt-5 rounded outline-none",
            default: "border focus:border-primary-600 focus:ring-2 ring-primary-200 text-black",
            error: "border border-error-600 text-error-600 focus:ring-1 focus:ring-error-300",
        },
        error: {
            base: "",
        },
    },
    outside: {
        container: {
            base: "flex flex-col focus-within:text-primary-apricot",
            base_dark: "text-neutral-whiteboard",
            base_light: "text-primary-navyblue",
            disabled: "pointer-events-none cursor-not-allowed",
        },
        label: {
            base: "font-medium leading-4 mb-2 text-base whitespace-nowrap",
            error: "text-alert-error",
        },
        input: {
            base: "border-2 h-12 px-4 rounded-2xl outline outline-none focus:ring-2 focus:ring-primary-apricot focus:ring-opacity-50 placeholder-neutral-eraser",
            default: "border-neutral-notebook outline-primary-apricot-0.5 text-neutral-pencil focus:border-primary-apricot",
            disabled: "bg-neutral-notebook",
            disabled_dark: "text-neutral-whiteboard",
            disabled_light: "text-neutral-pencil",
            error: "border-alert-error outline-none focus:!ring-2 focus:!ring-alert-error focus:!ring-opacity-50 text-neutral-pencil",
        },
        error: {
            base: "leading-3.5 pt-2 text-alert-error text-sm",
        },
    },
    default: {
        container: {
            base: "",
            disabled: "",
        },
        label: {
            base: "",
            error: "",
        },
        input: {
            base: "border p-2 rounded outline-none",
            disabled: "opacity-30 select-none pointer-events-none cursor-not-allowed",
            error: "border-error-600 text-error-600 focus:ring-1 focus:ring-error-300",
            default: "focus:border-primary-600 text-error-600 focus:ring-2 ring-primary-200 text-black",
        },
        error: {
            base: "",
        },
    },
};
// Container's Classes
var InputContainerClassNames = function (classes, props, additions) {
    return React.useMemo(function () {
        var _a;
        var _b, _c, _d, _e, _f;
        return classNames__default["default"]((_a = {},
            _a[(_b = classes.container) === null || _b === void 0 ? void 0 : _b.base] = true,
            _a[(_c = classes.container) === null || _c === void 0 ? void 0 : _c.base_dark] = props.mode == 'dark',
            _a[(_d = classes.container) === null || _d === void 0 ? void 0 : _d.base_light] = props.mode == 'light',
            _a[(_e = classes.container) === null || _e === void 0 ? void 0 : _e.disabled] = props.disabled,
            _a[(_f = props.className) !== null && _f !== void 0 ? _f : ''] = true,
            _a[additions ? additions : ''] = additions,
            _a));
    }, [
        props.className,
        props.disabled,
        props.mode,
    ]);
};
// Input's Classes
var InputClassNames = function (classes, props, additions) {
    return React.useMemo(function () {
        var _a;
        var _b, _c, _d, _e, _f, _g, _h, _j;
        return classNames__default["default"]((_a = {},
            _a[(_b = classes.input) === null || _b === void 0 ? void 0 : _b.base] = true,
            _a[(_c = classes.input) === null || _c === void 0 ? void 0 : _c.default] = !props.error && !props.disabled,
            _a[(_d = classes.input) === null || _d === void 0 ? void 0 : _d.error] = props.error,
            _a[(_e = classes.input) === null || _e === void 0 ? void 0 : _e.disabled] = props.disabled,
            _a[(_f = classes.input) === null || _f === void 0 ? void 0 : _f.disabled_dark] = props.disabled && props.mode == 'dark',
            _a[(_g = classes.input) === null || _g === void 0 ? void 0 : _g.disabled_light] = props.disabled && props.mode == 'light',
            _a[(_h = props.inputProps) === null || _h === void 0 ? void 0 : _h.addClassName] = (_j = props.inputProps) === null || _j === void 0 ? void 0 : _j.addClassName,
            _a[additions ? additions : ''] = additions,
            _a));
    }, [
        props.disabled,
        props.error,
        props.inputProps,
        props.mode,
    ]);
};
// Input Error's Element
var InputError = React.forwardRef(function (props) {
    var _a;
    var classes = VARIANTS[(_a = props.variant) !== null && _a !== void 0 ? _a : 'outside'];
    var errorClassNames = React.useMemo(function () {
        var _a;
        var _b, _c;
        return classNames__default["default"]((_a = {},
            _a[classes.error.base] = true,
            _a[(_b = props.errorProps) === null || _b === void 0 ? void 0 : _b.addClassName] = (_c = props.errorProps) === null || _c === void 0 ? void 0 : _c.addClassName,
            _a));
    }, [
        props.disabled,
        props.error,
        props.errorProps
    ]);
    return React__default["default"].createElement(React__default["default"].Fragment, null, props.error ? (React__default["default"].createElement("span", __assign({ className: errorClassNames }, (props.errorProps ? props.errorProps : {})), props.error)) : React__default["default"].createElement(React__default["default"].Fragment, null));
});
// Input Label's Element
var InputLabel = React.forwardRef(function (props) {
    var _a, _b;
    var classes = VARIANTS[(_a = props.variant) !== null && _a !== void 0 ? _a : 'outside'];
    var labelClassNames = React.useMemo(function () {
        var _a;
        var _b, _c;
        return classNames__default["default"]((_a = {},
            _a[classes.label.base] = true,
            _a[classes.label.error] = props.error,
            _a[(_b = props.labelProps) === null || _b === void 0 ? void 0 : _b.addClassName] = (_c = props.labelProps) === null || _c === void 0 ? void 0 : _c.addClassName,
            _a));
    }, [
        props.error,
        (_b = props.labelProps) === null || _b === void 0 ? void 0 : _b.addClassName,
    ]);
    return React__default["default"].createElement("span", __assign({ className: labelClassNames }, (props.labelProps ? props.labelProps : {})),
        props.label,
        props.required ? React__default["default"].createElement("span", { className: "text-alert-error" }, "*") : null);
});
var InputLabelInside = React.forwardRef(// not used
function (_a, ref) {
    var label = _a.label, disabled = _a.disabled, className = _a.className, error = _a.error, id = _a.id, name = _a.name, onBlur = _a.onBlur, onChange = _a.onChange, onClick = _a.onClick, onFocus = _a.onFocus, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, placeholder = _a.placeholder, value = _a.value, required = _a.required, type = _a.type, min = _a.min, max = _a.max, step = _a.step, maxLength = _a.maxLength, minLength = _a.minLength, pattern = _a.pattern, autoCapitalize = _a.autoCapitalize, autoComplete = _a.autoComplete, autoCorrect = _a.autoCorrect, inputMode = _a.inputMode, readOnly = _a.readOnly;
    var classes = VARIANTS.inside;
    var containerClassNames = React.useMemo(function () {
        var _a;
        return classNames__default["default"]((_a = {},
            _a[classes.container.base] = true,
            _a[classes.container.disabled] = disabled,
            _a[className !== null && className !== void 0 ? className : ''] = true,
            _a));
    }, [className, disabled]);
    var labelClassNames = React.useMemo(function () {
        var _a;
        return classNames__default["default"]((_a = {},
            _a[classes.label.base] = true,
            _a[classes.label.error] = !!error,
            _a));
    }, [error]);
    var inputClassNames = React.useMemo(function () {
        var _a;
        return classNames__default["default"]((_a = {},
            _a[classes.input.base] = true,
            _a[classes.input.default] = !error,
            _a[classes.input.error] = !!error,
            _a));
    }, [error]);
    return (React__default["default"].createElement("label", { "aria-disabled": disabled, "aria-invalid": !!error, className: containerClassNames, htmlFor: id },
        React__default["default"].createElement("span", { className: labelClassNames },
            label,
            required ? React__default["default"].createElement(React__default["default"].Fragment, null, "\u00A0*") : null),
        React__default["default"].createElement("input", { id: id, required: required, disabled: disabled, className: inputClassNames, name: name, onBlur: onBlur, onChange: onChange, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onClick: onClick, onFocus: onFocus, placeholder: placeholder, value: value, ref: ref, type: type, min: min, max: max, step: step, maxLength: maxLength, minLength: minLength, pattern: pattern, autoComplete: autoComplete, autoCorrect: autoCorrect, autoCapitalize: autoCapitalize, inputMode: inputMode, readOnly: readOnly })));
});
var InputLabelOutside = React.forwardRef(function (props, ref) {
    var classes = VARIANTS.outside;
    return (React__default["default"].createElement("label", __assign({ "aria-disabled": props.disabled, "aria-invalid": !!props.error, className: InputContainerClassNames(classes, props), htmlFor: props.id }, (props.containerProps ? props.containerProps : {})),
        React__default["default"].createElement(InputLabel, props),
        React__default["default"].createElement("input", __assign({ id: props.id, required: props.required, disabled: props.disabled, className: InputClassNames(classes, props), name: props.name, onBlur: props.onBlur, onChange: props.onChange, onKeyDown: props.onKeyDown, onKeyUp: props.onKeyUp, onClick: props.onClick, onFocus: props.onFocus, placeholder: props.placeholder, value: props.value, ref: ref, type: props.type, min: props.min, max: props.max, step: props.step, maxLength: props.maxLength, minLength: props.minLength, pattern: props.pattern, autoComplete: props.autoComplete, autoCorrect: props.autoCorrect, autoCapitalize: props.autoCapitalize, inputMode: props.inputMode, readOnly: props.readOnly }, (props.inputProps ? props.inputProps : {}))),
        React__default["default"].createElement(InputError, props)));
});
var InputDefault = React.forwardRef(// not used
function (_a, ref) {
    var label = _a.label, disabled = _a.disabled, className = _a.className, error = _a.error, id = _a.id, name = _a.name, onBlur = _a.onBlur, onChange = _a.onChange, onClick = _a.onClick, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onFocus = _a.onFocus, placeholder = _a.placeholder, value = _a.value, required = _a.required, type = _a.type, min = _a.min, max = _a.max, step = _a.step, maxLength = _a.maxLength, minLength = _a.minLength, pattern = _a.pattern, autoCapitalize = _a.autoCapitalize, autoComplete = _a.autoComplete, autoCorrect = _a.autoCorrect, inputMode = _a.inputMode, readOnly = _a.readOnly;
    var classes = VARIANTS.default;
    var inputClassNames = React.useMemo(function () {
        var _a;
        return classNames__default["default"]((_a = {},
            _a[classes.input.base] = true,
            _a[classes.input.default] = !error && !disabled,
            _a[classes.input.error] = !!error && !disabled,
            _a[classes.input.disabled] = disabled,
            _a[className !== null && className !== void 0 ? className : ''] = true,
            _a));
    }, [error, disabled, className]);
    return (React__default["default"].createElement("input", { "aria-label": label, "aria-invalid": !!error, required: required, id: id, disabled: disabled, className: inputClassNames, name: name, onBlur: onBlur, onChange: onChange, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onClick: onClick, onFocus: onFocus, placeholder: placeholder, value: value, ref: ref, type: type, min: min, max: max, step: step, maxLength: maxLength, minLength: minLength, pattern: pattern, autoComplete: autoComplete, autoCorrect: autoCorrect, autoCapitalize: autoCapitalize, inputMode: inputMode, readOnly: readOnly }));
});
var variants = {
    inside: InputLabelInside,
    outside: InputLabelOutside,
    default: InputDefault,
};
var Input = React.forwardRef(function (_a, ref) {
    var _b;
    var _c = _a.variant, variant = _c === void 0 ? 'outside' : _c, props = __rest(_a, ["variant"]);
    return React__default["default"].createElement((_b = variants[variant]) !== null && _b !== void 0 ? _b : variants.default, __assign(__assign({}, props), { ref: ref }));
});
Input.defaultProps = {
    mode: 'dark',
    type: 'text',
    variant: 'outside',
};
Input.displayName = 'Input';
InputDefault.displayName = 'Input';
InputLabelInside.displayName = 'Input';
InputLabelOutside.displayName = 'Input';

var useClickOutsideHandler = function (ref, callback) {
    var callbackFnRef = React__default["default"].useRef(callback);
    React__default["default"].useEffect(function () {
        var handler = function (event) {
            var _a;
            if (ref.current && !ref.current.contains(event.target)) {
                (_a = callbackFnRef.current) === null || _a === void 0 ? void 0 : _a.call(callbackFnRef, event);
            }
        };
        // Bind the event listener
        document.addEventListener('mouseup', handler);
        document.addEventListener('touchend', handler);
        return function () {
            // Unbind the event listener on clean up
            document.removeEventListener('mouseup', handler);
            document.removeEventListener('touchend', handler);
        };
    }, [ref]);
    React__default["default"].useEffect(function () {
        callbackFnRef.current = callback;
    }, [callback]);
};

/**
 * @param localeName Locale Intl
 * @returns Array of weekdays
 */
var daysOfWeek = function (localeName) {
    var format = new Intl.DateTimeFormat(undefined, { weekday: 'narrow' }).format;
    try {
        format = new Intl.DateTimeFormat(localeName, { weekday: 'narrow' }).format;
        return Array.from({ length: 7 }, function (_, index) { return index; }).map(function (day) {
            return format(new Date(Date.UTC(2021, 5, day)));
        });
    }
    catch (_a) {
        return Array.from({ length: 7 }, function (_, index) { return index; }).map(function (day) {
            return format(new Date(Date.UTC(2021, 5, day)));
        });
    }
};
/**
 * @param date Teh date to search
 * @returns The week number in month of the date
 */
var weekOfDate = function (date) {
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 0).getDay();
    return Math.ceil((firstDay + date.getDate()) / 7);
};
/**
 * Return an object of weekday index with dates array
 * @param date Base date in month and year
 * @returns Object of weekday index with an array of Dates (undefined if a Date is not present in the weekday in the month)
 */
var datesOfMonthAndYear = function (date) {
    var maxWeekNumber = 6;
    var numberOfDay = 7;
    var daysInWeekDay = Array.from({ length: maxWeekNumber }, function () {
        return Array.from({ length: numberOfDay }, function () { return undefined; });
    });
    var baseDate = new Date(date.getFullYear(), date.getMonth(), 1);
    while (baseDate.getMonth() === date.getMonth()) {
        var localDate = new Date(baseDate);
        daysInWeekDay[weekOfDate(localDate) - 1][localDate.getDay() === 0 ? 6 : localDate.getDay() - 1] = localDate;
        baseDate.setDate(localDate.getDate() + 1);
    }
    return daysInWeekDay;
};
/**
 * Test if two dates is the same day
 * @param first First date
 * @param second Second date
 * @returns True if both dates are the same day
 */
var datesAreOnSameDay = function (first, second) {
    return first.getFullYear() === second.getFullYear() &&
        first.getMonth() === second.getMonth() &&
        first.getDate() === second.getDate();
};

var MonthCalendarButton = function (_a) {
    var _b;
    var date = _a.date, selected = _a.selected, onDateClick = _a.onDateClick;
    var isSelected = selected && date ? datesAreOnSameDay(selected, date) : false;
    var buttonClassNames = classNames__default["default"]('user-select-none appearance-none text-sm mb-2 h-6 w-6 rounded-full', (_b = {},
        _b['hover:bg-primary-100 hover:text-primary-700'] = !isSelected,
        _b['bg-primary-100 text-primary-700'] = isSelected,
        _b));
    if (date)
        return (React__default["default"].createElement("button", { onClick: function () {
                onDateClick === null || onDateClick === void 0 ? void 0 : onDateClick(date);
            }, className: buttonClassNames }, date.getDate()));
    return React__default["default"].createElement("div", { className: "mb-2 h-6 w-6" });
};
var MonthCalendar = function (_a) {
    var selected = _a.selected, onDateClick = _a.onDateClick;
    var _b = React.useState(selected !== null && selected !== void 0 ? selected : new Date()), dateView = _b[0], setDateView = _b[1];
    var goPrevious = React.useCallback(function () {
        setDateView(function (current) {
            current.setMonth(current.getMonth() - 1);
            return new Date(current);
        });
    }, []);
    var goNext = React.useCallback(function () {
        setDateView(function (current) {
            current.setMonth(current.getMonth() + 1);
            return new Date(current);
        });
    }, []);
    var selectToday = React.useCallback(function () {
        onDateClick === null || onDateClick === void 0 ? void 0 : onDateClick(new Date());
        setDateView(new Date());
    }, [onDateClick]);
    var dates = React.useMemo(function () { return datesOfMonthAndYear(dateView); }, [dateView]);
    var daysOfWeekStrings = React.useMemo(function () { return daysOfWeek(undefined); }, []);
    return (React__default["default"].createElement("div", { className: "w-60" },
        React__default["default"].createElement("div", { className: "flex flex-col" },
            React__default["default"].createElement("div", { className: "p-2 bg-primary-700 text-white flex items-center justify-between" },
                React__default["default"].createElement(Button, { "aria-label": "Previous", variant: "secondary", onClick: goPrevious },
                    React__default["default"].createElement(Icon, { name: "arrow-left", size: '2xs' })),
                React__default["default"].createElement("div", { className: "text-center my-2" }, dateView
                    .toLocaleDateString(undefined, {
                    month: 'long',
                    year: 'numeric',
                })
                    .toLocaleUpperCase()),
                React__default["default"].createElement(Button, { "aria-label": "Next", variant: "secondary", onClick: goNext },
                    React__default["default"].createElement(Icon, { name: "arrow-right", size: 'xs' })))),
        React__default["default"].createElement("div", { className: "mt-2 mx-2 grid grid-cols-7 gap-2" },
            daysOfWeekStrings.map(function (dayString, dayIndex) { return (React__default["default"].createElement("div", { key: "".concat(dateView.getMonth(), "-weekday-").concat(dayIndex), className: "text-gray-500 text-center" }, dayString)); }),
            dates.map(function (weekDates, weekIndex) { return (React__default["default"].createElement(React.Fragment, { key: "".concat(dateView.getMonth(), "-weekday-").concat(weekIndex) }, weekDates.map(function (date, index) { return (React__default["default"].createElement(MonthCalendarButton, { key: "".concat(dateView.getMonth(), "-day-").concat(index), date: date, selected: selected, onDateClick: onDateClick })); }))); })),
        React__default["default"].createElement("div", { className: "flex mb-2 justify-end" },
            React__default["default"].createElement(Button, { onClick: selectToday, className: "mx-2" }, "Aujourd'hui"))));
};

var DatePicker = React.forwardRef(function (_a, ref) {
    var name = _a.name, value = _a.value, onChange = _a.onChange, onBlur = _a.onBlur, label = _a.label, variant = _a.variant, className = _a.className, disabled = _a.disabled, error = _a.error, required = _a.required;
    if (value && !(value instanceof Date && !Number.isNaN(value))) {
        throw new Error('DatePicker : value should be a Date instance or undefined');
    }
    var _b = React.useState(value === null || value === void 0 ? void 0 : value.toLocaleDateString()), inputValue = _b[0], setInputValue = _b[1];
    var _c = React.useState(false), open = _c[0], setOpen = _c[1];
    var containerRef = React.useRef(null);
    useClickOutsideHandler(containerRef, function () {
        setOpen(false);
    });
    React.useEffect(function () {
        if (value) {
            if (!(value instanceof Date && !Number.isNaN(value))) {
                throw new Error('DatePicker : value should be a Date instance or undefined');
            }
            setInputValue(value.toLocaleDateString());
        }
    }, [value]);
    var handleFocus = React.useCallback(function () {
        if (!disabled)
            setOpen(true);
    }, [disabled]);
    var handleDateClick = React.useCallback(function (newDate) {
        onChange === null || onChange === void 0 ? void 0 : onChange(newDate);
        setOpen(false);
    }, [onChange]);
    var containerClassNames = React.useMemo(function () {
        var _a;
        return classNames__default["default"]((_a = {},
            _a['absolute top-full shadow rounded overflow-hidden z-100 bg-background'] = true,
            _a['sr-only'] = !open,
            _a));
    }, [open]);
    var iconClassNames = React.useMemo(function () {
        return classNames__default["default"]('absolute right-2', {
            'text-gray-400': !error && !open,
            'text-primary-700': !error && open,
            'text-error-600': error,
            'bottom-3': variant && label,
        });
    }, [error, variant, label, open]);
    return (React__default["default"].createElement("div", { ref: containerRef, className: "flex relative items-center" },
        React__default["default"].createElement(Input, { className: className, label: label, variant: variant, onFocus: handleFocus, onBlur: onBlur, name: name, value: inputValue, ref: ref, disabled: disabled, 
            // error={error}
            mode: "dark", required: required }),
        !disabled ? (React__default["default"].createElement(React__default["default"].Fragment, null,
            React__default["default"].createElement(Icon, { name: "calendar", size: '1x', className: iconClassNames }),
            React__default["default"].createElement("div", { className: containerClassNames },
                React__default["default"].createElement(MonthCalendar, { selected: value, onDateClick: handleDateClick })))) : null));
});
DatePicker.displayName = 'DatePicker';

var optionClassNames = {
    base: 'truncate py-3 px-4 cursor-pointer hover:bg-primary-apricot-faded text-md leading-4 text-neutral-pencil',
    default: 'text-foreground',
};
var selectedClassNames = 'tw-font-bold';
var focusedClassNames = 'bg-primary-apricot-light';
var Option = function (_a) {
    var _b;
    var isMulti = _a.isMulti, value = _a.value, option = _a.option, focused = _a.focused, onOptionClick = _a.onOptionClick;
    var isSelected = React.useMemo(function () {
        return isMulti && Array.isArray(value)
            ? value.includes(option.value)
            : option.value === value;
    }, [value, option, isMulti]);
    var isFocused = React.useMemo(function () { return focused === option.value; }, [option, focused]);
    return (React__default["default"].createElement("div", { className: classNames__default["default"]((_b = {},
            _b[optionClassNames.base] = true,
            _b[optionClassNames.default] = !isSelected,
            _b[selectedClassNames] = isSelected && !isFocused,
            _b[focusedClassNames] = isFocused,
            _b)), role: "option", onClick: function (event) { return onOptionClick(option, event); } },
        React__default["default"].createElement("div", { className: "flex items-center" },
            React__default["default"].createElement("span", { className: "flex-grow" }, option.label),
            isMulti && isSelected ? (React__default["default"].createElement(Icon, { name: "check", className: "fill-current h-4 w-4" })) : null)));
};

var optionListClassNames = 'z-100 absolute top-full left-0 rounded-2xl shadow bg-white mt-1 max-h-48 w-full overflow-y-scroll';
var OptionList = function (_a) {
    var _b;
    var focused = _a.focused, isOpen = _a.isOpen, options = _a.options, onOptionClick = _a.onOptionClick, value = _a.value, isMulti = _a.isMulti;
    return (React__default["default"].createElement("div", { className: classNames__default["default"]((_b = {},
            _b[optionListClassNames] = true,
            _b['sr-only'] = !isOpen,
            _b)), role: "listbox" }, options.map(function (option) { return (React__default["default"].createElement(Option, { focused: focused, key: option.value, isMulti: isMulti, option: option, onOptionClick: onOptionClick, value: value })); })));
};
OptionList.displayName = 'OptionList';

var sizes = {
    xs: 4,
    sm: 6,
    md: 8,
    lg: 10,
    xl: 14,
    '2xl': 16,
};
var Loader = function (_a) {
    var _b, _c;
    var _d = _a.size, size = _d === void 0 ? 'md' : _d, _e = _a.color, color = _e === void 0 ? 'primary-800' : _e, _f = _a.className, className = _f === void 0 ? '' : _f;
    return (React__default["default"].createElement("svg", { className: "animate-spin h-".concat((_b = sizes[size]) !== null && _b !== void 0 ? _b : size, " w-").concat((_c = sizes[size]) !== null && _c !== void 0 ? _c : size, " text-").concat(color, " ").concat(className), xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24" },
        React__default["default"].createElement("circle", { className: "opacity-25", cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "4" }),
        React__default["default"].createElement("path", { className: "opacity-75", fill: "currentColor", d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" })));
};

var SelectVariantClassNames = {
    inside: {
        container: {
            loading: 'pointer-events-none cursor-not-allowed',
            base: "border bg-background rounded p-2 flex flex-col outline-none",
            default: 'focus-within:border-primary-apricot text-gray-500 border-gray-300',
            disabled: 'cursor-not-allowed pointer-events-none',
            error: 'text-error-600 border-error-600',
        },
        input: {
            base: 'bg-transparent outline-none h-6 truncate w-full',
            open: 'border-primary-apricot border-2',
            default: 'text-gray-700',
            error: 'text-error-600',
            disabled: 'bg-neutral-notebook'
        },
        label: {
            default: 'text-primary-apricot',
            open: 'text-primary-apricot',
            error: 'text-alert-error',
        },
        valueContainer: {
            base: 'absolute inset-0 outline-none',
            default: 'text-gray-700',
            error: 'text-error-600',
        },
    },
    outside: {
        container: {
            loading: 'pointer-events-none cursor-not-allowed',
            base: "flex flex-col",
            default: 'focus-within:border-primary-apricot text-gray-500',
            disabled: 'cursor-not-allowed pointer-events-none',
            error: 'text-error-600',
        },
        input: {
            base: 'p-4 rounded-2xl border outline-none truncate w-full leading-4 text-md bg-neutral-chalk placeholder-neutral-eraser',
            open: 'border-primary-apricot border-2',
            close: 'border-gray-300',
            default: 'text-gray-700',
            error: 'border-alert-error',
            disabled: 'bg-neutral-notebook'
        },
        label: {
            default: 'text-primary-navyblue',
            open: 'text-primary-apricot',
            error: 'text-alert-error',
            dark: 'text-neutral-whiteboard',
        },
        valueContainer: {
            base: 'absolute top-1/2 left-[16px] transform -translate-y-1/2 outline-none',
            default: 'text-gray-700',
            error: 'text-error-600',
        },
    },
};

var inputContainerClassNames = 'relative';
var KEYS = {
    ArrowDown: 'ArrowDown',
    ArrowUp: 'ArrowUp',
    Tab: 'Tab',
    Escape: 'Escape',
    Enter: 'Enter',
};
var filterOptions = function (_a) {
    var options = _a.options, search = _a.search;
    return options.filter(function (option) {
        return option.label.toLowerCase().includes(search.toLowerCase());
    });
};
var Select = React.forwardRef(function (_a, ref) {
    var _b;
    var ariaLabel = _a["aria-label"], className = _a.className, id = _a.id, name = _a.name, _c = _a.options, options = _c === void 0 ? [] : _c, placeholder = _a.placeholder, onChange = _a.onChange, isMulti = _a.isMulti, _d = _a.value, value = _d === void 0 ? isMulti ? [] : undefined : _d, disabled = _a.disabled, label = _a.label, _e = _a.variant, variant = _e === void 0 ? 'outside' : _e, tabIndex = _a.tabIndex, isLoading = _a.isLoading, isSearchable = _a.isSearchable, error = _a.error, required = _a.required, _f = _a.darkMode, darkMode = _f === void 0 ? true : _f, // the default will be the dark mode
    errorMsg = _a.errorMsg, _g = _a.width, width = _g === void 0 ? '100%' : _g;
    var _h = React.useState(false), isOpen = _h[0], setOpen = _h[1];
    var _j = React.useState(''), search = _j[0], setSearch = _j[1];
    var _k = React.useState((_b = options[0]) === null || _b === void 0 ? void 0 : _b.value), focused = _k[0], setFocused = _k[1];
    var containerRef = React.useRef(null);
    useClickOutsideHandler(containerRef, function () {
        setOpen(false);
        setSearch('');
    });
    var filteredOptions = React.useMemo(function () {
        return search.length === 0 ? options : filterOptions({ options: options, search: search });
    }, [isSearchable, options, search, filterOptions]);
    var handleOpen = React.useCallback(function () {
        if (!disabled) {
            setOpen(true);
        }
    }, [disabled]);
    // Click an option change the value only
    var handleClickForMulti = React.useCallback(function (option) {
        if (!value || !Array.isArray(value)) {
            onChange === null || onChange === void 0 ? void 0 : onChange([option.value]);
            return;
        }
        var index = value.findIndex(function (v) { return v === option.value; });
        // Handle if we click on an option which is already in value
        if (index > -1) {
            var tmp = __spreadArray([], value, true);
            tmp.splice(index, 1);
            onChange === null || onChange === void 0 ? void 0 : onChange(__spreadArray([], tmp, true));
        }
        else {
            onChange === null || onChange === void 0 ? void 0 : onChange(__spreadArray(__spreadArray([], value, true), [option.value], false));
        }
        setSearch('');
    }, [onChange, value]);
    // Click an option change search and value then close the options
    var handleClickForSingle = React.useCallback(function (option) {
        onChange === null || onChange === void 0 ? void 0 : onChange(option.value);
        setSearch('');
        setOpen(false);
    }, [onChange]);
    var handleKeyDown = React.useCallback(function (event) {
        if (!isOpen) {
            if (event.key === KEYS.ArrowDown)
                handleOpen();
        }
        else if ([
            KEYS.ArrowDown,
            KEYS.ArrowUp,
            KEYS.Enter,
            KEYS.Tab,
            KEYS.Escape,
        ].includes(event.key)) {
            event.stopPropagation();
            switch (event.key) {
                case KEYS.Tab:
                case KEYS.Escape:
                    setOpen(false);
                    break;
                case KEYS.ArrowUp:
                    {
                        var index_1 = filteredOptions.findIndex(function (option) { return option.value === focused; });
                        setFocused(function (current) { var _a, _b; return (_b = (_a = filteredOptions[index_1 - 1]) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : current; });
                    }
                    break;
                case KEYS.ArrowDown:
                    if (!isOpen) {
                        handleOpen();
                        setFocused(filteredOptions[0].value);
                    }
                    else {
                        var index_2 = filteredOptions.findIndex(function (option) { return option.value === focused; });
                        setFocused(function (current) { var _a, _b; return (_b = (_a = filteredOptions[index_2 + 1]) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : current; });
                    }
                    break;
                case KEYS.Enter: {
                    var optionSelected = filteredOptions.find(function (option) { return option.value === focused; });
                    if (optionSelected) {
                        isMulti
                            ? handleClickForMulti(optionSelected)
                            : handleClickForSingle(optionSelected);
                    }
                    break;
                }
            }
        }
    }, [
        isOpen,
        filteredOptions,
        handleClickForMulti,
        handleClickForMulti,
        focused,
        handleOpen,
    ]);
    var handleInputChange = React.useCallback(function (event) {
        var _a;
        setSearch((_a = event.target.value) !== null && _a !== void 0 ? _a : '');
        handleOpen();
    }, [handleOpen]);
    var handleInputKeyPress = React.useCallback(function (event) {
        if ([KEYS.Enter].includes(event.key)) {
            event.preventDefault();
        }
    }, []);
    var containerClassNames = React.useMemo(function () {
        var _a;
        var _b;
        var container = ((_b = SelectVariantClassNames[variant]) !== null && _b !== void 0 ? _b : SelectVariantClassNames.inside).container;
        return classNames__default["default"](container.base, (_a = {},
            _a[container.error] = !!error && !disabled,
            _a[container.disabled] = disabled,
            _a[container.loading] = isLoading,
            _a[container.default] = !disabled && !error,
            _a[container.opened] = isOpen && !disabled && !error,
            _a[className !== null && className !== void 0 ? className : ''] = true,
            _a));
    }, [disabled, error, variant, className, isLoading, isOpen, width]);
    var inputClassNames = React.useMemo(function () {
        var _a;
        var _b;
        var inputClasses = ((_b = SelectVariantClassNames[variant]) !== null && _b !== void 0 ? _b : SelectVariantClassNames.inside).input;
        return classNames__default["default"](inputClasses.base, (_a = {},
            _a[inputClasses.disabled] = disabled,
            _a[inputClasses.open] = !error && isOpen && variant === 'outside',
            _a[inputClasses.close] = !error && !isOpen && variant === 'outside',
            _a[inputClasses.default] = !disabled && !error,
            _a[inputClasses.error] = error && !disabled,
            _a));
    }, [disabled, error, label, variant, isOpen]);
    var chevronClassNames = React.useMemo(function () {
        return classNames__default["default"]('fill-current absolute top-1/2 transform -translate-y-1/2 right-4 w-3', variant === 'inside' ? 'top-1' : '', {
            'text-primary-apricot': isOpen && !error,
            'text-gray-300': !error && !isOpen,
            'text-alert-error': error,
        });
    }, [error, isOpen, variant]);
    var labelClassNames = React.useMemo(function () {
        var _a;
        var _b;
        var labelClasses = ((_b = SelectVariantClassNames[variant]) !== null && _b !== void 0 ? _b : SelectVariantClassNames.inside).label;
        return classNames__default["default"]('text-md font-medium leading-4 mb-2', (_a = {},
            _a[labelClasses.error] = !!error && !disabled,
            _a[labelClasses.disabled] = disabled,
            _a[labelClasses.open] = isOpen,
            _a[labelClasses.default] = !disabled && !error && !isOpen && !darkMode,
            _a[labelClasses.dark] = !error && !isOpen && darkMode,
            _a));
    }, [disabled, error, variant, isOpen, darkMode]);
    var searchClassNames = React.useMemo(function () {
        var _a;
        var _b;
        var valueContainer = ((_b = SelectVariantClassNames[variant]) !== null && _b !== void 0 ? _b : SelectVariantClassNames.inside).valueContainer;
        return classNames__default["default"](valueContainer.base, (_a = {},
            _a[valueContainer.default] = !disabled && !error,
            _a[valueContainer.error] = !disabled && !!error,
            _a['bg-transparent'] = search.length === 0,
            _a));
    }, [variant, disabled, error, search]);
    var valueRender = React.useMemo(function () {
        var _a;
        return Array.isArray(value)
            ? options
                .filter(function (option) { return value.includes(option.value); })
                .map(function (option) { return option.label; })
                .join(', ')
            : (_a = options.find(function (option) { return value === option.value; })) === null || _a === void 0 ? void 0 : _a.label;
    }, [options, value]);
    // When value change, change the focus
    React.useEffect(function () {
        setFocused(function (current) {
            var _a, _b;
            if (current)
                return current;
            var selected = value
                ? options.find(function (option) {
                    if (Array.isArray(value)) {
                        return option.value === value[value.length - 1];
                    }
                    return option.value === value;
                })
                : options[0];
            return (_a = selected === null || selected === void 0 ? void 0 : selected.value) !== null && _a !== void 0 ? _a : (_b = options[0]) === null || _b === void 0 ? void 0 : _b.value;
        });
    }, [value, options]);
    // Set focus
    React.useEffect(function () {
        var _a;
        if (!focused && filteredOptions.length > 0)
            setFocused(filteredOptions[0].value);
        if (!filteredOptions.find(function (option) { return option.value === focused; })) {
            setFocused((_a = filteredOptions[0]) === null || _a === void 0 ? void 0 : _a.value);
        }
    }, [focused, filteredOptions]);
    return (React__default["default"].createElement("label", { htmlFor: id, "aria-disabled": disabled, className: containerClassNames, style: width ? { width: width } : {}, onKeyDown: handleKeyDown, onClick: handleOpen, "aria-expanded": isOpen, "aria-invalid": required && !value, ref: containerRef },
        React__default["default"].createElement("span", { className: labelClassNames }, label),
        React__default["default"].createElement("div", { "aria-expanded": isOpen, className: inputContainerClassNames },
            React__default["default"].createElement("input", { name: name, role: "combobox", className: inputClassNames, disabled: disabled, onKeyPress: handleInputKeyPress, "aria-label": ariaLabel, placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : 'Select...', type: "text", readOnly: true, id: id, tabIndex: tabIndex, ref: ref, value: valueRender !== null && valueRender !== void 0 ? valueRender : '', "aria-haspopup": "listbox" }),
            isSearchable && !disabled ? (React__default["default"].createElement("input", { autoComplete: "off", type: "text", onChange: handleInputChange, onKeyPress: handleInputKeyPress, value: search, className: searchClassNames })) : null,
            isLoading || filteredOptions.length === 0 ? null : (React__default["default"].createElement(OptionList, { isMulti: isMulti, isOpen: isOpen, options: filteredOptions, value: value, focused: focused, onOptionClick: function (option, event) {
                    event.preventDefault();
                    event.stopPropagation();
                    isMulti
                        ? handleClickForMulti(option)
                        : handleClickForSingle(option);
                } })),
            isLoading ? (React__default["default"].createElement(Loader, { className: "mx-1", size: "sm", color: "primary-800" })) : (React__default["default"].createElement(Icon, { name: "caret-down", className: chevronClassNames })),
            error ? (React__default["default"].createElement("div", { className: 'text-alert-error text-sm absolute' }, errorMsg !== null && errorMsg !== void 0 ? errorMsg : 'There is an error that relates to this field.')) : null)));
});
Select.displayName = 'Select';

var TableBody = function (_a, ref) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React__default["default"].createElement("tbody", __assign({ ref: ref }, props), children));
};
var TableBody$1 = React__default["default"].forwardRef(TableBody);

var TableHead = function (_a) {
    var columns = _a.columns, children = _a.children, props = __rest(_a, ["columns", "children"]);
    if (columns)
        return (React__default["default"].createElement("thead", __assign({}, props),
            React__default["default"].createElement("tr", { className: "table-head-row" }, columns.map(function (column) { return (React__default["default"].createElement("th", { className: ['table-head', column.className].join(' '), key: column.name }, column.name)); }))));
    return React__default["default"].createElement("thead", __assign({}, props), children);
};

var TableHeadCell = function (_a) {
    var children = _a.children, className = _a.className, sortable = _a.sortable, sort = _a.sort, onSort = _a.onSort, onClick = _a.onClick, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, props = __rest(_a, ["children", "className", "sortable", "sort", "onSort", "onClick", "onMouseEnter", "onMouseLeave"]);
    var isCurrentSort = (sort === null || sort === void 0 ? void 0 : sort.field) === sortable;
    var _b = React__default["default"].useState(false), isHover = _b[0], setIsHover = _b[1];
    return (React__default["default"].createElement("th", __assign({ onMouseEnter: function (e) {
            onMouseEnter === null || onMouseEnter === void 0 ? void 0 : onMouseEnter(e);
            setIsHover(true);
        }, onMouseLeave: function (e) {
            onMouseLeave === null || onMouseLeave === void 0 ? void 0 : onMouseLeave(e);
            setIsHover(false);
        }, className: [
            'table-head',
            sortable ? 'cursor-pointer relative' : '',
            className,
        ].join(' '), onClick: function (event) {
            if (sortable) {
                onSort === null || onSort === void 0 ? void 0 : onSort(sortable, isCurrentSort && (!(sort === null || sort === void 0 ? void 0 : sort.order) || (sort === null || sort === void 0 ? void 0 : sort.order) === 'asc')
                    ? 'desc'
                    : 'asc');
            }
            onClick === null || onClick === void 0 ? void 0 : onClick(event);
        } }, props), sortable ? (React__default["default"].createElement("div", { className: "table-head-cell" },
        React__default["default"].createElement("span", null, children),
        isCurrentSort ? (React__default["default"].createElement(Icon, { size: '1x', className: "m-1", name: (sort === null || sort === void 0 ? void 0 : sort.order) === 'asc' ? 'sort-ascending' : 'sort-descending' })) : (React__default["default"].createElement(Icon, { size: '1x', className: ['m-1', !isHover ? 'opacity-0' : undefined].join(' '), name: "sort-ascending" })))) : (children)));
};

var TableRow = function (_a, ref) {
    var children = _a.children, hoverable = _a.hoverable, className = _a.className, props = __rest(_a, ["children", "hoverable", "className"]);
    return (React__default["default"].createElement("tr", __assign({ ref: ref, className: [
            'table-body-row',
            hoverable ? 'hoverable' : undefined,
            className,
        ].join(' ') }, props), children));
};
var TableRow$1 = React__default["default"].forwardRef(TableRow);

var Table = function (_a) {
    var children = _a.children, className = _a.className, props = __rest(_a, ["children", "className"]);
    return (React__default["default"].createElement("table", __assign({ className: ['table-container', className].join(' ') }, props), children));
};
Table.Head = TableHead;
Table.HeadCell = TableHeadCell;
Table.Body = TableBody$1;
Table.Row = TableRow$1;
var TableCell = function (_a, ref) {
    var children = _a.children, className = _a.className, props = __rest(_a, ["children", "className"]);
    return (React__default["default"].createElement("td", __assign({ ref: ref, className: [className].join(' ') }, props), children));
};
Table.Cell = React__default["default"].forwardRef(TableCell);

var ProgressBar = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 50 : _b, _c = _a.height, height = _c === void 0 ? '10px' : _c, _d = _a.progressColor, progressColor = _d === void 0 ? 'bg-primary-500' : _d, _e = _a.backgroundColor, backgroundColor = _e === void 0 ? 'bg-gray-200' : _e, _f = _a.icon, icon = _f === void 0 ? undefined : _f, _g = _a.iconSize, iconSize = _g === void 0 ? undefined : _g, _h = _a.breakPoint, breakPoint = _h === void 0 ? undefined : _h;
    var calculateBreakPositions = function (total, breakpoint) {
        if (breakpoint === void 0) { breakpoint = 10; }
        var breakPositions = [];
        for (var i = 1; i < breakpoint; i += 1) {
            breakPositions.push((i / breakpoint) * total);
        }
        return breakPositions;
    };
    return (React__default["default"].createElement("div", { className: 'w-full relative rounded-full dark:bg-gray-700 ' + backgroundColor, style: { height: height } },
        React__default["default"].createElement("div", { className: 'relative rounded-full transition-all ease-in-out duration-1000 ' +
                progressColor, style: { width: width + '%', height: height } }),
        breakPoint !== undefined &&
            breakPoint.section > 0 &&
            calculateBreakPositions(100, breakPoint.section).map(function (position) { return (React__default["default"].createElement("div", { key: position, style: {
                    top: '0',
                    position: 'absolute',
                    left: "".concat(position, "%"),
                    width: breakPoint.width || '4px',
                    height: '100%',
                }, className: "".concat(breakPoint.color || 'bg-white') })); }),
        icon && iconSize && (React__default["default"].createElement("div", { className: "rounded-full absolute transition-all ease-in-out duration-1000", style: {
                left: "calc(".concat(width, "% - ").concat(iconSize.width, "px / 2)"),
                top: "-".concat((iconSize.height - parseInt(height)) / 2, "px"),
            } }, icon))));
};

var FilterSelection = /** @class */ (function (_super) {
    __extends(FilterSelection, _super);
    function FilterSelection(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSelection = _this.handleSelection.bind(_this);
        return _this;
    }
    FilterSelection.prototype.handleSelection = function (e, value) {
        e.stopPropagation();
        this.props.setSelected(value);
    };
    FilterSelection.prototype.render = function () {
        var _this = this;
        var _a;
        return (React__default["default"].createElement("div", { className: (_a = 'absolute top-14 left-0 w-full bg-primary-navyblue-dim border border-neutral-chalk rounded-lg max-h-48 overflow-auto p-2 min-w-[180px] ' +
                this.props.classNameOption) !== null && _a !== void 0 ? _a : '' }, this.props.options.map(function (option) {
            return (React__default["default"].createElement("div", { className: 'p-2 hover:bg-primary-neptune leading-5 rounded-lg', onClick: function (e) { return _this.handleSelection(e, option.value); }, key: option.value }, option.label));
        })));
    };
    return FilterSelection;
}(React__default["default"].Component));

var DropdownFilter = React.forwardRef(function (_a, ref) {
    var _b, _c;
    var options = _a.options, selected = _a.selected, setSelected = _a.setSelected, label = _a.label, width = _a.width, classNameBase = _a.classNameBase, classNameLabel = _a.classNameLabel, classNameOption = _a.classNameOption;
    var _d = React.useState(false), openSelection = _d[0], setOpenSelection = _d[1];
    var containerRef = React.useRef(null);
    useClickOutsideHandler(containerRef, function () {
        setOpenSelection(false);
    });
    React.useImperativeHandle(ref, function () { return containerRef.current; });
    function handleChangeSelection(value) {
        setSelected(value);
        setOpenSelection(false);
    }
    function handleToggleOpen(e) {
        setOpenSelection(function (state) { return !state; });
        e.preventDefault();
    }
    var selectedObject = options.find(function (item) {
        return item.value === selected;
    });
    return (React__default["default"].createElement("div", { ref: containerRef, className: (_b = 'cursor-pointer bg-primary-navyblue-dim border border-neutral-chalk rounded-lg py-3 px-4 flex relative text-neutral-chalk ' +
            classNameBase) !== null && _b !== void 0 ? _b : '', style: { width: width }, onClick: handleToggleOpen },
        React__default["default"].createElement("div", { className: (_c = 'flex-auto ' + classNameLabel) !== null && _c !== void 0 ? _c : '' },
            React__default["default"].createElement("span", { className: 'font-bold' }, label ? label + ': ' : ''),
            React__default["default"].createElement("span", null, selectedObject === null || selectedObject === void 0 ? void 0 : selectedObject.label)),
        React__default["default"].createElement("div", { className: 'ml-2 flex-initial w-2.5 self-center' },
            React__default["default"].createElement(Icon, { name: "caret-down", className: 'fill-current text-primary-apricot transition-all ' +
                    (openSelection ? 'rotate-180' : '') })),
        openSelection ? (React__default["default"].createElement(FilterSelection, { options: options, setSelected: handleChangeSelection, classNameOption: classNameOption })) : null));
});
DropdownFilter.defaultProps = {
    width: '100%',
};

var Snackbar = function (_a) {
    _a.children; var states = _a.states; _a.views; var message = _a.message, buttonText = _a.buttonText, onTextClick = _a.onTextClick, className = _a.className; __rest(_a, ["children", "states", "views", "message", "buttonText", "onTextClick", "className"]);
    var iconStates = function (iconStates) {
        if (iconStates === 'celebratory') {
            return React__default["default"].createElement(Icon, { name: "circle-check", className: "icon neutral" });
        }
        if (iconStates === 'warning') {
            return React__default["default"].createElement(Icon, { name: "exclamation-triangle", className: "icon warning" });
        }
        if (iconStates === 'error') {
            return React__default["default"].createElement(Icon, { name: "exclamation-triangle", className: "icon neutral" });
        }
        if (iconStates === 'delete') {
            return React__default["default"].createElement(Icon, { name: "trash", className: 'icon neutral' });
        }
        return React__default["default"].createElement(Icon, { name: "circle-check", className: "icon neutral" });
    };
    var textButtonStates = function (textStates) {
        if (textStates !== '') {
            return (React__default["default"].createElement(React__default["default"].Fragment, null,
                React__default["default"].createElement("div", { className: "message-button cursor-pointer ".concat(states === 'warning' ? 'warning' : 'neutral') },
                    React__default["default"].createElement("span", { onClick: onTextClick }, buttonText))));
        }
        return null;
    };
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement("div", { className: "snackbar ".concat(states, " ").concat(className) },
            React__default["default"].createElement("div", { className: "flex" },
                states !== 'neutral' ? (React__default["default"].createElement("div", { className: 'icon-container' }, iconStates(states))) : null,
                React__default["default"].createElement("div", { className: "max-w-full" },
                    React__default["default"].createElement("div", { className: "float-left" },
                        React__default["default"].createElement("div", { className: "message ".concat(states), dangerouslySetInnerHTML: { __html: message } })),
                    React__default["default"].createElement("div", { className: "float-right" }, textButtonStates(buttonText)))))));
};

var Breadcrumb = function (_a) {
    var items = _a.items, _b = _a.icon, icon = _b === void 0 ? 'grid' : _b, _c = _a.className, className = _c === void 0 ? '' : _c;
    var iconClassName = 'breadcrumb-icon';
    return items.length > 0 ? (React__default["default"].createElement("div", { className: 'breadcrumb-container ' + className },
        React__default["default"].createElement("div", { className: 'breadcrumb-item breadcrumb-first-item' +
                (items[0].onClick ? ' pointer' : '') +
                (items[0].disabled ? ' disabled' : ''), onClick: items[0].onClick ? items[0].onClick : function () { } },
            icon === 'grid' && (React__default["default"].createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 448 512", className: iconClassName },
                React__default["default"].createElement("path", { d: "M0 72C0 49.9 17.9 32 40 32H88c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40V72zM0 232c0-22.1 17.9-40 40-40H88c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40V232zM128 392v48c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40V392c0-22.1 17.9-40 40-40H88c22.1 0 40 17.9 40 40zM160 72c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V72zM288 232v48c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V232c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40zM160 392c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V392zM448 72v48c0 22.1-17.9 40-40 40H360c-22.1 0-40-17.9-40-40V72c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40zM320 232c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H360c-22.1 0-40-17.9-40-40V232zM448 392v48c0 22.1-17.9 40-40 40H360c-22.1 0-40-17.9-40-40V392c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40z" }))),
            icon === 'house' && (React__default["default"].createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 576 512", className: iconClassName },
                React__default["default"].createElement("path", { d: "M295.5 13.7L280 .5 264.5 13.7 .5 237.7l31.1 36.6L56 253.5V488v24H80 480h24V488 253.5l24.5 20.8 31.1-36.6-264-224zM104 464V212.8L280 63.5 456 212.8V464H376V296 272H352 208 184v24V464H104zm128 0V320h96V464H232z" }))),
            icon === 'arrow-left' && (React__default["default"].createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 320 512", className: iconClassName },
                React__default["default"].createElement("path", { d: "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z" }))),
            React__default["default"].createElement("label", null, items[0].title),
            items.length > 1 ? (React__default["default"].createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 320 512", className: "breadcrumb-chevron-right" },
                React__default["default"].createElement("path", { d: "M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z" }))) : ('')),
        items.map(function (item, index) {
            return index > 0 ? (React__default["default"].createElement("div", { className: 'breadcrumb-item' +
                    (item.onClick ? ' pointer' : '') +
                    (item.disabled ? ' disabled' : ''), onClick: item.onClick ? item.onClick : function () { }, key: index },
                index !== 0 ? (React__default["default"].createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 320 512", className: "breadcrumb-chevron-left" },
                    React__default["default"].createElement("path", { d: "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z" }))) : (''),
                React__default["default"].createElement("label", null, item.title),
                index !== items.length - 1 ? (React__default["default"].createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 320 512", className: "breadcrumb-chevron-right" },
                    React__default["default"].createElement("path", { d: "M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z" }))) : (''))) : ('');
        }))) : (React__default["default"].createElement(React__default["default"].Fragment, null));
};

var Sheet = function (_a) {
    var children = _a.children, isOpen = _a.isOpen, toggleSheet = _a.toggleSheet, _b = _a.closeHeight, closeHeight = _b === void 0 ? '10%' : _b, _c = _a.openHeight, openHeight = _c === void 0 ? 'auto' : _c, // will follow the content height
    _d = _a.darkMode, // will follow the content height
    darkMode = _d === void 0 ? true : _d, _e = _a.zIndex, zIndex = _e === void 0 ? 1 : _e, _f = _a.width, width = _f === void 0 ? '100%' : _f, _g = _a.className, className = _g === void 0 ? '' : _g, footer = _a.footer, _h = _a.showFooterOnClose, showFooterOnClose = _h === void 0 ? false : _h, _j = _a.footerClasses, footerClasses = _j === void 0 ? '' : _j;
    var sheetContainerRef = React.useRef(null);
    var bottomSheetClass = [];
    bottomSheetClass.push(darkMode ? 'bg-primary-navyblue-shade' : 'bg-neutral-chalk');
    var bottomSheetStyle = {};
    bottomSheetStyle.height = !isOpen ? closeHeight : openHeight;
    bottomSheetStyle.zIndex = zIndex + 1;
    bottomSheetStyle.width = width;
    bottomSheetStyle.maxHeight = '80%';
    var handlerClass = [
        darkMode ? 'bg-primary-navyblue-bright' : 'bg-neutral-sketchbook',
    ];
    var _k = React.useState(0), initialHeight = _k[0], setInitialHeight = _k[1];
    function handleDragInitial(event, data) {
        var element = sheetContainerRef.current;
        if (element) {
            setInitialHeight(element.offsetHeight);
        }
    }
    function handleDrag(event, data) {
        // prevent flickering of drag event with set timeout
        setTimeout(function () {
            var element = sheetContainerRef.current;
            var yDiff = data.lastY;
            if (element) {
                element.style.height = initialHeight - yDiff + 'px';
            }
        }, 0);
    }
    function handleDragEnd(event, data) {
        setTimeout(function () {
            var threshold = 20;
            var yDiff = data.lastY;
            // if the pan action is below threshold, it will be considered as a click action, and it will toggle the sheet.
            // if it is above threshold, then check the direction of the pan action
            if (Math.abs(yDiff) > threshold) {
                if (isOpen && yDiff > 0) {
                    toggleSheet();
                }
                else if (!isOpen && yDiff < 0) {
                    toggleSheet();
                }
                else {
                    resetWidth();
                }
            }
            else {
                toggleSheet();
            }
        }, 150);
    }
    function resetWidth() {
        var element = sheetContainerRef.current;
        if (element) {
            element.style.height = isOpen ? openHeight : closeHeight;
        }
    }
    var shouldShowFooter = showFooterOnClose === undefined ? isOpen : showFooterOnClose ? true : isOpen;
    return (React__default["default"].createElement("div", { className: 'w-full fixed bottom-0 left-0 bg-black/50 transition-all', style: { zIndex: zIndex, height: isOpen ? '100%' : '0' } },
        React__default["default"].createElement("div", { className: 'fixed flex flex-col bottom-0 left-1/2 overflow-scroll rounded-t-2xl transition-all -translate-x-1/2 ' +
                bottomSheetClass.join(' ') +
                ' ' +
                className, style: bottomSheetStyle, id: 'sheetContainer' },
            React__default["default"].createElement("div", { className: 'py-2 w-full relative' },
                React__default["default"].createElement(reactDraggable.DraggableCore, { onStart: handleDragInitial, onDrag: handleDrag, onStop: handleDragEnd },
                    React__default["default"].createElement("div", { className: 'shadow-div w-full absolute left-0 top-0 h-[60px] cursor-pointer' })),
                React__default["default"].createElement("div", { className: 'h-[6px] w-[77px] mx-auto rounded-full cursor-pointer ' +
                        handlerClass.join(' '), id: 'sheetHandler' })),
            React__default["default"].createElement("div", { className: 'h-full ' + (isOpen ? 'overflow-y-scroll' : 'overflow-hidden') }, children),
            shouldShowFooter && footer && (React__default["default"].createElement("div", { className: "mt-auto text-white px-4 ".concat(footerClasses) }, footer)))));
};

var Scrim = /** @class */ (function (_super) {
    __extends(Scrim, _super);
    function Scrim(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }
    Scrim.prototype.handleClick = function (e) {
        e.stopPropagation();
        this.props.onClose();
    };
    Scrim.prototype.componentDidMount = function () {
        if (this.props.disableBodyScroll) {
            document.body.style.overflow = 'hidden';
        }
    };
    Scrim.prototype.componentWillUnmount = function () {
        if (this.props.disableBodyScroll) {
            document.body.style.overflow = 'auto';
        }
    };
    Scrim.prototype.render = function () {
        return (React__default["default"].createElement("div", { onClick: this.handleClick, className: 'fixed w-full h-full top-0 left-0 z-100 bg-black/50' },
            React__default["default"].createElement("div", { onClick: function (e) { e.stopPropagation(); } }, this.props.children)));
    };
    Scrim.defaultProps = {
        disableBodyScroll: true
    };
    return Scrim;
}(React__default["default"].Component));

var PopUp = /** @class */ (function (_super) {
    __extends(PopUp, _super);
    function PopUp(props) {
        var _this = _super.call(this, props) || this;
        _this.parseStyle = _this.parseStyle.bind(_this);
        return _this;
    }
    PopUp.prototype.render = function () {
        var style = this.parseStyle();
        return (React__default["default"].createElement(Scrim, { onClose: this.props.onClose, disableBodyScroll: this.props.disableBodyScroll },
            React__default["default"].createElement("div", { className: "popup-container px-12 pt-12 pb-8 rounded-2xl w-11/12 text-center fixed top-1/2 left-1/2 transform -translate-y-1/2 -translate-x-1/2 bg-white overflow-auto max-w-[560px] min-w-[286px] max-h-[96vh] shadow " +
                    this.props.className, style: style ? style : {} },
                this.props.img ? (typeof this.props.img === 'string' ? (React__default["default"].createElement("img", { src: this.props.img, className: "popup-image block mx-auto mb-4 ".concat(this.props.imgFullwidth ? '' : 'max-w-[65%]'), alt: '' })) : (this.props.img)) : null,
                React__default["default"].createElement("div", { className: 'popup-title font-bold mb-4 max-md:text-md text-xl leading-6 text-primary-navyblue' }, this.props.title),
                React__default["default"].createElement("div", { className: 'popup-desc text-base mb-4 text-neutral-pencil leading-6' }, this.props.description),
                React__default["default"].createElement("div", { className: "popup-button-container" }, this.props.buttonGroup))));
    };
    PopUp.prototype.parseStyle = function () {
        var style = null;
        if (this.props.width) {
            style = {
                width: this.props.width,
            };
        }
        return style;
    };
    PopUp.defaultProps = {
        disableBodyScroll: true,
    };
    return PopUp;
}(React__default["default"].Component));

var v$2 = "5.9.0";
var fr$2 = 30;
var ip$2 = 0;
var op$2 = 72;
var w$2 = 1080;
var h$2 = 1080;
var nm$2 = "Rocket";
var ddd$2 = 0;
var assets$2 = [
];
var layers$2 = [
	{
		ddd: 0,
		ind: 1,
		ty: 4,
		nm: "Line Outlines",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 45,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.833,
							y: 0.833
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 0,
						s: [
							509.32,
							281.518,
							0
						],
						to: [
							-6.128,
							6.128,
							0
						],
						ti: [
							6.128,
							-6.128,
							0
						]
					},
					{
						t: 11,
						s: [
							472.55,
							318.287,
							0
						]
					}
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					3,
					144.472,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										3,
										3
									],
									[
										3,
										285.944
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 8,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 4,
							s: [
								0
							]
						},
						{
							t: 11,
							s: [
								100
							]
						}
					],
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 0,
							s: [
								0
							]
						},
						{
							t: 7,
							s: [
								100
							]
						}
					],
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 0,
		op: 11,
		st: 4,
		bm: 0
	},
	{
		ddd: 0,
		ind: 2,
		ty: 4,
		nm: "Line Outlines 2",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 45,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.833,
							y: 0.833
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 5,
						s: [
							700.239,
							628,
							0
						],
						to: [
							-6.128,
							6.128,
							0
						],
						ti: [
							6.128,
							-6.128,
							0
						]
					},
					{
						t: 16,
						s: [
							663.469,
							664.77,
							0
						]
					}
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					3,
					144.472,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										3,
										3
									],
									[
										3,
										285.944
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 8,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 9,
							s: [
								0
							]
						},
						{
							t: 16,
							s: [
								100
							]
						}
					],
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 5,
							s: [
								0
							]
						},
						{
							t: 12,
							s: [
								100
							]
						}
					],
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 5,
		op: 16,
		st: 9,
		bm: 0
	},
	{
		ddd: 0,
		ind: 3,
		ty: 4,
		nm: "Line Outlines 3",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 45,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.833,
							y: 0.833
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 10,
						s: [
							580.031,
							278.689,
							0
						],
						to: [
							-6.128,
							6.128,
							0
						],
						ti: [
							6.128,
							-6.128,
							0
						]
					},
					{
						t: 21,
						s: [
							543.261,
							315.459,
							0
						]
					}
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					3,
					144.472,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										3,
										3
									],
									[
										3,
										285.944
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 8,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 14,
							s: [
								0
							]
						},
						{
							t: 21,
							s: [
								100
							]
						}
					],
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 10,
							s: [
								0
							]
						},
						{
							t: 17,
							s: [
								100
							]
						}
					],
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 10,
		op: 21,
		st: 14,
		bm: 0
	},
	{
		ddd: 0,
		ind: 4,
		ty: 4,
		nm: "Line Outlines 4",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 45,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.833,
							y: 0.833
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 13,
						s: [
							531.947,
							759.522,
							0
						],
						to: [
							-6.128,
							6.128,
							0
						],
						ti: [
							6.128,
							-6.128,
							0
						]
					},
					{
						t: 24,
						s: [
							495.178,
							796.291,
							0
						]
					}
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					3,
					144.472,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										3,
										3
									],
									[
										3,
										285.944
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 8,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 17,
							s: [
								0
							]
						},
						{
							t: 24,
							s: [
								100
							]
						}
					],
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 13,
							s: [
								0
							]
						},
						{
							t: 20,
							s: [
								100
							]
						}
					],
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 13,
		op: 24,
		st: 17,
		bm: 0
	},
	{
		ddd: 0,
		ind: 5,
		ty: 4,
		nm: "Line Outlines 5",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 45,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.833,
							y: 0.833
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 18,
						s: [
							700.239,
							653.456,
							0
						],
						to: [
							-6.128,
							6.128,
							0
						],
						ti: [
							6.128,
							-6.128,
							0
						]
					},
					{
						t: 29,
						s: [
							663.469,
							690.225,
							0
						]
					}
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					3,
					144.472,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										3,
										3
									],
									[
										3,
										285.944
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 8,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 22,
							s: [
								0
							]
						},
						{
							t: 29,
							s: [
								100
							]
						}
					],
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 18,
							s: [
								0
							]
						},
						{
							t: 25,
							s: [
								100
							]
						}
					],
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 18,
		op: 29,
		st: 22,
		bm: 0
	},
	{
		ddd: 0,
		ind: 6,
		ty: 4,
		nm: "Line Outlines 10",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 45,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.833,
							y: 0.833
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 24,
						s: [
							509.32,
							281.518,
							0
						],
						to: [
							-6.128,
							6.128,
							0
						],
						ti: [
							6.128,
							-6.128,
							0
						]
					},
					{
						t: 35,
						s: [
							472.55,
							318.287,
							0
						]
					}
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					3,
					144.472,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										3,
										3
									],
									[
										3,
										285.944
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 8,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 28,
							s: [
								0
							]
						},
						{
							t: 35,
							s: [
								100
							]
						}
					],
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 24,
							s: [
								0
							]
						},
						{
							t: 31,
							s: [
								100
							]
						}
					],
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 24,
		op: 35,
		st: 28,
		bm: 0
	},
	{
		ddd: 0,
		ind: 7,
		ty: 4,
		nm: "Line Outlines 9",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 45,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.833,
							y: 0.833
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 29,
						s: [
							560.232,
							793.463,
							0
						],
						to: [
							-6.128,
							6.128,
							0
						],
						ti: [
							6.128,
							-6.128,
							0
						]
					},
					{
						t: 40,
						s: [
							523.462,
							830.233,
							0
						]
					}
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					3,
					144.472,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										3,
										3
									],
									[
										3,
										285.944
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 8,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 33,
							s: [
								0
							]
						},
						{
							t: 40,
							s: [
								100
							]
						}
					],
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 29,
							s: [
								0
							]
						},
						{
							t: 36,
							s: [
								100
							]
						}
					],
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 29,
		op: 40,
		st: 33,
		bm: 0
	},
	{
		ddd: 0,
		ind: 8,
		ty: 4,
		nm: "Line Outlines 8",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 45,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.833,
							y: 0.833
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 34,
						s: [
							533.361,
							209.393,
							0
						],
						to: [
							-6.128,
							6.128,
							0
						],
						ti: [
							6.128,
							-6.128,
							0
						]
					},
					{
						t: 45,
						s: [
							496.592,
							246.162,
							0
						]
					}
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					3,
					144.472,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										3,
										3
									],
									[
										3,
										285.944
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 8,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 38,
							s: [
								0
							]
						},
						{
							t: 45,
							s: [
								100
							]
						}
					],
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 34,
							s: [
								0
							]
						},
						{
							t: 41,
							s: [
								100
							]
						}
					],
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 34,
		op: 45,
		st: 38,
		bm: 0
	},
	{
		ddd: 0,
		ind: 9,
		ty: 4,
		nm: "Line Outlines 7",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 45,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.833,
							y: 0.833
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 37,
						s: [
							292.945,
							585.574,
							0
						],
						to: [
							-6.128,
							6.128,
							0
						],
						ti: [
							6.128,
							-6.128,
							0
						]
					},
					{
						t: 48,
						s: [
							256.176,
							622.343,
							0
						]
					}
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					3,
					144.472,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										3,
										3
									],
									[
										3,
										285.944
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 8,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 41,
							s: [
								0
							]
						},
						{
							t: 48,
							s: [
								100
							]
						}
					],
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 37,
							s: [
								0
							]
						},
						{
							t: 44,
							s: [
								100
							]
						}
					],
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 37,
		op: 48,
		st: 41,
		bm: 0
	},
	{
		ddd: 0,
		ind: 10,
		ty: 4,
		nm: "Line Outlines 6",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 45,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.833,
							y: 0.833
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 42,
						s: [
							700.239,
							653.456,
							0
						],
						to: [
							-6.128,
							6.128,
							0
						],
						ti: [
							6.128,
							-6.128,
							0
						]
					},
					{
						t: 53,
						s: [
							663.469,
							690.225,
							0
						]
					}
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					3,
					144.472,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										3,
										3
									],
									[
										3,
										285.944
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 8,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 46,
							s: [
								0
							]
						},
						{
							t: 53,
							s: [
								100
							]
						}
					],
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 42,
							s: [
								0
							]
						},
						{
							t: 49,
							s: [
								100
							]
						}
					],
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 42,
		op: 53,
		st: 46,
		bm: 0
	},
	{
		ddd: 0,
		ind: 11,
		ty: 4,
		nm: "Line Outlines 15",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 45,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.833,
							y: 0.833
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 43,
						s: [
							509.32,
							281.518,
							0
						],
						to: [
							-6.128,
							6.128,
							0
						],
						ti: [
							6.128,
							-6.128,
							0
						]
					},
					{
						t: 54,
						s: [
							472.55,
							318.287,
							0
						]
					}
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					3,
					144.472,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										3,
										3
									],
									[
										3,
										285.944
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 8,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 47,
							s: [
								0
							]
						},
						{
							t: 54,
							s: [
								100
							]
						}
					],
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 43,
							s: [
								0
							]
						},
						{
							t: 50,
							s: [
								100
							]
						}
					],
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 43,
		op: 54,
		st: 47,
		bm: 0
	},
	{
		ddd: 0,
		ind: 12,
		ty: 4,
		nm: "Line Outlines 14",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 45,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.833,
							y: 0.833
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 48,
						s: [
							793.577,
							379.098,
							0
						],
						to: [
							-6.128,
							6.128,
							0
						],
						ti: [
							6.128,
							-6.128,
							0
						]
					},
					{
						t: 59,
						s: [
							756.807,
							415.868,
							0
						]
					}
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					3,
					144.472,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										3,
										3
									],
									[
										3,
										285.944
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 8,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 52,
							s: [
								0
							]
						},
						{
							t: 59,
							s: [
								100
							]
						}
					],
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 48,
							s: [
								0
							]
						},
						{
							t: 55,
							s: [
								100
							]
						}
					],
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 48,
		op: 59,
		st: 52,
		bm: 0
	},
	{
		ddd: 0,
		ind: 13,
		ty: 4,
		nm: "Line Outlines 13",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 45,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.833,
							y: 0.833
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 53,
						s: [
							580.031,
							256.062,
							0
						],
						to: [
							-6.128,
							6.128,
							0
						],
						ti: [
							6.128,
							-6.128,
							0
						]
					},
					{
						t: 64,
						s: [
							543.261,
							292.831,
							0
						]
					}
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					3,
					144.472,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										3,
										3
									],
									[
										3,
										285.944
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 8,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 57,
							s: [
								0
							]
						},
						{
							t: 64,
							s: [
								100
							]
						}
					],
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 53,
							s: [
								0
							]
						},
						{
							t: 60,
							s: [
								100
							]
						}
					],
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 53,
		op: 64,
		st: 57,
		bm: 0
	},
	{
		ddd: 0,
		ind: 14,
		ty: 4,
		nm: "Line Outlines 12",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 45,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.833,
							y: 0.833
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 56,
						s: [
							519.219,
							769.421,
							0
						],
						to: [
							-6.128,
							6.128,
							0
						],
						ti: [
							6.128,
							-6.128,
							0
						]
					},
					{
						t: 67,
						s: [
							482.45,
							806.191,
							0
						]
					}
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					3,
					144.472,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										3,
										3
									],
									[
										3,
										285.944
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 8,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 60,
							s: [
								0
							]
						},
						{
							t: 67,
							s: [
								100
							]
						}
					],
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 56,
							s: [
								0
							]
						},
						{
							t: 63,
							s: [
								100
							]
						}
					],
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 56,
		op: 67,
		st: 60,
		bm: 0
	},
	{
		ddd: 0,
		ind: 15,
		ty: 4,
		nm: "Line Outlines 11",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 45,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.833,
							y: 0.833
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 61,
						s: [
							700.239,
							653.456,
							0
						],
						to: [
							-6.128,
							6.128,
							0
						],
						ti: [
							6.128,
							-6.128,
							0
						]
					},
					{
						t: 72,
						s: [
							663.469,
							690.225,
							0
						]
					}
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					3,
					144.472,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										3,
										3
									],
									[
										3,
										285.944
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 8,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 65,
							s: [
								0
							]
						},
						{
							t: 72,
							s: [
								100
							]
						}
					],
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 61,
							s: [
								0
							]
						},
						{
							t: 68,
							s: [
								100
							]
						}
					],
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 61,
		op: 72,
		st: 65,
		bm: 0
	},
	{
		ddd: 0,
		ind: 17,
		ty: 4,
		nm: "L - Fin Outlines 2",
		parent: 21,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					121.595,
					314.279,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					-87.428,
					109.514,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: -18,
						s: [
							65,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0,
								0
							]
						},
						t: 0,
						s: [
							-126,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 18,
						s: [
							-65,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0,
								0
							]
						},
						t: 36,
						s: [
							-126,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 54,
						s: [
							-65,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0,
								0
							]
						},
						t: 72,
						s: [
							-126,
							100,
							100
						]
					},
					{
						t: 90,
						s: [
							65,
							100,
							100
						]
					}
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										34.969,
										0
									],
									[
										43.275,
										-41.054
									],
									[
										-15.448,
										22.086
									],
									[
										11.424,
										36.369
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										15.448,
										-22.085
									],
									[
										-10.326,
										-32.873
									]
								],
								v: [
									[
										-64.949,
										-109.747
									],
									[
										-74.869,
										109.009
									],
									[
										15.374,
										85.362
									],
									[
										3.731,
										-32.172
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.20000001496,
								0.431372578939,
								0.705882352941,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								58.056,
								109.698
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 36,
		op: 72,
		st: -10,
		bm: 0
	},
	{
		ddd: 0,
		ind: 18,
		ty: 4,
		nm: "R - Fin Outlines 1",
		parent: 21,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					121.595,
					314.279,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					-87.428,
					109.514,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: -18,
						s: [
							65,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0,
								0
							]
						},
						t: 0,
						s: [
							126,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 18,
						s: [
							65,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0,
								0
							]
						},
						t: 36,
						s: [
							126,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 54,
						s: [
							65,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0,
								0
							]
						},
						t: 72,
						s: [
							126,
							100,
							100
						]
					},
					{
						t: 90,
						s: [
							65,
							100,
							100
						]
					}
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										34.969,
										0
									],
									[
										43.275,
										-41.054
									],
									[
										-15.448,
										22.086
									],
									[
										11.424,
										36.369
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										15.448,
										-22.085
									],
									[
										-10.326,
										-32.873
									]
								],
								v: [
									[
										-64.949,
										-109.747
									],
									[
										-74.869,
										109.009
									],
									[
										15.374,
										85.362
									],
									[
										3.731,
										-32.172
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.20000001496,
								0.431372578939,
								0.705882352941,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								58.056,
								109.698
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 36,
		st: -10,
		bm: 0
	},
	{
		ddd: 0,
		ind: 19,
		ty: 4,
		nm: "Mask",
		parent: 21,
		td: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					121.595,
					223.24,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					-10.085,
					25.127,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										17.247,
										63.341
									],
									[
										26.819,
										0
									],
									[
										17.246,
										-63.341
									],
									[
										-4.538,
										-83.576
									],
									[
										0,
										0
									],
									[
										-4.538,
										83.576
									]
								],
								o: [
									[
										-17.247,
										-63.341
									],
									[
										-26.82,
										0
									],
									[
										-17.247,
										63.341
									],
									[
										4.538,
										83.576
									],
									[
										0,
										0
									],
									[
										4.539,
										-83.576
									]
								],
								v: [
									[
										84.201,
										-93.507
									],
									[
										0,
										-225.739
									],
									[
										-84.201,
										-93.507
									],
									[
										-116.807,
										142.163
									],
									[
										0,
										221.363
									],
									[
										116.806,
										142.163
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.662745098039,
								0.764705942191,
								0.901960844152,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								-10.085,
								27.295
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 8",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 72,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 20,
		ty: 4,
		nm: "Window",
		parent: 21,
		tt: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: -18,
						s: [
							175.6,
							145.711,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 18,
						s: [
							67.595,
							145.711,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 54,
						s: [
							175.6,
							145.711,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						t: 90,
						s: [
							67.595,
							145.711,
							0
						]
					}
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					0.451,
					-124.706,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: -18,
						s: [
							85,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 0,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 18,
						s: [
							85,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 36,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 54,
						s: [
							85,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 72,
						s: [
							100,
							100,
							100
						]
					},
					{
						t: 90,
						s: [
							85,
							100,
							100
						]
					}
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-24.965
									],
									[
										24.965,
										0
									],
									[
										0,
										24.965
									],
									[
										-24.965,
										0
									]
								],
								o: [
									[
										0,
										24.965
									],
									[
										-24.965,
										0
									],
									[
										0,
										-24.965
									],
									[
										24.965,
										0
									]
								],
								v: [
									[
										45.203,
										0
									],
									[
										0,
										45.203
									],
									[
										-45.203,
										0
									],
									[
										0,
										-45.203
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0.451,
								-124.706
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-28.047
									],
									[
										28.047,
										0
									],
									[
										0,
										28.048
									],
									[
										-28.048,
										0
									]
								],
								o: [
									[
										0,
										28.048
									],
									[
										-28.048,
										0
									],
									[
										0,
										-28.047
									],
									[
										28.047,
										0
									]
								],
								v: [
									[
										50.785,
										0
									],
									[
										0.001,
										50.784
									],
									[
										-50.785,
										0
									],
									[
										0.001,
										-50.784
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.968627510819,
								0.580392156863,
								0.133333333333,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0.451,
								-124.706
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 2",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-31.19
									],
									[
										31.19,
										0
									],
									[
										0,
										31.19
									],
									[
										-31.19,
										0
									]
								],
								o: [
									[
										0,
										31.19
									],
									[
										-31.19,
										0
									],
									[
										0,
										-31.19
									],
									[
										31.19,
										0
									]
								],
								v: [
									[
										56.474,
										0
									],
									[
										0,
										56.474
									],
									[
										-56.474,
										0
									],
									[
										0,
										-56.474
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.20000001496,
								0.431372578939,
								0.705882352941,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0.451,
								-124.706
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 3",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 3,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 72,
		st: -10,
		bm: 0
	},
	{
		ddd: 0,
		ind: 21,
		ty: 4,
		nm: "Rocket - Body Outlines",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 45,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 0,
						s: [
							540,
							540.573,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 20,
						s: [
							624,
							425.573,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 45,
						s: [
							476.797,
							465.786,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						t: 72,
						s: [
							540,
							540.573,
							0
						]
					}
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					121.595,
					225.99,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-22.767,
										17.009
									],
									[
										32.812,
										0
									],
									[
										24.641,
										7.255
									],
									[
										-17.762,
										-1.018
									],
									[
										-3.77,
										-0.02
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										-5.044,
										0.307
									]
								],
								o: [
									[
										-24.657,
										7.286
									],
									[
										-32.772,
										0
									],
									[
										24.251,
										18.068
									],
									[
										3.545,
										0.167
									],
									[
										0.912,
										-0.012
									],
									[
										0,
										0
									],
									[
										5.516,
										0
									],
									[
										18.393,
										-1.385
									]
								],
								v: [
									[
										87.677,
										-11.921
									],
									[
										-0.044,
										-1.835
									],
									[
										-87.677,
										-11.855
									],
									[
										-12.43,
										11.638
									],
									[
										-1.457,
										11.921
									],
									[
										-0.044,
										11.889
									],
									[
										-0.044,
										11.887
									],
									[
										15.786,
										11.409
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.20000001496,
								0.431372578939,
								0.705882352941,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								121.639,
								435.464
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 4",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 4,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-14.183,
										0
									],
									[
										-12.614,
										2.558
									],
									[
										12.103,
										0
									],
									[
										14.199,
										-21.219
									]
								],
								o: [
									[
										14.183,
										0
									],
									[
										-14.2,
										-21.219
									],
									[
										-12.104,
										0
									],
									[
										12.614,
										2.558
									]
								],
								v: [
									[
										0,
										19.892
									],
									[
										41.118,
										15.361
									],
									[
										0,
										-19.892
									],
									[
										-41.118,
										15.361
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.20000001496,
								0.431372578939,
								0.705882352941,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								121.595,
								20.142
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 5",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 5,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-15.81,
										0
									],
									[
										-13.597,
										2.981
									],
									[
										13.323,
										0
									],
									[
										15.457,
										-24.877
									]
								],
								o: [
									[
										15.81,
										0
									],
									[
										-15.457,
										-24.877
									],
									[
										-13.323,
										0
									],
									[
										13.597,
										2.981
									]
								],
								v: [
									[
										0,
										23.656
									],
									[
										45.389,
										18.226
									],
									[
										0,
										-23.656
									],
									[
										-45.389,
										18.226
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.968627510819,
								0.580392156863,
								0.133333333333,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								121.595,
								23.906
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 6",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 6,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0.188,
										11.123
									],
									[
										44.232,
										0
									],
									[
										28.065,
										6.092
									],
									[
										-0.598,
										-11.013
									],
									[
										0,
										0
									],
									[
										-4.538,
										83.577
									]
								],
								o: [
									[
										-28.065,
										6.092
									],
									[
										-44.231,
										0
									],
									[
										-0.189,
										11.123
									],
									[
										4.538,
										83.577
									],
									[
										0,
										0
									],
									[
										0.598,
										-11.013
									]
								],
								v: [
									[
										117.38,
										-58.408
									],
									[
										0,
										-44.369
									],
									[
										-117.379,
										-58.408
									],
									[
										-116.806,
										-25.169
									],
									[
										0,
										54.031
									],
									[
										116.807,
										-25.169
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.592156862745,
								0.717647058824,
								0.87450986376,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								121.594,
								393.323
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 7",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 7,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										17.247,
										63.341
									],
									[
										26.819,
										0
									],
									[
										17.246,
										-63.341
									],
									[
										-4.538,
										-83.576
									],
									[
										0,
										0
									],
									[
										-4.538,
										83.576
									]
								],
								o: [
									[
										-17.247,
										-63.341
									],
									[
										-26.82,
										0
									],
									[
										-17.247,
										63.341
									],
									[
										4.538,
										83.576
									],
									[
										0,
										0
									],
									[
										4.539,
										-83.576
									]
								],
								v: [
									[
										84.201,
										-93.507
									],
									[
										0,
										-225.739
									],
									[
										-84.201,
										-93.507
									],
									[
										-116.807,
										142.163
									],
									[
										0,
										221.363
									],
									[
										116.806,
										142.163
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.662745098039,
								0.764705942191,
								0.901960844152,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								121.595,
								225.99
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 8",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 8,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 72,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 22,
		ty: 4,
		nm: "R - Fin Outlines 2",
		parent: 21,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					121.595,
					314.279,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					-87.428,
					109.514,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: -18,
						s: [
							65,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0,
								0
							]
						},
						t: 0,
						s: [
							126,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 18,
						s: [
							65,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0,
								0
							]
						},
						t: 36,
						s: [
							126,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 54,
						s: [
							65,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0,
								0
							]
						},
						t: 72,
						s: [
							126,
							100,
							100
						]
					},
					{
						t: 90,
						s: [
							65,
							100,
							100
						]
					}
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										34.969,
										0
									],
									[
										43.275,
										-41.054
									],
									[
										-15.448,
										22.086
									],
									[
										11.424,
										36.369
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										15.448,
										-22.085
									],
									[
										-10.326,
										-32.873
									]
								],
								v: [
									[
										-64.949,
										-109.747
									],
									[
										-74.869,
										109.009
									],
									[
										15.374,
										85.362
									],
									[
										3.731,
										-32.172
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.20000001496,
								0.431372578939,
								0.705882352941,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								58.056,
								109.698
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 36,
		op: 72,
		st: -10,
		bm: 0
	},
	{
		ddd: 0,
		ind: 23,
		ty: 4,
		nm: "L - Fin Outlines 1",
		parent: 21,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					121.595,
					314.279,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					-87.428,
					109.514,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: -18,
						s: [
							65,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0,
								0
							]
						},
						t: 0,
						s: [
							-126,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 18,
						s: [
							-65,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0,
								0
							]
						},
						t: 36,
						s: [
							-126,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								0.833,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 54,
						s: [
							-65,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0.167,
								0,
								0
							]
						},
						t: 72,
						s: [
							-126,
							100,
							100
						]
					},
					{
						t: 90,
						s: [
							65,
							100,
							100
						]
					}
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										34.969,
										0
									],
									[
										43.275,
										-41.054
									],
									[
										-15.448,
										22.086
									],
									[
										11.424,
										36.369
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										15.448,
										-22.085
									],
									[
										-10.326,
										-32.873
									]
								],
								v: [
									[
										-64.949,
										-109.747
									],
									[
										-74.869,
										109.009
									],
									[
										15.374,
										85.362
									],
									[
										3.731,
										-32.172
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.20000001496,
								0.431372578939,
								0.705882352941,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								58.056,
								109.698
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 36,
		st: -10,
		bm: 0
	},
	{
		ddd: 0,
		ind: 24,
		ty: 4,
		nm: "Flame Orange Outlines",
		parent: 21,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					121.639,
					387.354,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					149.18,
					0.25,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 0,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 2,
						s: [
							100,
							120,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 6,
						s: [
							100,
							80,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 9,
						s: [
							100,
							130,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 12,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 14,
						s: [
							100,
							120,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 18,
						s: [
							100,
							80,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 22,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 24,
						s: [
							100,
							120,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 28,
						s: [
							100,
							80,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 32,
						s: [
							100,
							130,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 35,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 37,
						s: [
							100,
							120,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 41,
						s: [
							100,
							80,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 44,
						s: [
							100,
							130,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 47,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 49,
						s: [
							100,
							120,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 53,
						s: [
							100,
							80,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 57,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 59,
						s: [
							100,
							120,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 63,
						s: [
							100,
							80,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 68,
						s: [
							100,
							130,
							100
						]
					},
					{
						t: 72,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										10.791,
										36.189
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										-148.885,
										-88.094
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										-10.791,
										36.189
									],
									[
										148.885,
										-88.094
									]
								],
								v: [
									[
										78.585,
										-95.404
									],
									[
										0,
										-95.404
									],
									[
										-78.585,
										-95.404
									],
									[
										0,
										95.404
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.968627510819,
								0.58431372549,
								0.125490196078,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								149.135,
								95.653
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 72,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 25,
		ty: 4,
		nm: "Flame Lighter Outlines",
		parent: 21,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					121.595,
					387.354,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					188.665,
					0.25,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 0,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 4,
						s: [
							100,
							120,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 8,
						s: [
							100,
							80,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 11,
						s: [
							100,
							130,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 13,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 16,
						s: [
							100,
							120,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 20,
						s: [
							100,
							80,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 23,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 26,
						s: [
							100,
							120,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 30,
						s: [
							100,
							80,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 33,
						s: [
							100,
							130,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 36,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 39,
						s: [
							100,
							120,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 42,
						s: [
							100,
							80,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 46,
						s: [
							100,
							130,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 48,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 51,
						s: [
							100,
							120,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 55,
						s: [
							100,
							80,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 58,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 61,
						s: [
							100,
							120,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 65,
						s: [
							100,
							80,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 70,
						s: [
							100,
							130,
							100
						]
					},
					{
						t: 72,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										96.411,
										39.417
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										-188.46,
										-120.917
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										-96.411,
										39.417
									],
									[
										188.46,
										-120.917
									]
								],
								v: [
									[
										59.205,
										-139.341
									],
									[
										0,
										-139.341
									],
									[
										-59.206,
										-139.341
									],
									[
										0,
										139.341
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.984313785329,
								0.690196078431,
								0.231372563979,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								188.71,
								139.591
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 72,
		st: 0,
		bm: 0
	}
];
var markers$2 = [
];
var loadingRocket$1 = {
	v: v$2,
	fr: fr$2,
	ip: ip$2,
	op: op$2,
	w: w$2,
	h: h$2,
	nm: nm$2,
	ddd: ddd$2,
	assets: assets$2,
	layers: layers$2,
	markers: markers$2
};

var LoadingScroll = function (_a) {
    var _b = _a.height, height = _b === void 0 ? 160 : _b, _c = _a.className, className = _c === void 0 ? '' : _c, _d = _a.isBlockOthers, isBlockOthers = _d === void 0 ? false : _d, _e = _a.initialDelay, initialDelay = _e === void 0 ? 1000 : _e, // in millisecond
    _f = _a.jcLoading, // in millisecond
    jcLoading = _f === void 0 ? undefined : _f;
    var _g = React.useState(false), show = _g[0], setShow = _g[1];
    React.useEffect(function () {
        setTimeout(function () {
            setShow(true);
        }, initialDelay);
    }, []);
    var loadingRocketLottie = (React__default["default"].createElement("div", { className: 'loading-rocket ' + className, style: { height: height + 'px' } },
        React__default["default"].createElement(Lottie__default["default"], { animationData: loadingRocket$1, loop: true })));
    var loadingAnimation = function () {
        return jcLoading || loadingRocketLottie;
    };
    if (!show) {
        return React__default["default"].createElement(React__default["default"].Fragment, null);
    } // not showing loading until initial delay passed
    if (isBlockOthers)
        return (React__default["default"].createElement("div", { className: "container-loading-rocket-full" }, loadingAnimation()));
    return React__default["default"].createElement(React__default["default"].Fragment, null, loadingAnimation());
};

var SingleChip = /** @class */ (function (_super) {
    __extends(SingleChip, _super);
    function SingleChip(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }
    SingleChip.prototype.handleClick = function (value) {
        this.props.setActiveState(value);
    };
    SingleChip.prototype.render = function () {
        var _this = this;
        return (React__default["default"].createElement("div", { className: 'border inline-block rounded-[18px] px-4 py-1.5 bg-neutral-chalk border-primary-apricot hover:border-2 hover:bg-primary-apricot-faded cursor-pointer mb-2 mr-2 last-of-type:mr-0 ' +
                (this.props.active ? 'border-2 bg-primary-apricot-faded' : '') +
                (this.props.className ? (' ' + this.props.className) : ''), onClick: function () { return _this.handleClick(!_this.props.active); } }, this.props.children));
    };
    return SingleChip;
}(React__default["default"].Component));

var MultiChip = /** @class */ (function (_super) {
    __extends(MultiChip, _super);
    function MultiChip(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }
    MultiChip.prototype.handleClick = function (value) {
        this.props.setActiveState(value);
    };
    MultiChip.prototype.render = function () {
        var _this = this;
        return (React__default["default"].createElement("div", { className: 'bg-primary-navyblue-bright inline-block rounded-lg px-3 py-2 cursor-pointer mb-2 mr-2 last-of-type:mr-0' },
            React__default["default"].createElement("div", { className: 'flex' },
                React__default["default"].createElement("div", { className: 'flex-auto' }, this.props.children),
                React__default["default"].createElement("div", { className: 'flex-initial ml-2 self-center', onClick: function () { return _this.handleClick(!_this.props.active); } },
                    React__default["default"].createElement(Icon, { name: "xmark", className: 'fill-current text-neutral-chalk w-2.5' })))));
    };
    return MultiChip;
}(React__default["default"].Component));

var ReactionChip = /** @class */ (function (_super) {
    __extends(ReactionChip, _super);
    function ReactionChip(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }
    ReactionChip.prototype.handleClick = function (value) {
        this.props.setActiveState(value);
    };
    ReactionChip.prototype.render = function () {
        var _this = this;
        return (React__default["default"].createElement("div", { className: 'border inline-block rounded-[14px] px-1.5 py-0.5 bg-neutral-chalk border-primary-apricot hover:border-2 hover:bg-primary-apricot-faded cursor-pointer mb-2 mr-2 last-of-type:mr-0 ' +
                (this.props.active ? 'border-2 bg-primary-apricot-faded' : ''), onClick: function () { return _this.handleClick(!_this.props.active); } }, this.props.children));
    };
    return ReactionChip;
}(React__default["default"].Component));

var Chips = /** @class */ (function (_super) {
    __extends(Chips, _super);
    function Chips(props) {
        return _super.call(this, props) || this;
    }
    Chips.prototype.render = function () {
        return (this.props.variant === 'single'
            ? React__default["default"].createElement(SingleChip, __assign({}, this.props))
            : this.props.variant === 'reaction'
                ? React__default["default"].createElement(ReactionChip, __assign({}, this.props))
                : React__default["default"].createElement(MultiChip, __assign({}, this.props)));
    };
    Chips.defaultProps = {
        active: false,
    };
    return Chips;
}(React__default["default"].Component));

var v$1 = "5.9.0";
var fr$1 = 25;
var ip$1 = 0;
var op$1 = 101;
var w$1 = 275;
var h$1 = 125;
var nm$1 = "Rocket Idle";
var ddd$1 = 0;
var assets$1 = [
];
var layers$1 = [
	{
		ddd: 0,
		ind: 1,
		ty: 4,
		nm: "Layer 1",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 0,
						s: [
							0
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 33,
						s: [
							1
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 67,
						s: [
							-1
						]
					},
					{
						t: 100,
						s: [
							0
						]
					}
				],
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 0,
						s: [
							129.814,
							60.409,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 25,
						s: [
							128.272,
							63.659,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 50,
						s: [
							129.814,
							60.409,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 75,
						s: [
							128.272,
							63.659,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						t: 100,
						s: [
							129.814,
							60.409,
							0
						]
					}
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					126.814,
					64.159,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										5.498,
										2.824
									],
									[
										-2.824,
										5.498
									],
									[
										-5.498,
										-2.824
									],
									[
										2.824,
										-5.498
									],
									[
										0,
										0
									]
								],
								o: [
									[
										-2.824,
										5.498
									],
									[
										-5.498,
										-2.824
									],
									[
										2.824,
										-5.498
									],
									[
										5.498,
										2.824
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										9.955,
										5.113
									],
									[
										-5.113,
										9.955
									],
									[
										-9.955,
										-5.113
									],
									[
										5.113,
										-9.955
									],
									[
										9.955,
										5.113
									],
									[
										9.955,
										5.113
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								137.503,
								42.13
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Path 38370",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										6.14,
										3.156
									],
									[
										-3.156,
										6.14
									],
									[
										-6.139,
										-3.151
									],
									[
										3.153,
										-6.142
									],
									[
										0.001,
										-0.002
									]
								],
								o: [
									[
										-3.156,
										6.14
									],
									[
										-6.14,
										-3.156
									],
									[
										3.155,
										-6.137
									],
									[
										6.142,
										3.153
									],
									[
										-0.001,
										0.002
									],
									[
										0,
										0
									]
								],
								v: [
									[
										11.117,
										5.715
									],
									[
										-5.715,
										11.117
									],
									[
										-11.117,
										-5.715
									],
									[
										5.708,
										-11.12
									],
									[
										11.12,
										5.708
									],
									[
										11.117,
										5.715
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.96862745285,
								0.580392181873,
								0.133333340287,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								137.513,
								42.125
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Path 38369",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										6.966,
										3.578
									],
									[
										-3.578,
										6.966
									],
									[
										-6.966,
										-3.578
									],
									[
										3.578,
										-6.966
									],
									[
										0,
										0
									]
								],
								o: [
									[
										-3.578,
										6.966
									],
									[
										-6.966,
										-3.578
									],
									[
										3.578,
										-6.966
									],
									[
										6.966,
										3.578
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										12.612,
										6.479
									],
									[
										-6.479,
										12.612
									],
									[
										-12.612,
										-6.479
									],
									[
										6.478,
										-12.612
									],
									[
										12.612,
										6.478
									],
									[
										12.612,
										6.479
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.20000000298,
								0.43137255311,
								0.705882370472,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								137.505,
								42.131
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Path 38368",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 3,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										-0.218,
										-1.339
									],
									[
										-0.043,
										-1.353
									],
									[
										0.183,
										-1.348
									],
									[
										0.565,
										-1.246
									],
									[
										-0.007,
										1.322
									],
									[
										0.031,
										1.32
									],
									[
										0,
										0
									],
									[
										-0.033,
										1.362
									]
								],
								o: [
									[
										0.469,
										1.273
									],
									[
										0.23,
										1.334
									],
									[
										0.044,
										1.359
									],
									[
										-0.179,
										1.356
									],
									[
										0.073,
										-1.363
									],
									[
										0.007,
										-1.322
									],
									[
										0,
										0
									],
									[
										-0.037,
										-1.331
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-0.72,
										-7.977
									],
									[
										0.313,
										-4.049
									],
									[
										0.722,
										-0.014
									],
									[
										0.513,
										4.055
									],
									[
										-0.608,
										7.979
									],
									[
										-0.492,
										3.979
									],
									[
										-0.559,
										0.023
									],
									[
										-0.687,
										-3.951
									],
									[
										-0.721,
										-7.979
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								152.89,
								23.446
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Path 38367",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 4,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										2.084,
										1.711
									],
									[
										0.422,
										-0.257
									],
									[
										-2.618,
										-1.372
									],
									[
										-2.657,
										-0.701
									],
									[
										0.043,
										0.468
									],
									[
										2.221,
										1.124
									]
								],
								o: [
									[
										-2.39,
										-1.249
									],
									[
										-0.4,
										0.235
									],
									[
										2.252,
										1.915
									],
									[
										2.454,
										1.238
									],
									[
										-0.034,
										-0.494
									],
									[
										-2.395,
										-0.678
									],
									[
										0,
										0
									]
								],
								v: [
									[
										0.453,
										0.152
									],
									[
										-6.275,
										-4.299
									],
									[
										-7.508,
										-3.562
									],
									[
										-0.18,
										1.383
									],
									[
										7.508,
										4.299
									],
									[
										7.392,
										2.859
									],
									[
										0.453,
										0.15
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.96862745285,
								0.580392181873,
								0.133333340287,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								148.721,
								19.948
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Path 38366",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 5,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										-2.658,
										-0.701
									],
									[
										1.538,
										0.793
									],
									[
										5.816,
										-3.567
									],
									[
										-2.618,
										-1.372
									]
								],
								o: [
									[
										2.454,
										1.238
									],
									[
										-0.478,
										-6.894
									],
									[
										-1.538,
										-0.793
									],
									[
										2.251,
										1.916
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-0.181,
										3.239
									],
									[
										7.508,
										6.156
									],
									[
										4.151,
										-5.946
									],
									[
										-7.508,
										-1.709
									],
									[
										-0.181,
										3.239
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.20000000298,
								0.43137255311,
								0.705882370472,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								148.723,
								18.094
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Path 38365",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 6,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										-5.224,
										0.36
									],
									[
										4.845,
										2.485
									],
									[
										4.89,
										3.533
									],
									[
										-0.485,
										-0.586
									],
									[
										-4.675,
										-2.235
									]
								],
								o: [
									[
										5.747,
										2.952
									],
									[
										-5.171,
										-1.706
									],
									[
										-5.393,
										-2.704
									],
									[
										0.404,
										0.644
									],
									[
										3.268,
										4.02
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-1.852,
										3.49
									],
									[
										15.249,
										7.81
									],
									[
										0.201,
										1.514
									],
									[
										-15.249,
										-7.857
									],
									[
										-13.915,
										-6.009
									],
									[
										-1.852,
										3.491
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.20000000298,
								0.43137255311,
								0.705882370472,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								110.988,
								93.804
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Path 38364",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 7,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0.344,
										-0.667
									],
									[
										-4.186,
										-5.535
									],
									[
										-4.675,
										-2.235
									],
									[
										-6.664,
										12.973
									],
									[
										-0.315,
										0.638
									],
									[
										7.29,
										3.854
									],
									[
										6.687,
										5.808
									]
								],
								o: [
									[
										-0.351,
										0.657
									],
									[
										-3.981,
										7.751
									],
									[
										3.268,
										4.021
									],
									[
										12.468,
										6.4
									],
									[
										0.328,
										-0.639
									],
									[
										-8.055,
										-1.764
									],
									[
										-7.892,
										-4.022
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-20.777,
										-17.901
									],
									[
										-21.819,
										-15.915
									],
									[
										-20.519,
										4.12
									],
									[
										-8.456,
										13.62
									],
									[
										23.332,
										7.283
									],
									[
										24.296,
										5.368
									],
									[
										1.172,
										-3.098
									],
									[
										-20.778,
										-17.898
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.592156887054,
								0.717647075653,
								0.874509811401,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								117.59,
								83.677
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Path 38363",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 8,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										12.468,
										6.405
									],
									[
										3.268,
										4.021
									],
									[
										-3.983,
										7.751
									],
									[
										-4.8,
										-2.467
									],
									[
										19.704,
										-38.359
									]
								],
								o: [
									[
										-6.664,
										12.973
									],
									[
										-4.675,
										-2.235
									],
									[
										-4.187,
										-5.539
									],
									[
										19.7,
										-38.359
									],
									[
										4.8,
										2.467
									],
									[
										0,
										0
									]
								],
								v: [
									[
										16.069,
										34.2
									],
									[
										-15.719,
										40.537
									],
									[
										-27.782,
										31.037
									],
									[
										-29.082,
										11.002
									],
									[
										28.018,
										-44.613
									],
									[
										16.069,
										34.195
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.662745118141,
								0.764705896378,
								0.901960790157,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								124.854,
								56.756
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Path 38362",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 9,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										-2.993,
										5.827
									],
									[
										-9.021,
										-4.634
									]
								],
								o: [
									[
										-9.02,
										-4.634
									],
									[
										6.326,
										-12.315
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-3.524,
										22.643
									],
									[
										-18.81,
										5.459
									],
									[
										19.384,
										-21.952
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.20000000298,
								0.43137255311,
								0.705882370472,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								99.264,
								63.306
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Path 38361",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 10,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										-2.993,
										5.827
									],
									[
										9.021,
										4.634
									]
								],
								o: [
									[
										9.021,
										4.634
									],
									[
										6.326,
										-12.315
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-14.345,
										19.58
									],
									[
										8.527,
										21.997
									],
									[
										8.562,
										-25.015
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.20000000298,
								0.43137255311,
								0.705882370472,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								140.579,
								82.033
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Path 38360",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 11,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ty: "rc",
						d: 1,
						s: {
							a: 0,
							k: [
								76.537,
								101.117
							],
							ix: 2
						},
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 4
						},
						nm: "Rectangle Path 1",
						mn: "ADBE Vector Shape - Rect",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								118.148,
								62.5
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 1,
				cix: 2,
				bm: 0,
				ix: 12,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 300,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 2,
		ty: 4,
		nm: "Path 38359",
		parent: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					114.152,
					87.866,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					2.667,
					-5.833,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 0,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 8.5,
						s: [
							115,
							115,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 12.5,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 21,
						s: [
							115,
							115,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 25,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 33.5,
						s: [
							115,
							115,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 37.5,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 46,
						s: [
							115,
							115,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 50,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 58.5,
						s: [
							115,
							115,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 62.5,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 71,
						s: [
							115,
							115,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 75,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 83.5,
						s: [
							115,
							115,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 87.5,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 96,
						s: [
							115,
							115,
							100
						]
					},
					{
						t: 100,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										-10.19,
										-22.938
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										24.615,
										-5.02
									],
									[
										0,
										0
									]
								],
								v: [
									[
										9.6,
										-3.847
									],
									[
										-4.369,
										-11.039
									],
									[
										-6.923,
										11.044
									],
									[
										9.6,
										-3.848
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.96862745285,
								0.584313750267,
								0.1254902035,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Path 38359",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 300,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 3,
		ty: 4,
		nm: "Path 38358",
		parent: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					113.981,
					87.579,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					4.333,
					-10.25,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 0,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 6.5,
						s: [
							105,
							105,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 12.5,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 18.5,
						s: [
							105,
							105,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 25,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 31.5,
						s: [
							105,
							105,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 37.5,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 44,
						s: [
							105,
							105,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 50,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 56.5,
						s: [
							105,
							105,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 62.5,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 68.5,
						s: [
							105,
							105,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 75,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 81.5,
						s: [
							105,
							105,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 87.5,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 94,
						s: [
							105,
							105,
							100
						]
					},
					{
						t: 100,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										-14.767,
										-33.244
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										35.673,
										-7.275
									],
									[
										0,
										0
									]
								],
								v: [
									[
										11.438,
										-7.978
									],
									[
										-2.532,
										-15.17
									],
									[
										-9.351,
										15.23
									],
									[
										-9.351,
										15.23
									],
									[
										11.438,
										-7.978
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.984313726425,
								0.690196096897,
								0.23137255013,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Path 38358",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 300,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 4,
		ty: 4,
		nm: "Path 38371",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 0,
						s: [
							48.474,
							91.295,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 30,
						s: [
							53.662,
							91.295,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.833,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 67,
						s: [
							43.312,
							91.295,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						t: 100,
						s: [
							48.474,
							91.295,
							0
						]
					}
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					0,
					0,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										4.381,
										0.006
									],
									[
										1.271,
										-0.803
									],
									[
										5.78,
										-1.87
									],
									[
										0.709,
										-0.423
									],
									[
										7.324,
										-2.671
									],
									[
										0.952,
										-4.849
									],
									[
										1.835,
										-0.008
									],
									[
										0,
										-4.933
									]
								],
								o: [
									[
										0.006,
										-4.381
									],
									[
										-1.504,
										-0.002
									],
									[
										-1.87,
										-5.78
									],
									[
										-0.785,
										0.254
									],
									[
										-2.671,
										-7.324
									],
									[
										-4.643,
										1.693
									],
									[
										-1.701,
										-0.689
									],
									[
										-6.341,
										-0.001
									],
									[
										0,
										0
									]
								],
								v: [
									[
										36.109,
										11.031
									],
									[
										28.187,
										3.087
									],
									[
										23.939,
										4.313
									],
									[
										10.087,
										-2.767
									],
									[
										7.839,
										-1.749
									],
									[
										-10.258,
										-10.173
									],
									[
										-19.272,
										0.367
									],
									[
										-24.628,
										-0.664
									],
									[
										-36.109,
										11.031
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.96862745285,
								0.580392181873,
								0.1254902035,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Path 38371",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 300,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 5,
		ty: 4,
		nm: "Path 38373",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 0,
						s: [
							168.6,
							63.187,
							0
						],
						to: [
							0.917,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.833,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 50,
						s: [
							174.1,
							63.187,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						t: 100,
						s: [
							168.6,
							63.187,
							0
						]
					}
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					0,
					0,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										-5.117,
										0.007
									],
									[
										-1.305,
										-0.664
									],
									[
										-6.963,
										-2.34
									],
									[
										-1.315,
										-3.972
									],
									[
										-2.161,
										-0.01
									],
									[
										0,
										-5.125
									]
								],
								o: [
									[
										-0.007,
										-5.117
									],
									[
										1.465,
										-0.002
									],
									[
										2.34,
										-6.963
									],
									[
										3.966,
										1.333
									],
									[
										2.039,
										-0.714
									],
									[
										7.54,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-29.35,
										8.668
									],
									[
										-20.097,
										-0.61
									],
									[
										-15.882,
										0.397
									],
									[
										0.962,
										-7.973
									],
									[
										9.351,
										0.454
									],
									[
										15.698,
										-0.61
									],
									[
										29.35,
										8.669
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.886274516582,
								0.505882382393,
								0.1254902035,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Path 38373",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 300,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 6,
		ty: 4,
		nm: "Path 38372",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 0,
						s: [
							217.607,
							67.399,
							0
						],
						to: [
							-1.667,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.833,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 50,
						s: [
							207.607,
							67.399,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						t: 100,
						s: [
							217.607,
							67.399,
							0
						]
					}
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					0,
					0,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										23.946,
										0
									],
									[
										15.565,
										0
									],
									[
										2.394,
										-12.871
									],
									[
										12.572,
										-22.263
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-46.695,
										12.871
									],
									[
										46.695,
										12.871
									],
									[
										19.157,
										2.435
									],
									[
										0,
										-12.871
									],
									[
										-13.769,
										0
									],
									[
										-46.695,
										12.871
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.662745118141,
								0.764705896378,
								0.901960790157,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Path 38372",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 300,
		st: 0,
		bm: 0
	}
];
var markers$1 = [
];
var loadingRocket = {
	v: v$1,
	fr: fr$1,
	ip: ip$1,
	op: op$1,
	w: w$1,
	h: h$1,
	nm: nm$1,
	ddd: ddd$1,
	assets: assets$1,
	layers: layers$1,
	markers: markers$1
};

var BackgroundVariation = function (props) { return (React__namespace.createElement("svg", __assign({ id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", x: 0, y: 0, viewBox: "0 0 1366 768.3", xmlSpace: "preserve" }, props),
    React__namespace.createElement("style", null, ".st0{fill:#313272}.st2{fill:#e4e1e5}.st3{fill:#dd913e}.st9{fill:#15153f}.st11{fill:#14163e}.st30,.st31,.st32,.st33{fill-rule:evenodd;clip-rule:evenodd;fill:#5e5ea5}.st31,.st32,.st33{fill:#8b8abf}.st32,.st33{fill:#242554}.st33{fill:#313272}"),
    React__namespace.createElement("circle", { className: "st0", cx: 1297.4, cy: 400, r: 25.7 }),
    React__namespace.createElement("path", { className: "st0", d: "M1343.7 423.4c1.4-4.2-7.2-12.8-21.2-22.1.2 1 .2 2.1.2 3.1 8.5 6.2 13.4 11.7 12.5 14.6-1.7 5-19.9.4-40.8-10.1s-36.4-23.1-34.7-28.1c1.1-3.1 8.8-2.5 19.6 1.1.5-.8 1-1.4 1.7-2-16.3-6.2-28.4-7.8-29.9-3.4-2.1 6.1 17 21.5 42.6 34.4 25.6 13 48 18.5 50 12.5zM101.3 169.4c-5.5 1.1-7.3 2.9-8.4 8.4-.2.9-1.5.9-1.7 0-1.1-5.5-2.9-7.3-8.4-8.4-.9-.2-.9-1.5 0-1.7 5.5-1.1 7.3-2.9 8.4-8.4.2-.9 1.5-.9 1.7 0 1.1 5.5 2.9 7.3 8.4 8.4.9.2.9 1.5 0 1.7zM49.7 369.7c-3.5.7-4.6 1.8-5.3 5.3-.1.6-.9.6-1 0-.7-3.5-1.8-4.6-5.3-5.3-.6-.1-.6-.9 0-1 3.5-.7 4.6-1.8 5.3-5.3.1-.6.9-.6 1 0 .7 3.5 1.8 4.6 5.3 5.3.6.1.6.9 0 1zM1295.9 348.2c-5.5 1.1-7.3 2.9-8.4 8.4-.2.9-1.5.9-1.7 0-1.1-5.5-2.9-7.3-8.4-8.4-.9-.2-.9-1.5 0-1.7 5.5-1.1 7.3-2.9 8.4-8.4.2-.9 1.5-.9 1.7 0 1.1 5.5 2.9 7.3 8.4 8.4 1 .2 1 1.5 0 1.7zM1321.5 456.4c-2.7.5-3.7 1.4-4.2 4.2-.1.5-.7.5-.8 0-.5-2.7-1.4-3.7-4.2-4.2-.5-.1-.5-.7 0-.8 2.7-.5 3.7-1.4 4.2-4.2.1-.5.7-.5.8 0 .5 2.7 1.4 3.7 4.2 4.2.4 0 .4.7 0 .8z" }),
    React__namespace.createElement("g", { style: {
            opacity: 0.3,
        } },
        React__namespace.createElement("circle", { className: "st2", cx: 756.3, cy: 17.5, r: 4.5 }),
        React__namespace.createElement("circle", { className: "st2", cx: 209.1, cy: 16.2, r: 3.2 }),
        React__namespace.createElement("circle", { className: "st2", cx: 1271.3, cy: 720, r: 3.2 }),
        React__namespace.createElement("circle", { className: "st2", cx: 1292.1, cy: 114.4, r: 4.5 }),
        React__namespace.createElement("circle", { className: "st2", cx: 1106.3, cy: 701.6, r: 4.5 }),
        React__namespace.createElement("circle", { className: "st2", cx: 1217.9, cy: 594.6, r: 4.5 }),
        React__namespace.createElement("circle", { className: "st2", cx: 19, cy: 169.3, r: 3.2 }),
        React__namespace.createElement("circle", { className: "st2", cx: 1086.1, cy: 58.1, r: 3.2 }),
        React__namespace.createElement("circle", { className: "st2", cx: 1194.8, cy: 17.4, r: 3.2 }),
        React__namespace.createElement("circle", { className: "st2", cx: 477.1, cy: 24.7, r: 4.5 }),
        React__namespace.createElement("path", { className: "st2", d: "M584.1 113c-2.8.5-3.7 1.5-4.2 4.2-.1.5-.8.5-.8 0-.5-2.8-1.5-3.7-4.2-4.2-.5-.1-.5-.8 0-.8 2.8-.5 3.7-1.5 4.2-4.2.1-.5.8-.5.8 0 .5 2.8 1.5 3.7 4.2 4.2.5 0 .5.7 0 .8zM63.1 194.1c-3.5.7-4.7 1.8-5.3 5.3-.1.6-.9.6-1.1 0-.7-3.5-1.8-4.7-5.3-5.3-.6-.1-.6-.9 0-1.1 3.5-.7 4.7-1.8 5.3-5.3.1-.6.9-.6 1.1 0 .7 3.5 1.8 4.7 5.3 5.3.6.1.6 1 0 1.1zM1141.8 387c-3.5.7-4.7 1.8-5.3 5.3-.1.6-.9.6-1.1 0-.7-3.5-1.8-4.7-5.3-5.3-.6-.1-.6-.9 0-1.1 3.5-.7 4.7-1.8 5.3-5.3.1-.6.9-.6 1.1 0 .7 3.5 1.8 4.7 5.3 5.3.6.1.6 1 0 1.1zM186.3 626.3c-3.4.7-4.6 1.8-5.2 5.2-.1.6-.9.6-1 0-.7-3.4-1.8-4.6-5.2-5.2-.6-.1-.6-.9 0-1 3.4-.7 4.6-1.8 5.2-5.2.1-.6.9-.6 1 0 .7 3.4 1.8 4.6 5.2 5.2.5.1.5.9 0 1z" }),
        React__namespace.createElement("path", { className: "st3", d: "M1024.5 38.5c-4.9.9-6.5 2.6-7.4 7.4-.2.8-1.3.8-1.5 0-.9-4.9-2.6-6.5-7.4-7.4-.8-.2-.8-1.3 0-1.5 4.9-.9 6.5-2.6 7.4-7.4.2-.8 1.3-.8 1.5 0 .9 4.9 2.6 6.5 7.4 7.4.9.2.9 1.4 0 1.5zM258.3 708.4c-4.9.9-6.5 2.6-7.4 7.4-.2.8-1.3.8-1.5 0-.9-4.9-2.6-6.5-7.4-7.4-.8-.2-.8-1.3 0-1.5 4.9-.9 6.5-2.6 7.4-7.4.2-.8 1.3-.8 1.5 0 .9 4.9 2.6 6.5 7.4 7.4.8.2.8 1.4 0 1.5zM76.7 136.7c-10.1 2-13.5 5.3-15.5 15.5-.3 1.7-2.7 1.7-3.1 0-2-10.1-5.3-13.5-15.5-15.5-1.7-.3-1.7-2.7 0-3.1 10.1-2 13.5-5.3 15.5-15.5.3-1.7 2.7-1.7 3.1 0 2 10.1 5.3 13.5 15.5 15.5 1.7.4 1.7 2.8 0 3.1zM1323.9 636.1c-3.4.7-4.6 1.8-5.2 5.2-.1.6-.9.6-1 0-.7-3.4-1.8-4.6-5.2-5.2-.6-.1-.6-.9 0-1 3.4-.7 4.6-1.8 5.2-5.2.1-.6.9-.6 1 0 .7 3.4 1.8 4.6 5.2 5.2.6.1.6.9 0 1zM386.1 51.4c-3.4.7-4.6 1.8-5.2 5.2-.1.6-.9.6-1 0-.7-3.4-1.8-4.6-5.2-5.2-.6-.1-.6-.9 0-1 3.4-.7 4.6-1.8 5.2-5.2.1-.6.9-.6 1 0 .7 3.4 1.8 4.6 5.2 5.2.6.1.6.9 0 1z" }),
        React__namespace.createElement("circle", { className: "st2", cx: 712.8, cy: 135.2, r: 3.2 }),
        React__namespace.createElement("circle", { className: "st2", cx: 753.2, cy: 97.6, r: 3.2 }),
        React__namespace.createElement("circle", { className: "st2", cx: 46.1, cy: 28.6, r: 4.5 }),
        React__namespace.createElement("circle", { className: "st2", cx: 64.2, cy: 524.1, r: 4.5 }),
        React__namespace.createElement("circle", { className: "st2", cx: 409.8, cy: 693.7, r: 6.2 })),
    React__namespace.createElement("path", { d: "M1366 500.8v267.5H0V500.8c455.3-121.2 910.7-121.2 1366 0z", style: {
            opacity: 0.3,
            fill: "#313272",
        } }),
    React__namespace.createElement("path", { d: "M1366 600.8v167.6H0V600.8c455.3-121.3 910.7-121.3 1366 0z", style: {
            opacity: 0.4,
            fill: "#313272",
        } }),
    React__namespace.createElement("path", { className: "st0", d: "M1366 672.7v95.7H0v-95.7c455.3-121.3 910.7-121.3 1366 0z" }),
    React__namespace.createElement("g", { style: {
            opacity: 0.7,
        } },
        React__namespace.createElement("path", { d: "M953.5 689.1c-1.8 13.6-28.9 20.4-60.4 15.2s-55.6-20.4-53.8-34 28.9-20.4 60.4-15.2 55.6 20.4 53.8 34zm-582-18.4c-29.8 12.6-50.3 33.2-45.8 46.1 4.4 12.8 32.2 13 61.9.4 29.8-12.6 50.3-33.2 45.8-46.1-4.4-12.8-32.1-13-61.9-.4zm100.7 22.2c-21.4 8.5-36.4 22.8-33.4 32.1 3 9.2 22.8 9.9 44.2 1.4 21.4-8.5 36.4-22.8 33.4-32.1-3-9.2-22.8-9.8-44.2-1.4zm48.1-67.4c-16.2 5.6-27.7 15.9-25.8 22.9 2 7 16.7 8.1 33 2.4s27.7-15.9 25.7-22.9c-1.9-6.9-16.6-8-32.9-2.4zm520.3 80c-15.5-7.6-30.3-8.4-33-1.7s7.7 18.3 23.3 25.9c15.5 7.6 30.3 8.4 33 1.7s-7.7-18.3-23.3-25.9zm-73.8 28.8c-19.2-2.5-35.4 2.3-36.3 10.5-.9 8.3 14 17 33.2 19.4 19.2 2.5 35.4-2.3 36.3-10.5.8-8.3-14-17-33.2-19.4z", style: {
                fill: "#222152",
            } }),
        React__namespace.createElement("path", { d: "M396.7 716.3c-13.6 5.8-26.8 8.9-37.5 9.3 8.7-1.4 18.4-4.1 28.4-8.4 29.8-12.6 50.3-33.2 45.8-46.1-2.4-7-11.7-10.2-24.4-9.7 17.3-2.7 30.6.2 33.5 8.8 4.5 12.9-16 33.5-45.8 46.1zM498.9 687c9.2-.2 15.8 2.3 17.5 7.3 3 9.2-12 23.6-33.4 32.1-6.1 2.4-12.1 4.1-17.6 5 7.6-.1 17-2.1 26.8-5.9 21.4-8.5 36.4-22.8 33.4-32.1-2.2-6.6-12.9-8.8-26.7-6.4zm400.8-31.9c31.5 5.2 55.6 20.4 53.8 34-1.1 8-10.9 13.7-25.3 15.9 19.2-1 33.1-7.2 34.4-16.8 1.8-13.6-22.2-28.8-53.8-34-12.9-2.1-25.1-2.2-35.1-.7 8-.4 16.8.1 26 1.6zm150.1 49.5c-11.8-5.8-23.2-7.6-29.2-5.2 5.8.5 12.8 2.5 20 6.1 15.5 7.6 26 19.2 23.3 25.9-.6 1.6-2 2.8-3.8 3.5 6.6.6 11.5-.8 13-4.4 2.6-6.7-7.8-18.3-23.3-25.9zm-73.9 28.8c-7.7-1-15-.8-20.9.3 3.7-.1 7.7.1 11.8.6 19.2 2.5 34 11.1 33.2 19.4-.5 4.9-6.5 8.6-15.3 10.2 13.6-.4 23.8-4.6 24.5-11.1.8-8.3-14.1-17-33.3-19.4zM539.6 621.9c7.3 0 12.6 2.1 13.7 6 2 7-9.5 17.2-25.7 22.9-3.5 1.2-6.8 2.1-10.1 2.7 5.5 0 12.2-1.2 19.2-3.6 16.2-5.6 27.7-15.9 25.7-22.9-1.5-5.4-11-7.3-22.8-5.1z", style: {
                fill: "#484496",
            } }),
        React__namespace.createElement("path", { className: "st9", d: "M993.1 761.3c-5.9-3.3-14-5.8-23.1-7-12-1.5-22.8-.3-29.4 2.9 5.9 3.3 14 5.8 23.1 7 11.9 1.6 22.7.3 29.4-2.9z" }),
        React__namespace.createElement("path", { d: "M950.5 695.4c-9-8.9-26.6-16.8-47.6-20.2-26.2-4.3-49.3-.3-57.4 8.9 9 8.9 26.6 16.8 47.6 20.2 26.2 4.3 49.3.4 57.4-8.9z", style: {
                fill: "#151740",
            } }),
        React__namespace.createElement("path", { className: "st9", d: "M1016 720c4 3.5 9.1 6.9 14.9 9.8 11 5.4 21.6 7.3 27.8 5.6-4-3.5-9.1-6.9-14.9-9.8-11-5.4-21.6-7.4-27.8-5.6z" }),
        React__namespace.createElement("path", { className: "st11", d: "M331.4 723.3c10.5 5.9 32.7 3.9 56.2-6 20.6-8.7 36.8-21.3 43.3-32.5-10.5-5.9-32.7-3.9-56.2 6-20.6 8.7-36.8 21.3-43.3 32.5zM523.5 645.6c-6.7 2.3-12.6 5.5-17 8.8 5.9.3 13.3-.8 21-3.5 6.7-2.3 12.6-5.5 17-8.8-5.8-.3-13.2.8-21 3.5zM447 731.4c8.4 2.2 21.8.6 36-5 12.4-4.9 22.5-11.7 28.4-18.4-8.4-2.2-21.8-.6-36 5-12.4 4.9-22.5 11.7-28.4 18.4z" }),
        React__namespace.createElement("radialGradient", { id: "SVGID_1_", cx: 286.296, cy: 113.555, r: 88.24, gradientTransform: "matrix(1.0963 0 0 -1.2129 72.176 817.967)", gradientUnits: "userSpaceOnUse" },
            React__namespace.createElement("stop", { offset: 0, style: {
                    stopColor: "#4f3890",
                } }),
            React__namespace.createElement("stop", { offset: 0.963, style: {
                    stopColor: "#0e142a",
                } })),
        React__namespace.createElement("path", { d: "M415.9 731.4c1.5 5.1-7.1 12.6-19.1 16.8s-22.9 3.4-24.4-1.7 7.1-12.6 19.1-16.8 23-3.4 24.4 1.7z", style: {
                opacity: 0.25,
                fill: "url(#SVGID_1_)",
            } }),
        React__namespace.createElement("radialGradient", { id: "SVGID_00000097463054343782169270000011437489030853539474_", cx: 791.606, cy: 228.479, r: 88.232, gradientTransform: "matrix(.9912 .5184 .4686 -1.0966 -33.813 416.507)", gradientUnits: "userSpaceOnUse" },
            React__namespace.createElement("stop", { offset: 0, style: {
                    stopColor: "#4f3890",
                } }),
            React__namespace.createElement("stop", { offset: 0.963, style: {
                    stopColor: "#0e142a",
                } })),
        React__namespace.createElement("path", { style: {
                opacity: 0.25,
                fill: "url(#SVGID_00000097463054343782169270000011437489030853539474_)",
            }, d: "M865.1 636.7c-.7 5.3-11.3 8.1-23.8 6.2-12.5-1.9-22-7.8-21.4-13.1.7-5.3 11.3-8.1 23.8-6.2 12.5 1.9 22.1 7.8 21.4 13.1z" }),
        React__namespace.createElement("radialGradient", { id: "SVGID_00000012459389985504216790000015608132756254050968_", cx: 1098.371, cy: 369.216, r: 88.236, gradientTransform: "matrix(.7219 .9129 .8252 -.7986 43.942 -21.996)", gradientUnits: "userSpaceOnUse" },
            React__namespace.createElement("stop", { offset: 0, style: {
                    stopColor: "#4f3890",
                } }),
            React__namespace.createElement("stop", { offset: 0.963, style: {
                    stopColor: "#0e142a",
                } })),
        React__namespace.createElement("path", { style: {
                opacity: 0.25,
                fill: "url(#SVGID_00000012459389985504216790000015608132756254050968_)",
            }, d: "M1126.4 744.4c-2.5 4.6-13.3 2.4-24-4.8-10.8-7.3-17.4-16.8-14.9-21.4 2.5-4.6 13.3-2.4 24 4.8 10.8 7.2 17.4 16.8 14.9 21.4z" }),
        React__namespace.createElement("radialGradient", { id: "SVGID_00000066490071268081272650000004431875575668924840_", cx: 833.741, cy: 211.631, r: 37.452, gradientTransform: "matrix(.9912 .5184 .4686 -1.0966 -33.813 416.507)", gradientUnits: "userSpaceOnUse" },
            React__namespace.createElement("stop", { offset: 0, style: {
                    stopColor: "#4f3890",
                } }),
            React__namespace.createElement("stop", { offset: 0.963, style: {
                    stopColor: "#0e142a",
                } })),
        React__namespace.createElement("path", { style: {
                opacity: 0.25,
                fill: "url(#SVGID_00000066490071268081272650000004431875575668924840_)",
            }, d: "M894.8 642.3c-.3 2.3-4.8 3.4-10.1 2.6-5.3-.8-9.4-3.3-9.1-5.5.3-2.3 4.8-3.4 10.1-2.6 5.4.7 9.4 3.2 9.1 5.5z" }),
        React__namespace.createElement("radialGradient", { id: "SVGID_00000152953804587624452770000008585644769946580368_", cx: 903.222, cy: 174.65, r: 37.452, gradientTransform: "matrix(.9912 .5184 .4686 -1.0966 -33.813 416.507)", gradientUnits: "userSpaceOnUse" },
            React__namespace.createElement("stop", { offset: 0, style: {
                    stopColor: "#4f3890",
                } }),
            React__namespace.createElement("stop", { offset: 0.963, style: {
                    stopColor: "#0e142a",
                } })),
        React__namespace.createElement("path", { style: {
                opacity: 0.25,
                fill: "url(#SVGID_00000152953804587624452770000008585644769946580368_)",
            }, d: "M946.4 718.8c-.3 2.3-4.8 3.4-10.1 2.6-5.3-.8-9.4-3.3-9.1-5.5.3-2.3 4.8-3.4 10.1-2.6 5.3.8 9.4 3.3 9.1 5.5z" }),
        React__namespace.createElement("radialGradient", { id: "SVGID_00000177477918831526342990000007100394690213553575_", cx: 926.636, cy: 232.036, r: 37.452, gradientTransform: "matrix(.9912 .5184 .4686 -1.0966 -33.813 416.507)", gradientUnits: "userSpaceOnUse" },
            React__namespace.createElement("stop", { offset: 0, style: {
                    stopColor: "#4f3890",
                } }),
            React__namespace.createElement("stop", { offset: 0.963, style: {
                    stopColor: "#0e142a",
                } })),
        React__namespace.createElement("path", { style: {
                opacity: 0.25,
                fill: "url(#SVGID_00000177477918831526342990000007100394690213553575_)",
            }, d: "M996.5 668.1c-.3 2.3-4.8 3.4-10.1 2.6-5.3-.8-9.4-3.3-9.1-5.5.3-2.3 4.8-3.4 10.1-2.6 5.3.7 9.4 3.2 9.1 5.5z" }),
        React__namespace.createElement("radialGradient", { id: "SVGID_00000079484531858414804730000001691310727538566077_", cx: 1033.248, cy: 248.673, r: 37.453, gradientTransform: "matrix(.8498 .7664 .6928 -.9402 -9.136 163.474)", gradientUnits: "userSpaceOnUse" },
            React__namespace.createElement("stop", { offset: 0, style: {
                    stopColor: "#4f3890",
                } }),
            React__namespace.createElement("stop", { offset: 0.963, style: {
                    stopColor: "#0e142a",
                } })),
        React__namespace.createElement("path", { style: {
                opacity: 0.25,
                fill: "url(#SVGID_00000079484531858414804730000001691310727538566077_)",
            }, d: "M1038.7 747.2c-.8 2.1-5.4 2.1-10.4-.1s-8.4-5.7-7.6-7.8c.8-2.1 5.4-2.1 10.4.1 4.9 2.2 8.3 5.7 7.6 7.8z" }),
        React__namespace.createElement("radialGradient", { id: "SVGID_00000033368628048554865450000006372032000218687671_", cx: 974.207, cy: 268.853, r: 60.105, gradientTransform: "matrix(.9237 .6534 .5906 -1.0219 -31.18 283.19)", gradientUnits: "userSpaceOnUse" },
            React__namespace.createElement("stop", { offset: 0, style: {
                    stopColor: "#4f3890",
                } }),
            React__namespace.createElement("stop", { offset: 0.963, style: {
                    stopColor: "#0e142a",
                } })),
        React__namespace.createElement("path", { style: {
                opacity: 0.25,
                fill: "url(#SVGID_00000033368628048554865450000006372032000218687671_)",
            }, d: "M1027.6 686.5c-.9 3.5-8.3 4.4-16.6 1.9s-14.3-7.3-13.4-10.9c.9-3.5 8.3-4.4 16.6-1.9 8.3 2.5 14.3 7.4 13.4 10.9z" }),
        React__namespace.createElement("radialGradient", { id: "SVGID_00000105426084816881093400000018263051566757168776_", cx: 843.256, cy: 159.889, r: 60.105, gradientTransform: "matrix(.9805 .5426 .4904 -1.0848 -36.461 384.9)", gradientUnits: "userSpaceOnUse" },
            React__namespace.createElement("stop", { offset: 0, style: {
                    stopColor: "#4f3890",
                } }),
            React__namespace.createElement("stop", { offset: 0.963, style: {
                    stopColor: "#0e142a",
                } })),
        React__namespace.createElement("path", { style: {
                opacity: 0.25,
                fill: "url(#SVGID_00000105426084816881093400000018263051566757168776_)",
            }, d: "M872.8 710.2c-.5 3.6-7.8 5.3-16.3 3.8s-14.9-5.6-14.4-9.3c.5-3.6 7.8-5.3 16.3-3.8 8.5 1.6 15 5.7 14.4 9.3z" }),
        React__namespace.createElement("radialGradient", { id: "SVGID_00000006690876902530028900000005773957115868993156_", cx: 414.985, cy: 142.856, r: 54.143, gradientTransform: "matrix(1.0948 .065 .0587 -1.2112 52.05 779.1)", gradientUnits: "userSpaceOnUse" },
            React__namespace.createElement("stop", { offset: 0, style: {
                    stopColor: "#4f3890",
                } }),
            React__namespace.createElement("stop", { offset: 0.963, style: {
                    stopColor: "#0e142a",
                } })),
        React__namespace.createElement("path", { style: {
                opacity: 0.25,
                fill: "url(#SVGID_00000006690876902530028900000005773957115868993156_)",
            }, d: "M531.5 665.5c.7 3.2-4.7 7.5-12.2 9.6s-14.1 1.3-14.9-1.9c-.7-3.2 4.7-7.5 12.2-9.6 7.5-2.2 14.2-1.3 14.9 1.9z" }),
        React__namespace.createElement("radialGradient", { id: "SVGID_00000013891583951417404090000007418736701814529959_", cx: 410.625, cy: 92.688, r: 54.143, gradientTransform: "matrix(1.0948 .065 .0587 -1.2112 52.05 779.1)", gradientUnits: "userSpaceOnUse" },
            React__namespace.createElement("stop", { offset: 0, style: {
                    stopColor: "#4f3890",
                } }),
            React__namespace.createElement("stop", { offset: 0.963, style: {
                    stopColor: "#0e142a",
                } })),
        React__namespace.createElement("path", { style: {
                opacity: 0.25,
                fill: "url(#SVGID_00000013891583951417404090000007418736701814529959_)",
            }, d: "M523.8 726c.7 3.2-4.7 7.5-12.2 9.6s-14.1 1.3-14.9-1.9c-.7-3.2 4.7-7.5 12.2-9.6 7.5-2.2 14.2-1.3 14.9 1.9z" }),
        React__namespace.createElement("radialGradient", { id: "SVGID_00000089539753600869935890000017149102854941473923_", cx: 430.296, cy: 95.839, r: 33.728, gradientTransform: "matrix(1.0948 .065 .0587 -1.2112 52.05 779.1)", gradientUnits: "userSpaceOnUse" },
            React__namespace.createElement("stop", { offset: 0, style: {
                    stopColor: "#4f3890",
                } }),
            React__namespace.createElement("stop", { offset: 0.963, style: {
                    stopColor: "#0e142a",
                } })),
        React__namespace.createElement("path", { style: {
                opacity: 0.25,
                fill: "url(#SVGID_00000089539753600869935890000017149102854941473923_)",
            }, d: "M539.2 711.2c.5 2-2.9 4.7-7.6 6-4.7 1.3-8.8.8-9.3-1.2s2.9-4.7 7.6-6 8.8-.8 9.3 1.2z" }),
        React__namespace.createElement("radialGradient", { id: "SVGID_00000082358671611318975050000003205784293278322618_", cx: 384.901, cy: 159.225, r: 33.728, gradientTransform: "matrix(1.0948 .065 .0587 -1.2112 52.05 779.1)", gradientUnits: "userSpaceOnUse" },
            React__namespace.createElement("stop", { offset: 0, style: {
                    stopColor: "#4f3890",
                } }),
            React__namespace.createElement("stop", { offset: 0.963, style: {
                    stopColor: "#0e142a",
                } })),
        React__namespace.createElement("path", { style: {
                opacity: 0.25,
                fill: "url(#SVGID_00000082358671611318975050000003205784293278322618_)",
            }, d: "M493.2 631.5c.5 2-2.9 4.7-7.6 6s-8.8.8-9.3-1.2 2.9-4.7 7.6-6c4.7-1.3 8.9-.8 9.3 1.2z" }),
        React__namespace.createElement("radialGradient", { id: "SVGID_00000142161171015888505940000018115866701766163340_", cx: 334.664, cy: 90.707, r: 33.728, gradientTransform: "matrix(1.0948 .065 .0587 -1.2112 52.05 779.1)", gradientUnits: "userSpaceOnUse" },
            React__namespace.createElement("stop", { offset: 0, style: {
                    stopColor: "#4f3890",
                } }),
            React__namespace.createElement("stop", { offset: 0.963, style: {
                    stopColor: "#0e142a",
                } })),
        React__namespace.createElement("path", { style: {
                opacity: 0.25,
                fill: "url(#SVGID_00000142161171015888505940000018115866701766163340_)",
            }, d: "M434.2 711.2c.5 2-2.9 4.7-7.6 6s-8.8.8-9.3-1.2 2.9-4.7 7.6-6c4.7-1.3 8.8-.8 9.3 1.2z" }),
        React__namespace.createElement("radialGradient", { id: "SVGID_00000099623359635220629810000000111135871671891117_", cx: 450.928, cy: 174.767, r: 88.24, gradientTransform: "matrix(1.0963 0 0 -1.2129 72.176 817.967)", gradientUnits: "userSpaceOnUse" },
            React__namespace.createElement("stop", { offset: 0, style: {
                    stopColor: "#4f3890",
                } }),
            React__namespace.createElement("stop", { offset: 0.963, style: {
                    stopColor: "#0e142a",
                } })),
        React__namespace.createElement("path", { style: {
                opacity: 0.25,
                fill: "url(#SVGID_00000099623359635220629810000000111135871671891117_)",
            }, d: "M596.4 657.2c1.5 5.1-7.1 12.6-19.1 16.8s-22.9 3.4-24.4-1.7 7.1-12.6 19.1-16.8 23-3.5 24.4 1.7z" }),
        React__namespace.createElement("radialGradient", { id: "SVGID_00000108311035143951100880000007737766927235913896_", cx: 495.782, cy: 160.651, r: 33.728, gradientTransform: "matrix(1.0948 .065 .0587 -1.2112 52.05 779.1)", gradientUnits: "userSpaceOnUse" },
            React__namespace.createElement("stop", { offset: 0, style: {
                    stopColor: "#4f3890",
                } }),
            React__namespace.createElement("stop", { offset: 0.963, style: {
                    stopColor: "#0e142a",
                } })),
        React__namespace.createElement("path", { style: {
                opacity: 0.25,
                fill: "url(#SVGID_00000108311035143951100880000007737766927235913896_)",
            }, d: "M614.7 637c.5 2-2.9 4.7-7.6 6-4.7 1.3-8.8.8-9.3-1.2s2.9-4.7 7.6-6c4.7-1.4 8.8-.8 9.3 1.2z" }),
        React__namespace.createElement("radialGradient", { id: "SVGID_00000117658790245036507740000014700606710697835175_", cx: 334.8, cy: 143.73, r: 33.728, gradientTransform: "matrix(1.0948 .065 .0587 -1.2112 52.05 779.1)", gradientUnits: "userSpaceOnUse" },
            React__namespace.createElement("stop", { offset: 0, style: {
                    stopColor: "#4f3890",
                } }),
            React__namespace.createElement("stop", { offset: 0.963, style: {
                    stopColor: "#0e142a",
                } })),
        React__namespace.createElement("path", { style: {
                opacity: 0.25,
                fill: "url(#SVGID_00000117658790245036507740000014700606710697835175_)",
            }, d: "M437.5 647c.5 2-2.9 4.7-7.6 6s-8.8.8-9.3-1.2 2.9-4.7 7.6-6c4.7-1.3 8.8-.8 9.3 1.2z" })),
    React__namespace.createElement("g", { style: {
            opacity: 0.45,
        } },
        React__namespace.createElement("path", { className: "st30", d: "M66.5 208.1c-21.4 6.4-33.6 28.9-27.3 50.3 6.4 21.4 28.9 33.6 50.3 27.3 21.4-6.4 33.6-28.9 27.3-50.3-6.4-21.4-28.9-33.6-50.3-27.3z" }),
        React__namespace.createElement("path", { className: "st30", d: "M111.5 239.5c0 21.3-17.2 38.5-38.5 38.5-14.7 0-27.5-8.3-34-20.4 4.7 17.2 20.4 29.8 39 29.8 22.3 0 40.5-18.1 40.5-40.5 0-13.2-6.3-24.9-16.1-32.3 5.6 6.7 9.1 15.4 9.1 24.9z" }),
        React__namespace.createElement("path", { className: "st31", d: "M38.7 237.3c4.6-1.3 10.8-3.2 15.4-4.8 8.2-2.8 12.4-8.2 17.8-9.9 3.9-1.3 20.5-6 29.5-8.5 4.5 3.2 8.3 7.3 11.2 12.1-8.1 5.1-27.2 15.6-32 17.2-6 2-28.9 7.9-30.3 7.6-.8-.1-7.5.4-12.7-1.2-.2-4.4.1-8.6 1.1-12.5zM41.7 264.9c11.8-3.6 30.1-9 34.4-9.7 6.4-1.1 20.5-.9 30.7-4 4-1.2 8.2-2.9 11.6-4.5 0 4.4-.7 8.8-2.1 12.9-7.7 2.6-21.8 7.1-28.1 7.5-5.9.4-23.9 6.8-35.7 11.3-4.4-3.6-8.1-8.2-10.8-13.5z" }),
        React__namespace.createElement("path", { className: "st31", d: "m41.7 264.9 1.8-.5c4.3 5.1 9.9 9 16.3 11.4-2.5.9-5 1.8-7.2 2.7-4-3.2-7.3-7.2-9.9-11.6l-.1-.1c-.1-.1-.2-.3-.2-.4-.2-.6-.4-1.1-.7-1.5zm68.3-14.7c3-1.1 5.9-2.3 8.5-3.5v.2c0 2.4-.2 4.8-.6 7.1v.2c0 .2-.1.4-.1.6-.3 1.6-.8 3.3-1.3 4.9-3.6 1.2-8.7 2.9-13.7 4.3 3.2-4.1 5.7-8.7 7.2-13.8z" }),
        React__namespace.createElement("path", { className: "st32", d: "M37.6 246.9s15.3-4.8 20.5-6.5c5.3-1.7 9.1-9.2 15.2-11.6 5.3-2.1 20.9-7 33.1-10.8 2.6 2.5 4.8 5.4 6.6 8.5l-15.8 9.6-59.3 15.8c0-.2 0-.4-.1-.5-.1-.8-.2-1.6-.2-2.4v-2.1z" }),
        React__namespace.createElement("path", { className: "st33", d: "M47.2 273.1c7.6-2.8 23.8-8.6 27.1-9.6 4.3-1.4 13 4 23.4-.1 6.3-2.5 14.3-6.1 19.9-8.7-.4 2.2-1.1 4.4-1.8 6.5L64 284.9c-6.5-2.4-12.3-6.5-16.8-11.8z" }),
        React__namespace.createElement("path", { className: "st33", d: "m47.2 273.1 4.4-1.6c6.1 4.1 13.4 6.5 21.3 6.5 2.7 0 5.4-.3 7.9-.8L64 284.9c-6.5-2.4-12.3-6.5-16.8-11.8zm58.2-12.8c4.4-1.9 8.8-3.9 12.3-5.5-.4 2.2-1.1 4.4-1.8 6.5l-19.6 9c3.6-2.9 6.6-6.2 9.1-10z" }),
        React__namespace.createElement("path", { className: "st32", d: "M54.8 280c3.3-1.5 20.1-8.9 23.7-10.3 4-1.6 10.2 1.6 18.4-1.9 5-2.1 13.8-6.2 19.8-9.1-4.6 15-17.7 26.5-34.2 28.4-10.2 1.1-19.9-1.6-27.7-7.1z" }),
        React__namespace.createElement("path", { className: "st32", d: "M54.8 280c1.2-.5 4.3-1.9 7.8-3.5 3.3.9 6.7 1.4 10.3 1.4 10.9 0 20.8-4.6 27.8-11.9 4.9-2.2 11.2-5.1 15.9-7.3-4.4 14.3-16.5 25.3-31.5 28-2.3.4-4.7.6-7.1.6-2.6 0-5.2-.2-7.7-.7h-.1c-.2 0-.4-.1-.7-.1l-.4-.1-.2-.1c-5-1.1-9.8-3.3-14.1-6.3z" }),
        React__namespace.createElement("path", { className: "st31", d: "M114.4 264.5c-5.1 2.7-18.8 10-20.9 11.2-2.6 1.4-8.2.2-15.9 4.4-3 1.6-6.4 3.9-9.5 6.1-3.3-.8-6.4-2.1-9.4-3.7 6.6-3.4 16.1-8.3 18.6-9.4 4-1.8 10.8.7 15.2-1.3l23.3-10.7c-.4 1.2-.8 2.3-1.4 3.4z" }),
        React__namespace.createElement("path", { className: "st33", d: "M114.4 264.5c-5.1 2.7-18.8 10-20.9 11.1-2.6 1.4-8.2.2-15.9 4.4-3 1.6-6.4 3.9-9.5 6.1-3.3-.8-6.4-2.1-9.4-3.7 2.8-1.5 6.2-3.2 9.3-4.8 1.6.2 3.2.3 4.9.3 8.8 0 16.8-2.9 23.3-7.9l19.6-9c-.4 1.3-.9 2.4-1.4 3.5z" }),
        React__namespace.createElement("path", { className: "st32", d: "M40.7 262.5c7.7-2.6 24.6-8.3 31.2-9.9 8.8-2.2 21.9 1 32.8-2 5-1.4 9.9-3.6 13.7-5.6 0 .8.1 1.6 0 2.4-5.3 2.9-13 6.8-19.4 8.2-10.8 2.3-14.5-2.3-31.8 5-8.1 3.4-16 7-22.1 9.8-1.8-2.4-3.2-5.1-4.4-7.9z" }),
        React__namespace.createElement("path", { className: "st32", d: "m40.7 262.5 1.1-.4c1.9 2.5 4 4.9 6.4 6.9-1.1.5-2.1 1-3.1 1.4-1.8-2.4-3.2-5.1-4.4-7.9zm69.7-13.8c2.9-1.2 5.7-2.5 8-3.7v2.5c-2.6 1.4-5.7 3.1-9 4.6.4-1.2.7-2.3 1-3.4z" }),
        React__namespace.createElement("path", { className: "st33", d: "M41.6 229.3c6-1.8 13.2-4 15.9-5 4.9-1.8 6.5-5.9 12.3-7.5 4-1.1 17.4-4.5 25.4-6.5-1.7-.8-3.5-1.5-5.4-2.1-7.7 1.8-19.8 4.6-25.5 5.9-4.4 1-7.9.7-10.3.1-5.2 4-9.5 9.2-12.4 15.1zM37.6 249c8.7-2.4 21.4-6 26.3-7.8 7.8-2.9 7.2-7.7 12.4-9.6 5.2-1.9 4.8-1.8 7.1-2.4 2.3-.7 7.5 4.3 12.8 2.3 5.2-2 3.5-6 7.2-7.7 1.8-.8 4.1-1.8 5.9-2.6 2.6 3.2 4.7 6.7 6.3 10.6l-76.8 25.1c-.5-1.8-.8-3.6-1-5.5-.1-.8-.1-1.6-.2-2.4z" }),
        React__namespace.createElement("path", { className: "st33", d: "m107.3 222.1 1.9-.9c2.6 3.2 4.7 6.7 6.3 10.6l-4.6 1.5c-.6-3.9-1.8-7.7-3.6-11.2z" }),
        React__namespace.createElement("g", { style: {
                opacity: 0.33,
            } },
            React__namespace.createElement("path", { d: "M47.5 238.2c-.5 1.6-2.1 2.5-3.7 2s-2.5-2.1-2-3.7c1.5-5 4-9.6 7.3-13.5 3.3-4 7.4-7.3 12.1-9.8 1.5-.8 3.3-.2 4 1.3.8 1.5.2 3.3-1.3 4-3.9 2.1-7.4 4.9-10.3 8.3-2.8 3.4-4.9 7.2-6.1 11.4zM72 215.5c-1.6.4-3.2-.7-3.6-2.3s.7-3.2 2.3-3.6c.8-.2 1.6-.3 2.5-.5.8-.1 1.7-.2 2.5-.3 1.6-.1 3.1 1.1 3.2 2.7.1 1.6-1.1 3.1-2.7 3.2l-2.1.3c-.6.2-1.3.4-2.1.5z", style: {
                    fill: "#fff",
                } })),
        React__namespace.createElement("path", { className: "st32", d: "M91.4 245.7c3.3 0 6-2.7 6-6s-2.7-6-6-6-6 2.7-6 6 2.7 6 6 6z" }),
        React__namespace.createElement("path", { className: "st31", d: "M84.4 248.5c1.3 0 2.3-1 2.3-2.3s-1-2.3-2.3-2.3-2.3 1-2.3 2.3c0 1.2 1.1 2.3 2.3 2.3z" }),
        React__namespace.createElement("path", { className: "st32", d: "M100.6 240.9c.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3 0 .7.6 1.3 1.3 1.3z" }),
        React__namespace.createElement("path", { className: "st31", d: "M91.4 242.7c1.7 0 3.1-1.4 3.1-3.1s-1.4-3.1-3.1-3.1-3.1 1.4-3.1 3.1 1.4 3.1 3.1 3.1zM85 239.8c.8 0 1.5-.7 1.5-1.5s-.7-1.5-1.5-1.5-1.5.7-1.5 1.5c0 .9.7 1.5 1.5 1.5zM95.5 236.3c.6 0 1.1-.5 1.1-1.1s-.5-1.1-1.1-1.1-1.1.5-1.1 1.1.5 1.1 1.1 1.1z" }),
        React__namespace.createElement("path", { className: "st33", d: "M86.2 267.6c2.4 0 4.4-2 4.4-4.4s-2-4.4-4.4-4.4-4.4 2-4.4 4.4c0 2.4 1.9 4.4 4.4 4.4z" }),
        React__namespace.createElement("path", { className: "st31", d: "M94.7 262.8c1 0 1.9-.8 1.9-1.9 0-1-.8-1.9-1.9-1.9-1 0-1.9.8-1.9 1.9 0 1.1.9 1.9 1.9 1.9z" }),
        React__namespace.createElement("path", { className: "st33", d: "M68.2 269.9c2.2 0 3.9-1.8 3.9-3.9 0-2.2-1.8-3.9-3.9-3.9-2.2 0-3.9 1.8-3.9 3.9 0 2.1 1.8 3.9 3.9 3.9z" }),
        React__namespace.createElement("path", { className: "st32", d: "M73.4 256.1c2.2 0 3.9-1.8 3.9-3.9 0-2.2-1.8-3.9-3.9-3.9-2.2 0-3.9 1.8-3.9 3.9-.1 2.2 1.7 3.9 3.9 3.9zM66.3 252.1c.5 0 1-.4 1-1 0-.5-.4-1-1-1-.5 0-1 .4-1 1s.4 1 1 1zM79.1 251c.5 0 1-.4 1-1s-.4-1-1-1c-.5 0-1 .4-1 1s.5 1 1 1zM92.2 226.7c2.5 0 4.5-2 4.5-4.5s-2-4.5-4.5-4.5-4.5 2-4.5 4.5 2 4.5 4.5 4.5z" }),
        React__namespace.createElement("path", { className: "st31", d: "M92.2 224.6c1.3 0 2.4-1.1 2.4-2.4s-1.1-2.4-2.4-2.4-2.4 1.1-2.4 2.4 1.1 2.4 2.4 2.4zM89.2 228.1c.7 0 1.2-.6 1.2-1.2 0-.7-.6-1.2-1.2-1.2-.7 0-1.2.6-1.2 1.2-.1.7.5 1.2 1.2 1.2zM96.9 224c.3 0 .6-.3.6-.6s-.3-.6-.6-.6-.6.3-.6.6.2.6.6.6z" }),
        React__namespace.createElement("path", { className: "st32", d: "M98.9 221.7c.9 0 1.6-.7 1.6-1.6 0-.9-.7-1.6-1.6-1.6s-1.6.7-1.6 1.6.7 1.6 1.6 1.6zM85.7 223.4c.5 0 .9-.4.9-.9s-.4-.9-.9-.9-.9.4-.9.9.4.9.9.9z" })),
    React__namespace.createElement("g", { style: {
            opacity: 0.92,
        } },
        React__namespace.createElement("path", { style: {
                fill: "none",
            }, d: "M-1674-9647.7h1366v768h-1366z", transform: "translate(1674 9648)", id: "Rectangle_4334_00000032643912514155916650000007732714211228329642_" })))); };

var BlurredEllipse = function (_a) {
    var className = _a.className;
    return (React__default["default"].createElement("svg", { id: "background_blurred_ellipse", width: "1366", height: "768", viewBox: "0 0 1366 768", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: className },
        React__default["default"].createElement("g", { clipPath: "url(#clip0_790_22909)" },
            React__default["default"].createElement("g", { filter: "url(#filter0_f_790_22909)" },
                React__default["default"].createElement("ellipse", { cx: "683", cy: "1067", rx: "833", ry: "405", fill: "#262262" }))),
        React__default["default"].createElement("defs", null,
            React__default["default"].createElement("filter", { id: "filter0_f_790_22909", x: "-350", y: "462", width: "2066", height: "1210", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" },
                React__default["default"].createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
                React__default["default"].createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "BackgroundImageFix", result: "shape" }),
                React__default["default"].createElement("feGaussianBlur", { stdDeviation: "100", result: "effect1_foregroundBlur_790_22909" })),
            React__default["default"].createElement("clipPath", { id: "clip0_790_22909" },
                React__default["default"].createElement("rect", { width: "1366", height: "768", fill: "white" })))));
};

var LoadingFull = function (props) {
    var children = props.children, _a = props.disableDecorations, disableDecorations = _a === void 0 ? false : _a;
    var _b = React.useState('unset'), height = _b[0], setHeight = _b[1];
    React.useEffect(function () {
        setBgHeight();
        window.addEventListener('resize', setBgHeight);
        return function () {
            window.removeEventListener('resize', setBgHeight);
        };
    }, []);
    function setBgHeight() {
        var element = document.getElementById('outer-loading-full');
        if (element) {
            var width = element.offsetWidth;
            var height_1 = element.offsetHeight;
            setHeight(width / height_1 < 16 / 9 ? '100%' : 'unset');
        }
    }
    return (React__default["default"].createElement("div", { className: 'w-full h-full fixed z-[9999] left-0 top-0 bg-primary-navyblue-dark overflow-hidden', id: 'outer-loading-full' },
        disableDecorations === false && (React__default["default"].createElement(BackgroundVariation, { className: 'absolute min-w-full min-h-full left-1/2 top-1/2 -translate-y-1/2 -translate-x-1/2', style: { height: height } })),
        React__default["default"].createElement("div", { className: 'absolute left-1/2 top-1/2 -translate-y-1/2 -translate-x-1/2 w-full px-4' },
            React__default["default"].createElement("div", null,
                disableDecorations === false && (React__default["default"].createElement(Lottie__default["default"], { className: 'mx-auto max-w-[275px] max-h-[125px] mb-3', animationData: loadingRocket, loop: true })),
                children)),
        disableDecorations === true && (React__default["default"].createElement(BlurredEllipse, { className: "absolute bottom-0 left-1/2 -translate-x-1/2" }))));
};

var Switch = React.forwardRef(function (props, forwardRef) {
    return (React__default["default"].createElement("label", { className: "".concat(!props.disabled && 'cursor-pointer') },
        React__default["default"].createElement("input", __assign({ type: "checkbox", className: "hidden", ref: forwardRef }, props)),
        React__default["default"].createElement("div", { className: "w-10 h-6 p-1 rounded-full ".concat(props.checked ? 'bg-primary-apricot' : 'bg-neutral-eraser') },
            React__default["default"].createElement("div", { className: "h-4 w-4 p-0.5 shadow-sm rounded-full transition-all duration-300 text-white ".concat(props.checked && 'translate-x-4', " ").concat(props.disabled ? 'bg-neutral-notebook' : 'bg-white') }))));
});

var injectClassNames = function (as) {
    if (as === void 0) { as = 'div'; }
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    return function (strings) {
        var Element = function (_a) {
            var className = _a.className, children = _a.children, props = __rest(_a, ["className", "children"]);
            return React__default["default"].createElement(as, __assign({ className: "".concat(className !== null && className !== void 0 ? className : '').concat(strings ? " ".concat(strings) : "") }, props), children);
        };
        Element.displayName = "".concat(as);
        return Element;
    };
};

var StyledTopBar = injectClassNames('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["fixed top-0 left-0 h-16 right-0 shadow-md px-3 flex items-center border-b border-primary-500"], ["fixed top-0 left-0 h-16 right-0 shadow-md px-3 flex items-center border-b border-primary-500"])));
var TopBar = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React__default["default"].createElement(StyledTopBar, __assign({}, props), children));
};
var templateObject_1;

var CaretRight = function (props) { return (React__namespace.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 256 512" }, props),
    React__namespace.createElement("path", { d: "M246.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6l0 256c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l128-128z" }))); };

var CaretLeft = function (props) { return (React__namespace.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 256 512" }, props),
    React__namespace.createElement("path", { d: "M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 256c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-128-128z" }))); };

var sortData = function (data, field, order) {
    if (order === void 0) { order = 'asc'; }
    var sortedData = __spreadArray([], data.sort(function (currentRow, nextRow) {
        return typeof currentRow[field] === 'number'
            ? currentRow[field] - nextRow[field]
            : "".concat(currentRow[field]).localeCompare(nextRow[field]);
    }), true);
    return order === 'asc' ? sortedData : sortedData.reverse();
};
var useTableState = function (_a) {
    var data = _a.data, initialSort = _a.initialSort;
    var _b = React__default["default"].useState({
        data: data,
        sort: initialSort,
    }), state = _b[0], setState = _b[1];
    var onSort = function (field, order) {
        setState({
            data: sortData(data, field, order),
            sort: {
                field: field,
                order: order,
            },
        });
    };
    React__default["default"].useEffect(function () {
        var _a, _b;
        setState(__assign(__assign({}, state), { data: ((_a = state.sort) === null || _a === void 0 ? void 0 : _a.field)
                ? sortData(data, state.sort.field, (_b = state.sort) === null || _b === void 0 ? void 0 : _b.order)
                : data }));
    }, [data]);
    return __assign(__assign({}, state), { onSort: onSort });
};

var flickityOptions = {
    initialIndex: 0,
    pauseAutoPlayOnHover: false,
    draggable: false,
    prevNextButtons: false,
    autoPlay: false,
};
var sliderContentStyle = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
};
var PopUpSlider = function (_a) {
    var data = _a.data, onClose = _a.onClose, disableBodyScroll = _a.disableBodyScroll, popupContainerClassnames = _a.popupContainerClassnames, _b = _a.showButton, showButton = _b === void 0 ? true : _b, lastNextButton = _a.lastNextButton, sliderOptions = _a.sliderOptions, onMount = _a.onMount;
    var _c = React.useState(), flickity = _c[0], setFlickity = _c[1];
    var _d = React.useState(0), selectedIndex = _d[0], setSelectedIndex = _d[1];
    var handleNext = function () {
        flickity === null || flickity === void 0 ? void 0 : flickity.next();
    };
    var handlePrevious = function () {
        flickity === null || flickity === void 0 ? void 0 : flickity.previous();
    };
    var changeSelectedIndex = function (index) {
        setSelectedIndex(index);
    };
    React.useEffect(function () {
        flickity === null || flickity === void 0 ? void 0 : flickity.on('change', changeSelectedIndex);
        setTimeout(function () {
            flickity === null || flickity === void 0 ? void 0 : flickity.resize();
        }, 250);
        if (onMount && flickity)
            onMount(flickity);
        return function () {
            flickity === null || flickity === void 0 ? void 0 : flickity.off('change', changeSelectedIndex);
        };
    }, [flickity]);
    return (React__default["default"].createElement(Scrim, { onClose: onClose, disableBodyScroll: disableBodyScroll },
        React__default["default"].createElement("div", { className: "slider-popup-container px-12 pt-12 pb-8 rounded-2xl w-11/12 text-center fixed top-1/2 left-1/2 transform -translate-y-1/2 -translate-x-1/2 bg-white overflow-hidden max-w-[560px] min-w-[286px] max-h-[96vh] shadow ".concat(popupContainerClassnames) },
            React__default["default"].createElement(React.Suspense, { fallback: React__default["default"].createElement(React__default["default"].Fragment, null, "Loading...") },
                React__default["default"].createElement(Flickity__default["default"], { className: "carousel", elementType: "div", flickityRef: function (c) { return setFlickity(c); }, options: __assign(__assign({}, flickityOptions), sliderOptions) }, data.map(function (child) {
                    return (React__default["default"].createElement("div", { style: child.style ? child.style : sliderContentStyle }, child.content));
                }))),
            showButton && (React__default["default"].createElement("div", { className: "mt-3" },
                React__default["default"].createElement("div", { className: 'w-full' },
                    lastNextButton && selectedIndex == data.length - 1 ? (React__default["default"].createElement(Button, { variant: "primary", onClick: lastNextButton.onClick, className: "w-full", style: { maxWidth: 'unset' } }, lastNextButton.label)) : (React__default["default"].createElement(Button, { variant: "primary", onClick: handleNext, className: "w-full", style: { maxWidth: 'unset' }, disabled: selectedIndex == data.length - 1 }, "Next")),
                    React__default["default"].createElement(Button, { variant: "secondary", onClick: handlePrevious, disabled: selectedIndex == 0, className: "w-full", style: { maxWidth: 'unset' } }, "Back")))))));
};

var GCS_BASE_URL = 'https://storage.googleapis.com/geniebook-cdn';

var MAXIMUM_SHOWED_SUBTOPIC_NAME = 2;
var MAXIMUM_TOPIC_NAME_LENGTH = 30;
var FailedGenerateWorksheetPopup = function (_a) {
    var subtopics = _a.subtopics, _b = _a.show, show = _b === void 0 ? false : _b, onConfirm = _a.onConfirm, onClose = _a.onClose, _c = _a.className, className = _c === void 0 ? '' : _c;
    var handlePrimaryButton = function () {
        if (onConfirm)
            onConfirm();
    };
    var dismissPopup = function () {
        if (onClose)
            onClose();
    };
    var getSubtopicsCopy = function () {
        var first_topic = subtopics[0].name.toLowerCase();
        var showMoreTopics = subtopics.length > MAXIMUM_SHOWED_SUBTOPIC_NAME &&
            first_topic.length <= MAXIMUM_TOPIC_NAME_LENGTH;
        var leftTopics = showMoreTopics
            ? subtopics.length - MAXIMUM_SHOWED_SUBTOPIC_NAME
            : subtopics.length - 1;
        var content = "<strong>".concat(apStyleTitleCase.apStyleTitleCase(first_topic), "</strong>");
        if (subtopics.length > 1) {
            if (subtopics.length === MAXIMUM_SHOWED_SUBTOPIC_NAME ||
                first_topic.length > MAXIMUM_TOPIC_NAME_LENGTH) {
                content += ' and ';
                content +=
                    first_topic.length > MAXIMUM_TOPIC_NAME_LENGTH
                        ? "".concat(leftTopics, " more!")
                        : "<strong>".concat(apStyleTitleCase.apStyleTitleCase(subtopics[1].name.toLowerCase()), "</strong>!");
            }
            else if (subtopics.length > MAXIMUM_SHOWED_SUBTOPIC_NAME) {
                content += "<strong>, ".concat(apStyleTitleCase.apStyleTitleCase(subtopics[1].name.toLowerCase()), "</strong> and ").concat(leftTopics, " more!");
            }
        }
        else
            content += '!';
        return DOMPurify__default["default"].sanitize(content);
    };
    return (React__default["default"].createElement(React__default["default"].Fragment, null, show && (React__default["default"].createElement(PopUp, { title: "Nice work", description: React__default["default"].createElement("div", { dangerouslySetInnerHTML: {
                __html: "Great job on practising ".concat(getSubtopicsCopy(), " It seems like you are\n                  ready to explore other topics and expand your knowledge. Are you\n                  ready?"),
            } }), buttonGroup: React__default["default"].createElement(React__default["default"].Fragment, null,
            React__default["default"].createElement("div", { className: 'w-full' },
                React__default["default"].createElement(Button, { className: 'w-full max-w-full', onClick: handlePrimaryButton }, "Try another worksheet")),
            onClose && (React__default["default"].createElement("div", { className: 'w-full -mb-4' },
                React__default["default"].createElement(Button, { variant: "secondary", className: 'w-full max-w-full', onClick: dismissPopup }, "Maybe later")))), onClose: dismissPopup, img: "".concat(GCS_BASE_URL, "/assets/images/Class2Smart/Failed_Create_Worksheet.svg"), imgFullwidth: true, width: "462px", className: "".concat(className) }))));
};

var v = "5.7.4";
var fr = 30;
var ip = 0;
var op = 30;
var w = 96;
var h = 60;
var nm = "Dots Loading";
var ddd = 0;
var assets = [
];
var layers = [
	{
		ddd: 0,
		ind: 1,
		ty: 4,
		nm: "Dot 4",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					111.203,
					50.69899999999999,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					0,
					0,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					93.75,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								16,
								16
							],
							ix: 2
						},
						p: {
							a: 1,
							k: [
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 9,
									s: [
										-4,
										0
									],
									to: [
										0,
										-2.667
									],
									ti: [
										0,
										0
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 15,
									s: [
										-4,
										-16
									],
									to: [
										0,
										0
									],
									ti: [
										0,
										-2.667
									]
								},
								{
									t: 21.0000008553475,
									s: [
										-4,
										0
									]
								}
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								-25.204,
								-18.699
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 330.000013441176,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 2,
		ty: 4,
		nm: "Dot 3",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					83.219,
					50.69899999999999,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					0,
					0,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					93.75,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								16,
								16
							],
							ix: 2
						},
						p: {
							a: 1,
							k: [
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 6,
									s: [
										0,
										0
									],
									to: [
										0,
										-2.667
									],
									ti: [
										0,
										0
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 12,
									s: [
										0,
										-16
									],
									to: [
										0,
										0
									],
									ti: [
										0,
										-2.667
									]
								},
								{
									t: 18.000000733155,
									s: [
										0,
										0
									]
								}
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								-25.204,
								-18.699
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 330.000013441176,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 3,
		ty: 4,
		nm: "Dot 2",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					58.233999999999995,
					50.69899999999999,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					0,
					0,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					93.75,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								16,
								16
							],
							ix: 2
						},
						p: {
							a: 1,
							k: [
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 3,
									s: [
										1,
										0
									],
									to: [
										0,
										-2.667
									],
									ti: [
										0,
										0
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 9,
									s: [
										1,
										-16
									],
									to: [
										0,
										0
									],
									ti: [
										0,
										-2.667
									]
								},
								{
									t: 15.0000006109625,
									s: [
										1,
										0
									]
								}
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								-25.204,
								-18.699
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 330.000013441176,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 4,
		ty: 4,
		nm: "Dot 1",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					31.25,
					50.69899999999999,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					0,
					0,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					93.75,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								16,
								16
							],
							ix: 2
						},
						p: {
							a: 1,
							k: [
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 0,
									s: [
										4,
										0
									],
									to: [
										0,
										-2.667
									],
									ti: [
										0,
										0
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 6,
									s: [
										4,
										-16
									],
									to: [
										0,
										0
									],
									ti: [
										0,
										-2.667
									]
								},
								{
									t: 12.00000048877,
									s: [
										4,
										0
									]
								}
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								-25.204,
								-18.699
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 330.000013441176,
		st: 0,
		bm: 0
	}
];
var markers = [
];
var fourDotsLoading = {
	v: v,
	fr: fr,
	ip: ip,
	op: op,
	w: w,
	h: h,
	nm: nm,
	ddd: ddd,
	assets: assets,
	layers: layers,
	markers: markers
};

var GenerateClass2SmartWorksheetPopup = function (_a) {
    var online_lesson_name = _a.online_lesson_name, _b = _a.show, show = _b === void 0 ? false : _b, onClose = _a.onClose, onCreateWorksheet = _a.onCreateWorksheet, _c = _a.isLoading, isLoading = _c === void 0 ? false : _c, loadingImage = _a.loadingImage, _d = _a.className, className = _d === void 0 ? '' : _d;
    var handleCreateWorksheet = function () {
        onClose();
        if (onCreateWorksheet)
            onCreateWorksheet();
    };
    var dismissPopup = function () {
        onClose();
    };
    var getLoadingComponent = function (loading) {
        if (typeof loading == 'string')
            return (React__default["default"].createElement("img", { src: loading, className: "m-auto" }));
        else
            return loading;
    };
    return (React__default["default"].createElement(React__default["default"].Fragment, null, show && (React__default["default"].createElement(PopUp, { title: "Test yourself", description: React__default["default"].createElement(React__default["default"].Fragment, null,
            React__default["default"].createElement("div", { className: "mb-2" },
                "Gauge your understanding of what you just learnt in",
                ' ',
                React__default["default"].createElement("b", null, online_lesson_name),
                "."),
            React__default["default"].createElement("div", null, "1 credit will be used to create this worksheet.")), buttonGroup: React__default["default"].createElement(React__default["default"].Fragment, null,
            React__default["default"].createElement("div", { className: 'w-full' },
                React__default["default"].createElement(Button, { className: 'w-full max-w-full', onClick: handleCreateWorksheet }, isLoading ? (loadingImage ?
                    getLoadingComponent(loadingImage) : React__default["default"].createElement(Lottie__default["default"], { id: "loading", animationData: fourDotsLoading, className: "m-auto h-[30px]" })) : "Create worksheet")),
            !isLoading && React__default["default"].createElement("div", { className: 'w-full -mb-4' },
                React__default["default"].createElement(Button, { variant: "secondary", className: 'w-full max-w-full', onClick: dismissPopup }, "Maybe later"))), onClose: dismissPopup, img: "".concat(GCS_BASE_URL, "/assets/images/Class2Smart/Create_Worksheet.svg"), imgFullwidth: true, width: "462px", className: "".concat(className) }))));
};

exports.Avatar = Avatar;
exports.Badge = Badge;
exports.Banner = Banner;
exports.Breadcrumb = Breadcrumb;
exports.Button = Button;
exports.Card = Card;
exports.CaretLeft = CaretLeft;
exports.CaretRight = CaretRight;
exports.Checkbox = Checkbox;
exports.Chips = Chips;
exports.Container = Container;
exports.ContainerScroll = ContainerScroll;
exports.DatePicker = DatePicker;
exports.DropdownFilter = DropdownFilter;
exports.Grid = Grid;
exports.Icon = Icon;
exports.Input = Input;
exports.Link = Link;
exports.Loader = Loader;
exports.LoadingFull = LoadingFull;
exports.LoadingScroll = LoadingScroll;
exports.Logo = Logo;
exports.Modal = Modal;
exports.PopUp = PopUp;
exports.PopUpFailedGenerateWorksheet = FailedGenerateWorksheetPopup;
exports.PopUpGenerateWorksheet = GenerateClass2SmartWorksheetPopup;
exports.PopUpSlider = PopUpSlider;
exports.ProgressBar = ProgressBar;
exports.Radio = Radio;
exports.Scrim = Scrim;
exports.Select = Select;
exports.Sheet = Sheet;
exports.Snackbar = Snackbar;
exports.Switch = Switch;
exports.Table = Table;
exports.Tooltip = Tooltip;
exports.TopBar = TopBar;
exports.useClickOutsideHandler = useClickOutsideHandler;
exports.useDebounce = useClickOutsideHandler;
exports.useTableState = useTableState;
//# sourceMappingURL=index.js.map
